// Add a cookie tfs_ce=true
function setCookie(name, value) {
    var expirationDate = new Date();

    // Expire à la fin de la journée en cours
    expirationDate.setHours(23, 59, 59, 999);

    var cookieValue = encodeURIComponent(value) + '; expires=' + expirationDate.toUTCString() + '; path=/';
    document.cookie = name + '=' + cookieValue;
}

setCookie('tfs_ce', 'true');

function addErrorMessage(field, message) {
    var errorMessage = $('<span class="error-message">' + message + '</span>');
    field.after(errorMessage);
}

function getCookieValue(cookieName) {
    var name = cookieName + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

function deleteCookie(name, path = '/') {
    document.cookie = name + '=; Path=' + path + '; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

var historyEventLogger = [];
var exceptionEventLogger = ['coupon_apply', 'checkout_payment_saved'];
function sendEventLogger(eventType, params = {}) {

    if(!exceptionEventLogger.includes(eventType) && historyEventLogger.includes(eventType)){
        return;
    }

    var jsonData = document.querySelector('script[elconf-json]').textContent;
    var parsedData = JSON.parse(jsonData);
    var elconf_data = parsedData.elconf_data;
    var elconf_event = parsedData.elconf_event;

    if(Object.keys(elconf_data).length == 0){
        return;
    }

    var details = {};
    if (Object.keys(params).length > 0) {
        details = params;
    }

    if(Object.keys(elconf_data).length > 0){
        details = {...details, ...elconf_data};
    }

    if(Object.keys(elconf_event).length > 0 && eventType in elconf_event){
        details = {...details, ...elconf_event[eventType]};
    }


    var dataToSend = {
        'event': eventType,
        'details': details
    };

    //get relative path with paramters if any
    var relative_uri = window.location.pathname + window.location.search;
    relative_uri ? dataToSend['details']['uri'] = relative_uri : '';

    // Sending data using Beacon API
    const url = "/el";
    const data = JSON.stringify(dataToSend);
    const success = navigator.sendBeacon(url, data);
    console.log(dataToSend);
    if (success) {
        console.log("Call request sent successfully.");
        historyEventLogger.push(eventType);
    } else {
        console.log("Failed to send call request.");
    }
 
    if (!navigator.sendBeacon) {
        fetch("/el", {
            method: "POST",
            body: JSON.stringify(dataToSend),
            headers: { "Content-Type": "application/json" },
            keepalive: true
        }).then(response => console.log("Fallback sent", response))
        .catch(error => console.error("Fallback failed", error));
    }
}

        
(function ($) {
    "use strict";

    if($('.m-hide').is(":visible")){
        $('.d-hide').remove();
    }else{
        $('.m-hide').remove();
    }

    var is_clicked_wishlist = false;

    $(function() {
        $('.lazy').Lazy( {
            combined: true,
            delay: 0,
        } );
        $('.lazy2').Lazy( {
            combined: true,
            delay: 100,
        } );
    });

    var oDict = JSON.parse(document.querySelector('[dict-json]').innerHTML);

    $('.mega-menu').show();
    
    window.addEventListener('popstate', function (event) {
        // Rechargez la page lorsque l'événement 'popstate' se déclenche (lorsque l'utilisateur fait "Retour" dans le navigateur)
        if($('.shop-area').length == 0){
            window.location.reload();
        }
    });

    if($('.video-background img').length > 0){
        // add style : style="width: 100%; height: 100%; object-fit: cover;"
        $('.video-background img').css('object-fit', 'cover');
        $('.video-background img').css('width', '100%');
        $('.video-background img').css('height', '100%');
        $('.video-background img').show();
        //take data-image and put it in src attribute
        $('.video-background img').attr('src', $('.video-background img').data('image'));
    }


    
    /*--------------------------
        Newsletter Popup
    ---------------------------*/
    setTimeout(function() {
        $('.popup-wrapper-area').css({
            "opacity": "1",
            "visibility": "visible"
        });
        $('.popup-off').on('click', function(e) {
            e.preventDefault();
            $(".popup-wrapper-area").fadeOut(500);
        })
    }, 1000);


    function animateParagraphs() {
        var maxWidth = 0;

        // Trouver la largeur maximale parmi tous les span
        $('.custom-container p span').each(function() {
            var currentWidth = $(this).width();
            if (currentWidth > maxWidth) {
                maxWidth = currentWidth;
            }
        });
        $('.custom-container p span').each(function() {
            $(this).width(maxWidth);
        });

        if ($(window).width() < 768) {
            var $container = $('.top_banner_mobile .custom-container');
        } else {
            var $container = $('.top_banner:not(.top_banner_mobile) .custom-container');
        }

        var $paragraphs = $container.find('p');
        var currentIndex = 0; // Commencer avec le premier paragraphe
    
        // Fonction pour démarrer l'animation du paragraphe actuel
        function animateCurrentParagraph() {
            // Masquer tous les paragraphes sauf le courant
            $paragraphs.hide();
            var $currentParagraph = $($paragraphs[currentIndex]);
        
            if ($(window).width() < 768) {
                $currentParagraph.fadeIn(1000).delay(8000).fadeOut(1000, function() {
                    // Passer au paragraphe suivant ou revenir au premier si on est au dernier
                    currentIndex = (currentIndex + 1) % $paragraphs.length;
                    animateCurrentParagraph(); // Rappeler la fonction pour animer le prochain paragraphe
                });
            }else{
                $currentParagraph.fadeIn(1000).delay(8000).fadeOut(1000, function() {            
                    // Passer au paragraphe suivant ou revenir au premier si on est au dernier
                    currentIndex = (currentIndex + 1) % $paragraphs.length;
                    animateCurrentParagraph(); // Rappeler la fonction pour animer le prochain paragraphe
                });
            }
        }
        
    
        animateCurrentParagraph(); // Démarrer l'animation
    }
    
    
    // Masquer tous les paragraphes sauf le premier au début
    $('.top_banner_mobile .custom-container p').hide().first().show();
    $('.top_banner .custom-container').css('visibility', 'visible');
    
    // Démarrer l'animation
    animateParagraphs();

    $('.top_banner_close').on('click', function(e) {
        e.preventDefault();
        $('.top_banner').hide();
    });

    /*====== Currency language active ======*/
    $('.curr-lang-wrap ul li').hover(
        function(){ $(this).addClass('curr-lang-hover') },
        function(){ $(this).removeClass('curr-lang-hover') }
    )
    
    /*====== SidebarCart ======*/
    function miniCart() {
        var navbarTrigger = $('.cart-active'),
            endTrigger = $('.cart-close'),
            container = $('.sidebar-cart-active'),
            wrapper2 = $('.main-wrapper');
        
        wrapper2.prepend('<div class="body-overlay"></div>');
        navbarTrigger.on('click', function(e) {
            e.preventDefault();
            container.addClass('inside');
            wrapper2.addClass('overlay-active');
        });
        endTrigger.on('click', function(e) {
            e.preventDefault();
            container.removeClass('inside');
            wrapper2.removeClass('overlay-active');
        });
        $('.body-overlay').on('click', function(e) {
            e.preventDefault();
            container.removeClass('inside');
            wrapper2.removeClass('overlay-active');
        });
    };
    miniCart();


    /*====== SidebarFilters ======*/
    function sidebarFiltersDesktop() {
        var navbarTrigger = $('.sidebar-active'),
            endTrigger = $('.sidebar-close'),
            endTrigger2 = $('.sidebar-close-img'),
            container = $('.sidebar-results-active'),
            wrapper2 = $('.main-wrapper');
        
        wrapper2.prepend('<div class="body-overlay"></div>');
        navbarTrigger.on('click', function(e) {
            e.preventDefault();
            console.log('click');
            container.addClass('inside');
            wrapper2.addClass('overlay-active');
            //prevent the body to scroll
            $('body').css('overflow', 'hidden');
            $('body').css('margin-right', '15px');
        });
        $(document).on('click', '.sidebar-close', function(e) {  // Remplacez #endTriggerID par le sélecteur approprié
            e.preventDefault();
            container.removeClass('inside');
            wrapper2.removeClass('overlay-active');
            //allow the body to scroll
            $('body').css('overflow', 'auto');
            $('body').css('margin-right', '');
        });
        
        $(document).on('click', '.sidebar-close-img', function(e) {  // Remplacez #endTrigger2ID par le sélecteur approprié
            e.preventDefault();
            container.removeClass('inside');
            wrapper2.removeClass('overlay-active');
            $('body').css('overflow', 'auto');
            $('body').css('margin-right', '');
        });
        
        $(document).on('click', '.body-overlay', function(e) {
            e.preventDefault();
            container.removeClass('inside');
            wrapper2.removeClass('overlay-active');
            //allow the body to scroll
            $('body').css('overflow', 'auto');
            $('body').css('margin-right', '');
        });
    };
    if($(window).width() > 768){
        sidebarFiltersDesktop();
    }
    
    
    /*====== Quickinfo ======*/
    function quickInfo() {
        var navbarTrigger = $('.quick-info-active'),
            endTrigger = $('.quickinfo-close'),
            container = $('.quickinfo-wrapper-active'),
            wrapper2 = $('.main-wrapper-2');
        
        wrapper2.prepend('<div class="body-overlay-2"></div>');
        navbarTrigger.on('click', function(e) {
            e.preventDefault();
            container.addClass('quickinfo-visible');
            wrapper2.addClass('overlay-active-2');
        });
        endTrigger.on('click', function(e) {
            e.preventDefault();
            container.removeClass('quickinfo-visible');
            wrapper2.removeClass('overlay-active-2');
        });
        $('.body-overlay-2').on('click', function(e) {
            e.preventDefault();
            container.removeClass('quickinfo-visible');
            wrapper2.removeClass('overlay-active-2');
        });
    };
    quickInfo();
    
    /*====== Headroom menu sticky ======*/
    $(".intelligent-header").headroom({
        "offset": 400,
        "tolerance": 20 
    });    

    $(window).one('scroll', function() {
        sendEventLogger('scroll');
    });
    

    //on scroll up in the document, hide the header
    // if($('.homepage').length > 0){

    //     // Gestion du header sur la homepage
    //     $(window).scroll(function() {
    //         var scroll = $(window).scrollTop();
    //         if (scroll >= 400) {
    //             $(".intelligent-header").addClass("headroom--force-pinned");
    //             $('.header-area').removeClass('transparent');
    //             console.log('scrolling')
    //         }else{
    //             $(".intelligent-header").removeClass("headroom--force-pinned");
    //             $('.header-area').addClass('transparent');
    //         }
    //     });

    //     setTimeout(function() {
    //         $('.logo a svg').removeClass('big');
    //         setTimeout(function() {
    //             $('.header-bottom').fadeIn(300);
    //         }, 700);
    //     }, 2000);            

    //     /*if($(window).width() < 768){

    //         // Gestion du scroll vers les sections
    //         const sections = $('.scroll-sct');
    //         let currentSectionIndex = 0;
    //         let lastScrollTop = $(window).scrollTop();
    //         let isScrollingAllowed = true;
    //         let isProgrammaticScroll = false; // Indicateur pour le défilement programmé

    //         $(window).on('scroll', function() {
    //             // Ignorer les événements de défilement générés par l'animation
    //             if (isProgrammaticScroll) {
    //                 return;
    //             }

    //             let currentScrollTop = $(window).scrollTop();

    //             if (!isScrollingAllowed) {
    //                 return;
    //             }

    //             if (currentScrollTop < lastScrollTop) {
    //                 // Défilement vers le haut
    //                 currentSectionIndex = Math.max(currentSectionIndex - 1, 0);
    //             } else if (currentScrollTop > lastScrollTop) {
    //                 // Défilement vers le bas
    //                 currentSectionIndex = Math.min(currentSectionIndex + 1, sections.length - 1);
    //             }

    //             lastScrollTop = currentScrollTop;

    //             const scrollToPosition = sections.eq(currentSectionIndex).offset().top - 50;

    //             isProgrammaticScroll = true; // Début du défilement programmé
    //             $('html, body').animate({
    //                 scrollTop: scrollToPosition
    //             }, 500, function() {
    //                 // Réinitialiser après l'animation
    //                 isProgrammaticScroll = false;
    //                 lastScrollTop = $(window).scrollTop();
    //             });

    //             isScrollingAllowed = false;
    //             setTimeout(function() {
    //                 isScrollingAllowed = true;
    //             }, 700); // Buffer de 0.7 seconde
    //         });
    //     }*/
    // }
    
    $(".intelligent-header-2").headroom({
        "offset": 0,
    });
    
    /*----- Slider-active active -----*/
    $('.slider-active-1').owlCarousel({
        loop: true,
        nav: true,
        autoplay: false,
        autoplayTimeout: 5000,
        animateOut: 'fadeOut',
        animateIn: 'fadeIn',
        navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
        item: 1,
        responsive: {
            0: {
                items: 1
            },
            576: {
                items: 1,
            },
            768: {
                items: 1
            },
            992: {
                items: 1
            }
        }
    })
    
    /*--
        Slider active 3
    -----------------------------------*/
    $('.slider-active-3').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        fade: false,
        arrows: false,
        responsive: [{
                breakpoint: 767,
                settings: {
                }
            },
            {
                breakpoint: 420,
                settings: {
                    autoplay: true,
                    slidesToShow: 1,
                }
            }
        ]
    });
    
    /*--
        Slider active 2
    -----------------------------------*/
    $('.slider-active-2').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '350px',
        dots: false,
        fade: false,
        prevArrow: '<span class="slider-icon slider-prev"><i class="fa fa-angle-left"></i></span>',
        nextArrow: '<span class="slider-icon slider-next"><i class="fa fa-angle-right"></i></span>',
        responsive: [
            {
                breakpoint: 1199,
                settings: {
                    centerPadding: '200px',
                }
            },
            {
                breakpoint: 991,
                settings: {
                    centerPadding: '150px',
                }
            },
            {
                breakpoint: 767,
                settings: {
                    centerPadding: '100px',
                }
            },
            {
                breakpoint: 575,
                settings: {
                    autoplay: true,
                    slidesToShow: 1,
                    centerPadding: '30px',
                }
            }
        ]
    });
    
    /* Product slider active */
    $('.product-slider-active').owlCarousel({
        loop: true,
        nav: false,
        autoplay: false,
        autoplayTimeout: 5000,
        item: 4,
        margin: 20,
        responsive: {
            0: {
                items: 1
            },
            576: {
                items: 2,
                margin: 30,
            },
            768: {
                items: 2,
                margin: 30,
            },
            992: {
                items: 3,
                margin: 30
            },
            1200: {
                items: 4
            }
        }
    })
    
    /* Product category slider */
    $('.product-category-slider').owlCarousel({
        loop: true,
        nav: false,
        autoplay: false,
        autoplayTimeout: 5000,
        item: 3,
        margin: 30,
        responsive: {
            0: {
                items: 1
            },
            576: {
                items: 2,
            },
            768: {
                items: 2,
            },
            992: {
                items: 3,
            },
            1200: {
                items: 3
            }
        }
    })
    
    /* Banner slider active  */
    $('.banner-slider-active').owlCarousel({
        loop: true,
        nav: true,
        autoplay: false,
        autoplayTimeout: 5000,
        navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
        item: 3,
        margin: 20,
        responsive: {
            0: {
                items: 1
            },
            576: {
                items: 1,
            },
            768: {
                items: 2
            },
            992: {
                items: 3
            }
        }
    })
    
    /* Blog gallery active  */
    $('.blog-gallery-slider').owlCarousel({
        loop: true,
        nav: true,
        autoplay: false,
        autoplayTimeout: 5000,
        navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
        item: 1,
        responsive: {
            0: {
                items: 1
            },
            576: {
                items: 1,
            },
            768: {
                items: 1
            },
            992: {
                items: 1
            }
        }
    })
    
    /* Testimonial active  */
    $('.testimonial-active').owlCarousel({
        loop: true,
        nav: false,
        autoplay: false,
        autoplayTimeout: 5000,
        item: 1,
        animateIn: 'zoomIn',
        responsive: {
            0: {
                items: 1
            },
            576: {
                items: 1,
            },
            768: {
                items: 1
            },
            992: {
                items: 1
            }
        }
    }) 
    
    /* Testimonial active 3 */
    $('.testimonial-active-2').owlCarousel({
        loop: true,
        nav: false,
        autoplay: false,
        autoplayTimeout: 5000,
        animateOut: 'fadeOut',
        animateIn: 'fadeIn',
        item: 2,
        margin: 50,
        responsive: {
            0: {
                items: 1
            },
            768: {
                items: 1
            },
            992: {
                items: 2
            },
            1000: {
                items: 2
            }
        }
    })
    
    /* Blog related active  */
    $('.blog-related-active').owlCarousel({
        loop: true,
        nav: false,
        autoplay: false,
        autoplayTimeout: 5000,
        item: 1,
        animateIn: 'zoomIn',
        responsive: {
            0: {
                items: 1
            },
            576: {
                items: 1,
            },
            768: {
                items: 1
            },
            992: {
                items: 1
            }
        }
    })
    
    
    /*--
        Instafeed
    -----------------------------------*/
    // User Changeable Access
    var activeId = $("#instafeed"),
          myTemplate = '<div class="instagram-item"><a href="{{link}}" target="_blank" id="{{id}}"><img src="{{image}}" /></a><div class="instagram-hvr-content"><span class="totalcomments"><i class="fa fa-comment"></i>{{comments}}</span><span class="tottallikes"><i class="fa fa-heart"></i>{{likes}}</span></div></div>';
    if (activeId.length) {
        var userID = activeId.attr('data-userid'),
            accessTokenID = activeId.attr('data-accesstoken'),
            userFeed = new Instafeed({
                get: 'user',
                userId: 6665768655,
                accessToken: 'IGQVJWLXU1Ri1JbjE0RlhlRmVZAMy1mRllxUzJWZAG5najYxWUxLcGl1SV80UHNiN2ZAaUFdHTVllMEh6YjRucTZAIY09TQlowdGlScG9taHhWNHJwaXQzOVZAwUDdsZAHdqTjhTcHB5ZA2I5QWRVZAVZAtYjZA2SgZDZD',
                template: myTemplate,
                sortBy: 'least-recent',
                limit: 6,
            });
        userFeed.run();
    }
    
    
    /* Tooltip active */
    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
      return new bootstrap.Tooltip(tooltipTriggerEl)
    })

    
    /* Quickview slider active */
    $('.quickview-slider-active').owlCarousel({
        loop: true,
        nav: true,
        autoplay: false,
        autoplayTimeout: 5000,
        navText: ['<i class="dl-icon-left"></i>', '<i class="dl-icon-right"></i>'],
        item: 1,
        responsive: {
            0: {
                items: 1
            },
            576: {
                items: 1,
            },
            768: {
                items: 1
            },
            992: {
                items: 1
            }
        }
    })
    
    /*====== Mobile off canvas active ======*/
    function headermobileAside() {
        var navbarTrigger = $('.mobile-aside-button'),
            endTrigger = $('.mobile-aside-close'),
            container = $('.mobile-off-canvas-active'),
            wrapper = $('.main-wrapper-3');
        wrapper.prepend('<div class="body-overlay-3"></div>');
        navbarTrigger.on('click', function(e) {
            e.preventDefault();
            container.addClass('inside');
            wrapper.addClass('overlay-active-3');
        });
        endTrigger.on('click', function(e) {
            e.preventDefault();
            container.removeClass('inside');
            wrapper.removeClass('overlay-active-3');
        });
        $('.body-overlay-3').on('click', function(e) {
            e.preventDefault();
            container.removeClass('inside');
            wrapper.removeClass('overlay-active-3');
        });
    };
    headermobileAside();

    //Desktop Header Bold hover
    $('.intelligent-header .position-static').each(function(){
        //$(this).width($(this).width() + 2);
    });

    /*====== Mobile search right canvas active ======*/
    function headermobileSearchAside() {
        var navbarTrigger = $('.mobile-aside-search-button'),
            endTrigger = $('.mobile-aside-close'),
            container = $('.mobile-off-canvas-active'),
            wrapper = $('.main-wrapper-3');
        wrapper.prepend('<div class="body-overlay-3"></div>');
        navbarTrigger.on('click', function(e) {
            e.preventDefault();
            container.addClass('inside');
            wrapper.addClass('overlay-active-3');
        });
        endTrigger.on('click', function(e) {
            e.preventDefault();
            container.removeClass('inside');
            wrapper.removeClass('overlay-active-3');
        });
        $('.body-overlay-3').on('click', function(e) {
            e.preventDefault();
            container.removeClass('inside');
            wrapper.removeClass('overlay-active-3');
        });
    };
    headermobileSearchAside();
    
    /*---------------------
        Mobile-menu
    --------------------- */
    // var $offCanvasNav = $('.mobile-menu , .final-clickable-menu'),
    //     $offCanvasNavSubMenu = $offCanvasNav.find('.dropdown');
    // $offCanvasNavSubMenu.parent().prepend('<span class="menu-expand"><i></i></span>');
    // $offCanvasNavSubMenu.slideUp();
    // $offCanvasNav.on('click', 'li a, li .menu-expand', function(e) {
    //     var $this = $(this);
    //     if (($this.parent().attr('class') != undefined) && ($this.parent().attr('class').match(/\b(menu-item-has-children|has-children|has-sub-menu)\b/)) && ($this.attr('href') === '#' || $this.hasClass('menu-expand'))) {
    //         e.preventDefault();
    //         if ($this.siblings('ul:visible').length) {
    //             $this.parent('li').removeClass('active');
    //             $this.siblings('ul').slideUp();
    //         } else {
    //             $this.parent('li').addClass('active');
    //             $this.closest('li').siblings('li').removeClass('active').find('li').removeClass('active');
    //             $this.closest('li').siblings('li').find('ul:visible').slideUp();
    //             $this.siblings('ul').slideDown();
    //         }
    //     }
    // });

    $('.sub-entry-open').on('click', function(e) {
        e.preventDefault();
        //get data-entry attribute from the .main-entry parent
        var entry = $(this).parent().data('entry');
        //hide all main-entry except the one with the data-entry attribute
        

        if($(this).parent().find('.sub-entry').is(':visible')){
            $(this).parent().find('.sub-entry').hide();
            // $('.sub-entry-open').show();
            $('.sub-entry-open').css('display', '');
            console.log("flag");

        }else{
            var $parent = $(this).parent();
            setTimeout(function() {
                $parent.find('.sub-entry').show();
                $parent.find('.sub-entry').children().each(function(index) {
                    $(this).css({
                        'position': 'relative',
                        'left': '-5%',
                        'opacity': '0',
                        'display': 'block' // Rendre l'élément visible sans show()
                    }).delay(index * 25).animate({
                        'left': '0',
                        'opacity': '1'
                    }, 250); // Animation pour chaque enfant
                });
            }, 700);

            // $('.sub-entry-open').hide('slow');
            $('.sub-entry-open:visible, .mobile-menu-universe:visible, .mobile-curr-lang-wrap:visible, .mobile-others-wrap:visible').each(function(index) {
                $(this).delay(index * 25).animate({
                    'left': '-5%',
                    'opacity': '0'
                });
            }).promise().done(function() {
                $('.mobile-menu-universe').hide();
                $('.mobile-curr-lang-wrap').hide();
                $('.mobile-others-wrap').hide();

                $('.main-entry').each(function(){
                    if($(this).data('entry') != entry){
                        $(this).hide();
                    }
                });
                
                $('.sub-entry-open').hide();
                $('.sub-entry-open').css({
                    'left': '0',
                    'opacity': '1'
                });
            });
        }
    });

    $('.back-entry').on('click', function(e) {
        e.preventDefault();
        // $('.sub-entry').hide('slow');
        // setTimeout(function() {
        //     $('.main-entry').show();
        //     $('.sub-entry-open').show();
        //     $('.menu-title-universe').show();
        //     $('.mobile-curr-lang-wrap').show();
        // }, 500);

        $('.back-entry:visible, .sub-entry li:visible').each(function(index) {
            $(this).delay(index * 25).animate({
                'left': '-5%',
                'opacity': '0'
            });
        }).promise().done(function() {
            $('.back-entry, .sub-entry li').hide(); // Masque ces éléments
            $('.sub-entry').hide(); // Masque les sous-entrées
            $('.main-entry, .sub-entry-open, .mobile-curr-lang-wrap, .mobile-others-wrap')
            .css({ // Remet ces éléments visibles avant animation
                'display': 'block',
                'opacity': '0', // Assure que l'animation commence bien
                'left': '-5%' // Position initiale pour l'animation
            })
            .each(function(index) {
                $(this).delay(index * 25).animate({
                    'left': '0%',
                    'opacity': '1'
                }, 250); // Animation fluide
            });
            $('.mobile-menu-universe')
            .css({ // Remet ces éléments visibles avant animation
                'display': 'flex',
                'opacity': '0', // Assure que l'animation commence bien
                'left': '-5%' // Position initiale pour l'animation
            })
            .each(function(index) {
                $(this).delay(index * 25).animate({
                    'left': '0%',
                    'opacity': '1'
                }, 250); // Animation fluide
            });
            $('.sub-entry-open').css('display', '');
        });
    });
    
    /*--- Language currency active ----*/
    $('.mobile-language-active').on('click', function(e) {
        e.preventDefault();
        $('.lang-dropdown-active').slideToggle(900);
    });
    $('.mobile-currency-active').on('click', function(e) {
        e.preventDefault();
        $('.curr-dropdown-active').slideToggle(900);
    });
    $('.mobile-account-active').on('click', function(e) {
        e.preventDefault();
        $('.account-dropdown-active').slideToggle(900);
    });
    
    /*------ Wow Active ----*/
    new WOW().init();
    
    /*------------
        ScrollUp
    ------------------ */
    if ($('.header-checkout').length == 0 && $('.product-details-area').length == 0) {
        $.scrollUp({
            scrollText: '<i class="fa fa-angle-up"></i>',
            easingType: 'linear',
            scrollSpeed: 900,
            animation: 'fade'
        });
    }
    
    /*====== SidebarSearch ======*/
    function sidebarSearch() {
        var searchTrigger = $('.search-active'),
            endTriggersearch = $('.search-close'),
            container = $('.main-search-active');
        searchTrigger.on('click', function(e) {
            e.preventDefault();
            container.addClass('search-visible');
        });
        endTriggersearch.on('click', function(e) {
            container.removeClass('search-visible');
        });
    };
    sidebarSearch();

    var isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;

    /*====== SearchBar Header ======*/
    $('.intelligent-header').hover(function(){
        var header_type = $(this).data('type');
        if(header_type == "homepage"){
            $('.sub-menu').hover(function(){
                setTimeout(function() {
                    $('.intelligent-header').removeClass('homepage');
                }, 300);
            });
        }

        $('.sub-menu').hover(function(){
            setTimeout(function() {
                $('.intelligent-header').removeClass('untransparency');
            }, 300);
        });

        // if (!isTouchDevice) {
        //     // Comportement pour les ordinateurs de bureau
        //     $('.nav-main').hover(function() {
        //         $('.nav-main').css('text-decoration', 'none');
        //         $(this).css('text-decoration', 'underline');
        //         var gender = $(this).data('gender');
        //         $('.nav-sub').hide();
        //         $('.nav-sub-' + gender).show();
        //     }, function() {
        //     });
        // } else {
        //     // Comportement pour les appareils tactiles
        //     $('.nav-main').on('click', function(e) {
        //         e.preventDefault();
        //         $('.nav-main').css('text-decoration', 'none');
        //         $(this).css('text-decoration', 'underline');
        //         var gender = $(this).data('gender');
        //         if($('.nav-sub-' + gender).is(':visible')) {
        //             window.location.href = $(this).attr('href');
        //         } else {
        //             $('.nav-sub').hide();
        //             $('.nav-sub-' + gender).show();
        //         }
        //     });

        //     $('.sub-menu').on('click', function(e) {
        //         e.preventDefault();
        //     });

        //     // onscroll
        //     $(window).scroll(function() {
        //         // $('.nav-sub').hide();
        //         $('.nav-main').css('text-decoration', 'none');
        //         if($(this).data('type')=="homepage"){
        //             $('.intelligent-header').addClass('homepage');
        //         }
        //     });
        // }

        $('.logo, .header-login component-same').hover(function(){
            if(header_type == "homepage"){
                setTimeout(function() {
                    $('.intelligent-header').addClass('homepage');
                }, 300);
            }
        });

    }, function(){
        // $('.nav-sub').hide();
        $('.nav-main').css('text-decoration', 'none');
        if($(this).data('type')=="homepage"){
            setTimeout(function() {
                $('.intelligent-header').addClass('homepage');
            }, 300);
        }

        setTimeout(function() {
            $('.intelligent-header').addClass('untransparency');
        }, 300);
    });

    $('.sidebar-cart-active .search-icon').click(function(e) {
        e.preventDefault();
        if($('.sidebar-cart-active form.search-form input[type="search"]').val() != '') {
            $('.sidebar-cart-active form.search-form').submit();
        }
    });
    
    /*---------------------
        Video popup
    --------------------- */
    $('.video-popup').magnificPopup({
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        zoom: {
            enabled: true,
        }
    });
    
    /*--------------------------
        Masonry active
    ---------------------------- */
    $('.grid').imagesLoaded(function() {
        // init Isotope
        $('.grid').isotope({
            itemSelector: '.grid-item',
            percentPosition: true,
            layoutMode: 'masonry',
            masonry: {
                // use outer width of grid-sizer for columnWidth
                columnWidth: '.grid-sizer',
            }
        });
    });
    
    /*--
        Masonry active 2
    -----------------------------------*/
    $('.grid-2').imagesLoaded(function() {
        // init Isotope
        var $grid = $('.grid-2').isotope({
            itemSelector: '.grid-item-2',
            percentPosition: true,
            layoutMode: 'masonry',
            masonry: {
                // use outer width of grid-sizer for columnWidth
                columnWidth: '.grid-item-2',
            }
        });
    });
    
    
    /* Jarallax active  */
    $('.jarallax').jarallax({
        speed: 0.7
    });
    
    /*=========================
		Toggle Ativation
	===========================*/
    function itemToggler() {
        $(".toggle-item-active").slice(0, 9).show();
        $(".item-wrapper").find(".loadMore").on('click', function(e) {
            e.preventDefault();
            $(this).parents(".item-wrapper").find(".toggle-item-active:hidden").slice(0, 1).slideDown();
            if ($(".toggle-item-active:hidden").length == 0) {
                $(this).parent('.toggle-btn').fadeOut('slow');
            }
        });
    }
    itemToggler();
    
     /*====== Clickable main menu ======*/
    function clickableMenu() {
        var navbarTrigger = $('.clickable-menu-active'),
            endTrigger = $('.clickable-menu-close'),
            container = $('.clickablemenu-wrapper-active'),
            wrapper4 = $('.main-wrapper-4');
        
        wrapper4.prepend('<div class="body-overlay-4"></div>');
        navbarTrigger.on('click', function(e) {
            e.preventDefault();
            container.addClass('clickablemenu-visible');
            wrapper4.addClass('overlay-active-4');
        });
        endTrigger.on('click', function() {
            container.removeClass('clickablemenu-visible');
            wrapper4.removeClass('overlay-active-4');
        });
        $('.body-overlay-4').on('click', function() {
            container.removeClass('clickablemenu-visible');
            wrapper4.removeClass('overlay-active-4');
        });
    };
    clickableMenu();
    
    /*--
        Magnific Popup
    ------------------------*/
    // $('.img-popup').magnificPopup({
    //     type: 'image',
    //     zoom: {
    //         enabled: true
    //     },
    //     gallery: {
    //         enabled: true
    //     },
    //     closeMarkup: '<button title="%title%" type="button" class="mfp-close mfp-fade-out"><img style="width: 25px;margin: 64px -46px 0 0;cursor: pointer;" src="/assets/251129145240/images/icon-img/big-close-white.svg" alt="Fermer" /></button>',
    //     arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-custom-arrow-left"><img src="/assets/251129145240/images/icon-img/big-close-white.svg" alt=""></button>',

    //     callbacks: {
    //         open: function() {
    //             $('.mfp-close').on('click', (e) => {
    //                 e.preventDefault();
    //                 $.magnificPopup.close(); // Utilisez $.magnificPopup.close() pour fermer la popup
    //               });

    //             var zoomButtonsContainer = $('<div class="zoom-buttons-container"></div>');
    //             var zoomInButton = $('<button class="zoom-in-button">+</button>');
    //             var zoomOutButton = $('<button class="zoom-out-button">-</button>');

    //             zoomButtonsContainer.append(zoomInButton, zoomOutButton);

    //             zoomInButton.on('click', function(event) {
    //                 event.stopPropagation();
    //                 zoomImage(1.4); // Définit le zoom à 1 (pas de zoom)
    //             });

    //             zoomOutButton.on('click', function(event) {
    //                 event.stopPropagation();
    //                 zoomImage(1); // Définit le zoom à 1 (pas de zoom)
    //             });

    //             $('.mfp-container .mfp-content').append(zoomButtonsContainer);

    //             function zoomImage(scale) {
    //                 $('.mfp-img').css('transform', 'scale(' + scale + ')');
    //             }

    //         },
    //         close: function() {
    //           // Will fire when popup is closed
    //         }
    //         // e.t.c.
    //       },
    //       mainClass: 'mfp-without-fade'
    // });

    // $('.img-popup-mobile').magnificPopup({
    //     type: 'image',
    //     gallery: {
    //         enabled: true
    //     }
    // });

    $('.open-login-modal').magnificPopup({
        type: 'inline',
        callbacks: {
            open: function() {
                console.log('guest open');
    
                $("#password_reset-modal .hide").hide();
                $("#password_reset-modal .hide_bot").hide();
                $("#password_reset-modal .show").show();

                if($('.bid-area-section-content-steps-primary.btn-primary.open-login-modal').hasClass('guest')) {
                    $('#login-modal label.guest-hide').show();
                    $('#login-modal #guest').trigger('click');
                }

                if($('.checkout-container-left-contact-connect').length > 0) {
                    $('#login-modal #login').trigger('click');
                }

                var container = $('.mobile-off-canvas-active');
                var wrapper = $('.main-wrapper-3');
                container.removeClass('inside');
                wrapper.removeClass('overlay-active-3');
                if (typeof gtag === 'function') {
                    gtag("event", "login_screen", { });
                }

                if($('#login-modal #login').is(':checked')) {
                    sendEventLogger('login_popin_open', { 'view': 'signin' });
                } else {
                    sendEventLogger('login_popin_open', { 'view': 'signup' });
                }
            }
        }
    });

    $('.open-login_magic-modal').magnificPopup({
        type: 'inline',
        callbacks: {
            open: function() {
                console.log('magic login open');
    

                if (typeof gtag === 'function') {
                    gtag("event", "login_screen", { });
                }

                sendEventLogger('login_popin_open', { 'view': 'signin' });
            }
        }
    });

    // $('.open-search-modal').magnificPopup({
    //     type: 'inline',
    //     mainClass: 'my-mfp-slide-top',
    //     callbacks: {
    //         open: function() {
    //             setTimeout(function() { $('.search-modal .search-form input[type="search"]').focus() }, 500);
    //             $('html, body').css('overflow', 'hidden');

    //             const swiperElAutoSuggest = document.querySelector('.swiper-container-autosuggest')

    //             if(swiperElAutoSuggest != null) {

    //                 const paramsAutoSuggest = {
    //                 injectStyles: [`
    //                 .swiper-container-autosuggest .swiper-pagination-bullets{
    //                     display: none!important;
    //                     opacity: 0;
    //                 }
    //                 `],
    //                 // spaceBetween: 6,
    //                 slidesPerView: 4, 
    //                 slidesPerGroup: 4,
    //                 centeredSlides: false,
    //                 loop: false,
    //                 breakpoints: {
    //                     768: {
    //                         slidesPerView: 4, 
    //                         slidesPerGroup: 4,
    //                         spaceBetween: 6,
    //                         centeredSlides: false,
    //                         loop: false,
    //                     },
    //                 },
    //                 draggable: true,
    //                 autoplay: {
    //                     delay: 7000, // 7 secondes
    //                     disableOnInteraction: false,
    //                 },
    //                 navigation: {
    //                     nextEl: '.swiper-button-next',
    //                     prevEl: '.swiper-button-prev',
    //                 },
    //                 pagination: {
    //                     el: null
    //                 }
    //                 }

    //                 Object.assign(swiperElAutoSuggest, paramsAutoSuggest)
    //                 swiperElAutoSuggest.initialize();
    //                 console.log('swiperElAutoSuggest', swiperElAutoSuggest)
    //             }
    //         },
    //         close: function() {
    //             $('html, body').css('overflow', 'auto');
    //         }
    //     }
    // });

    $('.open-search-modal').click(function() {

        if($('.search-modal').is(':visible')) {
            $('.search-modal').hide();
            $('html, body').css('overflow', '');
            return;
        }
        setTimeout(function() { $('.search-modal .search-form input[type="search"]').focus() }, 500);
        $('html, body').css('overflow', 'hidden');

        const swiperElAutoSuggest = document.querySelector('.swiper-container-autosuggest')

        if(swiperElAutoSuggest != null) {

            const paramsAutoSuggest = {
            injectStyles: [`
            .swiper-container-autosuggest .swiper-pagination-bullets{
                display: none!important;
                opacity: 0;
            }
            `],
            spaceBetween: 6,
            slidesPerView: 2, 
            slidesPerGroup: 2,
            centeredSlides: false,
            loop: false,
            breakpoints: {
                768: {
                    slidesPerView: 6, 
                    slidesPerGroup: 2,
                    spaceBetween: 6,
                    centeredSlides: false,
                    loop: false,
                },
            },
            draggable: true,
            autoplay: {
                delay: 7000, // 7 secondes
                disableOnInteraction: false,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            pagination: {
                el: null
            }
            }

            Object.assign(swiperElAutoSuggest, paramsAutoSuggest)
            swiperElAutoSuggest.initialize();
            console.log('swiperElAutoSuggest', swiperElAutoSuggest)
        }

        $('.search-modal').show();
    });

    
    $('.open-checkout_returns_popin-modal').magnificPopup({
        type: 'inline',
        callbacks: {
            open: function() {
                //block scroll on body
                $('html, body').css('overflow', 'hidden');
            },
            close: function() {
                //unblock scroll on body
                $('html, body').css('overflow', 'auto');
            }
        }
    });
    $('.open-checkout_orders_popin-modal').magnificPopup({
        type: 'inline',
        callbacks: {
            open: function() {
                //block scroll on body
                $('html, body').css('overflow', 'hidden');
            },
            close: function() {
                //unblock scroll on body
                $('html, body').css('overflow', 'auto');
            }
        }
    });
    $('.open-checkout_privacy_popin-modal').magnificPopup({
        type: 'inline',
        callbacks: {
            open: function() {
                //block scroll on body
                $('html, body').css('overflow', 'hidden');
            },
            close: function() {
                //unblock scroll on body
                $('html, body').css('overflow', 'auto');
            }
        }
    });
    $('.open-checkout_terms_popin-modal').magnificPopup({
        type: 'inline',
        callbacks: {
            open: function() {
                //block scroll on body
                $('html, body').css('overflow', 'hidden');
            },
            close: function() {
                //unblock scroll on body
                $('html, body').css('overflow', 'auto');
            }
        }
    });
    $('.open-checkout_contact_popin-modal').magnificPopup({
        type: 'inline',
        callbacks: {
            open: function() {
                //block scroll on body
                $('html, body').css('overflow', 'hidden');
            },
            close: function() {
                //unblock scroll on body
                $('html, body').css('overflow', 'auto');
            }
        }
    });

    $('.open-notifyme_privacy_popin-modal').magnificPopup({
        type: 'inline',
        callbacks: {
            open: function() {
                //block scroll on body
                $('html, body').css('overflow', 'hidden');
            },
            close: function() {
                //unblock scroll on body
                $('html, body').css('overflow', 'auto');
            }
        }
    });

    $(document).on('click', '#notifyme_popin-modal .mfp-close', function(e) {
        e.preventDefault();
        $.magnificPopup.close();
        $('.open-notifyme_popin-modal').click();
        console.log('open-notifyme_privacy_popin-modal');
    });


    $('.open-password_reset-modal').magnificPopup({
        type: 'inline'
    });
    $('.open-password_reset-modal').on('click', function(e) {
        e.preventDefault();
        var email = $('#login-form #login_email').val();
        $('#password_reset-form input[name="email"]').val(email);
    });
    $('.password_reset .close-button').on('click', function(e) {
        e.preventDefault();
        $.magnificPopup.close();
    });


    $('.signup-hide').hide();
    $('.guest-hide').hide();

    function handleLoginPopin() {
        var selectedOption = $('input[name="login"]:checked').attr('id');

        // Cacher tous les formulaires
        $('#signup-form').hide();
        $('#login-form').hide();
        $('#guest-form').hide();
        $('.login-hide').hide();

        // Afficher le formulaire correspondant
        if (selectedOption === 'signup') {
            $('#signup-form').show();
            $('.login-hide').show();
            $('#login-modal .login-modal-proposition button')
            .text( oDict["you_already_have_an_account"] + ' ' + oDict["login"] )
            .attr('data-target', 'login');
            $('.error-message').text('');
        } else if (selectedOption === 'login') {
            $('#login-form').show();
            $('.login-hide').hide();
            $('#login-modal .login-modal-proposition button')
            .text( oDict["you_dont_have_any_account_yet"] )
            .attr('data-target', 'signup');       
            $('.error-message').text('');     
        }else if(selectedOption === 'guest'){
            $('#guest-form').show();
        }

    }

    handleLoginPopin();

    $('input[name="login"]').change(function() {
        // Récupérer la valeur du bouton radio sélectionné
        handleLoginPopin();
    });
    $('#login-modal .login-modal-proposition button').on('click', function(e) {
        e.preventDefault();
        var dataTarget = $(this).attr('data-target');
    
        if (dataTarget === 'login') {
            $('#login-modal #login').trigger('click');
        } else {
            $('#login-modal #signup').trigger('click');
        }
    });

    $('.login-modal-selector').click(function(e) {
        if($('.login-modal-selector input#login').is(':checked')) {
            sendEventLogger('login_popin_switch', { 'view': 'signup' });
        } else if($('.login-modal-selector input#signup').is(':checked')) {
            sendEventLogger('login_popin_switch', { 'view': 'signin' });
        }else if($('.login-modal-selector input#guest').is(':checked')){
            sendEventLogger('login_popin_switch', { 'view': 'guest' });
        }
    });

    if($('form#signup-form').length > 0) {
        var url = new URL(window.location.href);
        //remove "key" parameter from url
        url.searchParams.delete('key');

        $('input[name="return_path"]').val(url.pathname + url.search);
        // console.log('return_path', url.pathname + url.search);
    }

    $('#signup-form input[name="password"]').on('input', function() {
        $(this).next('.error-message').remove();
        $('.password-message').show();
    });
    
    /*** SIGNUP FORM SUBMISSION ***/
    // $('#signup-form').submit(function(e) {
    //     e.preventDefault(); // Empêche le rechargement de la page

    //     $('.error-message').remove();

    //     // Récupère les données du formulaire
    //     var firstname = $('#signup-form input[name="firstname"]').val().trim();
    //     var lastname = $('#signup-form input[name="lastname"]').val().trim();
    //     var email = $('#signup-form input[name="email"]').val().trim();
    //     var password = $('#signup-form input[name="password"]').val().trim();
    //     var gender = ($('#signup-form select[name="gender"]').val() || '').trim();
    //     var birthday_day = $('#signup-form select[name="birthday_day"]').val();
    //     var birthday_month = $('#signup-form select[name="birthday_month"]').val();
    //     var birthday_year = $('#signup-form select[name="birthday_year"]').val();
    //     var newsletter = $('#signup-form input[name="newsletter"]').is(':checked');

    //     // Vérifie si les champs sont vides
    //     if (firstname === '') {
    //         addErrorMessage($('input[name="firstname"]'), oDict["enter_valid_first_name"]);
    //     }

    //     if (lastname === '') {
    //         addErrorMessage($('input[name="lastname"]'), oDict["enter_valid_last_name"]);
    //     }

    //     if (email === '') {
    //         addErrorMessage($('input[name="email"]'), oDict["enter_your_email"]);
    //     } else if (!/^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/.test(email)) {
    //         addErrorMessage($('input[name="email"]'), oDict["enter_valid_email"]);
    //     }

    //     if (password === '') {
    //         addErrorMessage($('input[name="password"]'), oDict["enter_your_password"]);
    //         $('.password-message').hide();
    //     }

    //     if (password !== '' && password.length > 20) {
    //         addErrorMessage($('input[name="password"]'), oDict["password_exceed_char"]);
    //         $('.password-message').hide();
    //     }

    //     // Vérifie la complexité du mot de passe (1 majuscule, 1 chiffre, 1 symbole)
    //     var passwordRegex = /^(?=.*[A-Z])(?=.*\d).*$/;
    //     if (!passwordRegex.test(password)) {
    //         addErrorMessage($('input[name="password"]'), oDict["password_policy"]);
    //         $('.password-message').hide();
    //     }

    //     if($('.error-message').length > 0) {
    //         return;
    //     }

    //     grecaptcha.enterprise.ready(function() {
    //         grecaptcha.enterprise.execute('6LdkTGQpAAAAADf8F07OFECYPJZ2-TPT-KzZAX5l', {action: 'signup'}).then(function(token) {
    //             $('#recaptchaTokenSignup').val(token);

    //             var currentUrl = window.location.href;
    //             var urlObject = new URL(currentUrl);
    //             var baseUrl = urlObject.origin;

    //             var formData = $('#signup-form').serialize();

    //             $.ajax({
    //                 url: baseUrl + $('#signup-form').attr('action'),
    //                 type: 'POST',
    //                 data: formData,
    //                 success: function(data, status, xhr) {
    //                     var redirectUrl = xhr.getResponseHeader('Location');
    //                     if (xhr.status === 201) {
    //                         //window.location.reload();
    //                         $.magnificPopup.close();
    //                         $.magnificPopup.open({
    //                             items: {
    //                                 src: $('#verify_account-modal'),
    //                                 closeMarkup: '',
    //                                 type: 'inline',
    //                                 closeBtnInside: false,
    //                                 closeOnBgClick: false,
    //                             },
    //                             closeOnBgClick: false,
    //                             callbacks: {
    //                                 open: function() {
    //                                     $('.mfp-close').on('click', function(e) {
    //                                         e.preventDefault();
    //                                         $.magnificPopup.close(); // Fermer la popup lors du clic sur le bouton de fermeture
    //                                     });
    //                                 }
    //                             }
    //                         });
    //                         $('#verify_account-modal').attr('data-email', $('#signup-form input[name="email"]').val().trim());
    //                         $('.verify_account .close-button').on('click', function(e) {
    //                             e.preventDefault();
    //                             $.magnificPopup.close();
    //                         });

    //                         $('.account_verif_form_resend-btn').attr('data-sent', 'true').html(oDict["verif_sent"]);
    //                         $('.verif_counter').text(60);
    //                         var interval = setInterval(function() {
    //                             var counter = $('.verif_counter').text();
    //                             counter--;
    //                             $('.verif_counter').text(counter);
    //                             if(counter == 0) {
    //                                 clearInterval(interval);
    //                                 $('.account_verif_form_resend-btn').attr('data-sent', 'false');
    //                                 $('.account_verif_form_resend-btn').html(oDict["verif_send_code"]);
    //                             }
    //                         }, 1000);
    //                     } else {
    //                         if (data.success) {
    //                             console.log('Utilisateur créé avec succès');
    //                         } else {
    //                             if (data.errorCode === -2) {
    //                                 console.log('Email already exists');
    //                                 addErrorMessage($('#signup-form input[name="email"]'), oDict["email_already_exists"]);
    //                             } else if (data.errorCode === -3 ) { // recaptcha
    //                                 addErrorMessage($('#signup-form input[name="password"]'), oDict["pwd_reset_bot_detected"]);
    //                             } else {
    //                                 console.log('Erreur lors de la création de l\'utilisateur');
    //                             }
    //                         }                  
    //                     }
    //                 },
    //                 error: function(xhr, status, error) {
    //                     console.log(baseUrl + $('#signup-form').attr('action'));
    //                     console.log('AJAX error: ' + error);
    //                 }
    //             });

    //         });
    //     });
    // });

    /*** MAGIC SIGNUP FORM SUBMISSION ***/
    $('.login_magic-signup input[type="submit"]').on('click', function(e) {
        e.preventDefault(); // Empêche le rechargement de la page

        $('.error-message').remove();

        // Récupère les données du formulaire
        var firstname = $('.login_magic-signup input[name="firstname"]').val().trim();
        var lastname = $('.login_magic-signup input[name="lastname"]').val().trim();
        var email = $('#login_magic_email').val().trim();
        var password = $('.login_magic-signup input[name="password"]').val().trim();
        var return_path = $('.login_magic-signup input[name="return_path"]').val().trim();
        var recaptchaIp = $('.login_magic-signup input[name="recaptchaIp"]').val().trim();
        var recaptchaUserAgent = $('.login_magic-signup input[name="recaptchaUserAgent"]').val().trim();
        var visitor_id = $('.login_magic-signup input[name="visitor_id"]').val().trim();
        var registration_url = $('.login_magic-signup input[name="registration_url"]').val().trim();

        // Vérifie si les champs sont vides
        if (firstname === '') {
            addErrorMessage($('.login_magic-signup input[name="firstname"]'), oDict["enter_valid_first_name"]);
        }

        if (lastname === '') {
            addErrorMessage($('.login_magic-signup input[name="lastname"]'), oDict["enter_valid_last_name"]);
        }

        if (email === '') {
            addErrorMessage($('.login_magic-signup input[name="email"]'), oDict["enter_your_email"]);
        } else if (!/^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/.test(email)) {
            addErrorMessage($('.login_magic-signup input[name="email"]'), oDict["enter_valid_email"]);
        }

        if (password === '') {
            addErrorMessage($('.login_magic-signup input[name="password"]'), oDict["enter_your_password"]);
            $('.password-message').hide();
        }

        if (password !== '' && password.length > 20) {
            addErrorMessage($('.login_magic-signup input[name="password"]'), oDict["password_exceed_char"]);
            $('.password-message').hide();
        }

        // Vérifie la complexité du mot de passe (1 majuscule, 1 chiffre, 1 symbole)
        var passwordRegex = /^(?=.*[A-Z])(?=.*\d).*$/;
        if (!passwordRegex.test(password)) {
            addErrorMessage($('.login_magic-signup input[name="password"]'), oDict["password_policy"]);
            $('.password-message').hide();
        }

        if($('.error-message').length > 0) {
            return;
        }

        grecaptcha.enterprise.ready(function() {
            grecaptcha.enterprise.execute('6LdkTGQpAAAAADf8F07OFECYPJZ2-TPT-KzZAX5l', {action: 'signup'}).then(function(token) {
                $('#recaptchaTokenSignup').val(token);

                var currentUrl = window.location.href;
                var urlObject = new URL(currentUrl);
                var baseUrl = urlObject.origin;

                var formData = {
                    firstname: firstname,
                    lastname: lastname,
                    email: email,
                    password: password,
                    recaptchaTokenSignup: token,
                    return_path: return_path,
                    recaptchaIp: recaptchaIp,
                    recaptchaUserAgent: recaptchaUserAgent,
                    visitor_id: visitor_id,
                    registration_url: registration_url,
                }

                $.ajax({
                    url: baseUrl + $('.login_magic-signup').attr('data-action'),
                    type: 'POST',
                    data: formData,
                    success: function(data, status, xhr) {
                        var redirectUrl = xhr.getResponseHeader('Location');
                        if (xhr.status === 201) {
                            //window.location.reload();
                            $.magnificPopup.close();
                            $.magnificPopup.open({
                                items: {
                                    src: $('#verify_account-modal'),
                                    closeMarkup: '',
                                    type: 'inline',
                                    closeBtnInside: false,
                                    closeOnBgClick: false,
                                },
                                closeOnBgClick: false,
                                callbacks: {
                                    open: function() {
                                        $('.mfp-close').on('click', function(e) {
                                            e.preventDefault();
                                            $.magnificPopup.close(); // Fermer la popup lors du clic sur le bouton de fermeture
                                        });
                                    }
                                }
                            });
                            $('#verify_account-modal').attr('data-email', $('#login_magic_email').val().trim());
                            $('.verify_account .close-button').on('click', function(e) {
                                e.preventDefault();
                                $.magnificPopup.close();
                            });

                            $('.account_verif_form_resend-btn').attr('data-sent', 'true').html(oDict["verif_sent"]);
                            $('.verif_counter').text(60);
                            var interval = setInterval(function() {
                                var counter = $('.verif_counter').text();
                                counter--;
                                $('.verif_counter').text(counter);
                                if(counter == 0) {
                                    clearInterval(interval);
                                    $('.account_verif_form_resend-btn').attr('data-sent', 'false');
                                    $('.account_verif_form_resend-btn').html(oDict["verif_send_code"]);
                                }
                            }, 1000);
                        } else {
                            if (data.success) {
                                console.log('Utilisateur créé avec succès');
                            } else {
                                if (data.errorCode === -2) {
                                    console.log('Email already exists');
                                    addErrorMessage($('#signup-form input[name="email"]'), oDict["email_already_exists"]);
                                } else if (data.errorCode === -3 ) { // recaptcha
                                    addErrorMessage($('#signup-form input[name="password"]'), oDict["pwd_reset_bot_detected"]);
                                } else {
                                    console.log('Erreur lors de la création de l\'utilisateur');
                                }
                            }                  
                        }
                    },
                    error: function(xhr, status, error) {
                        console.log(baseUrl + $('#signup-form').attr('action'));
                        console.log('AJAX error: ' + error);
                    }
                });

            });
        });
    });

    $('.login_magic-signup input').on('input', function() {
        var firstname = $('.login_magic-signup input[name="firstname"]').val().trim();
        var lastname = $('.login_magic-signup input[name="lastname"]').val().trim();
        var email = $('#login_magic_email').val().trim();
        var password = $('.login_magic-signup input[name="password"]').val().trim();

        if (firstname.length > 0 && lastname.length > 0 && email.length > 0 && password.length > 0) {
            $('.login_magic-signup input[type="submit"]').prop('disabled', false);
        }else{
            $('.login_magic-signup input[type="submit"]').prop('disabled', true);
        }
    });

    $('#verify_account_creation_signup-form input').on('input', function() {
        // var firstname = $('#verify_account_creation_signup-form input[name="firstname"]').val().trim();
        // var lastname = $('#verify_account_creation_signup-form input[name="lastname"]').val().trim();
        var password = $('#verify_account_creation_signup-form input[name="password"]').val().trim();

        if (password.length > 0) {
            $('#verify_account_creation_signup-form input[type="submit"]').prop('disabled', false);
        }else{
            $('#verify_account_creation_signup-form input[type="submit"]').prop('disabled', true);
        }
    });


    /*** GUEST FORM SUBMISSION ***/
    $('#guest-form').submit(function(e) {
        e.preventDefault(); // Empêche le rechargement de la page

        $('.error-message').remove();

        // Récupère les données du formulaire
        var email = $('#guest-form input[name="email"]').val().trim();

        if (email === '') {
            addErrorMessage($('input[name="email"]'), oDict["enter_your_email"]);
        } else if (!/^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/.test(email)) {
            addErrorMessage($('input[name="email"]'), oDict["enter_valid_email"]);
        }

        if($('.error-message').length > 0) {
            return;
        }

        grecaptcha.enterprise.ready(function() {
            grecaptcha.enterprise.execute('6LdkTGQpAAAAADf8F07OFECYPJZ2-TPT-KzZAX5l', {action: 'signup'}).then(function(token) {
                $('#recaptchaTokenSignupGuest').val(token);

                var currentUrl = window.location.href;
                var urlObject = new URL(currentUrl);
                var baseUrl = urlObject.origin;

                var formData = $('#guest-form').serialize();
                formData += '&guest=true';

                $.ajax({
                    url: baseUrl + $('#guest-form').attr('action'),
                    type: 'POST',
                    data: formData,
                    success: function(data, status, xhr) {
                        var redirectUrl = xhr.getResponseHeader('Location');
                        if (xhr.status === 201) {
                            window.location.reload();
                            $.magnificPopup.close();
                            // $.magnificPopup.open({
                            //     items: {
                            //         src: $('#verify_account-modal'),
                            //         closeMarkup: '',
                            //         type: 'inline',
                            //         closeBtnInside: false,
                            //         closeOnBgClick: false,
                            //     },
                            //     closeOnBgClick: false,
                            //     callbacks: {
                            //         open: function() {
                            //             $('.mfp-close').on('click', function(e) {
                            //                 e.preventDefault();
                            //                 $.magnificPopup.close();
                            //             });
                            //         }
                            //     }
                            // });

                        } else {
                            if (data.success) {
                                console.log('Utilisateur créé avec succès');
                            } else {
                                if (data.errorCode === -2) {
                                    console.log('Email already exists');
                                    addErrorMessage($('#guest-form input[name="email"]'), oDict["email_already_exists"]);
                                } else if (data.errorCode === -3 ) { // recaptcha
                                    addErrorMessage($('#guest-form input[name="password"]'), oDict["pwd_reset_bot_detected"]);
                                } else {
                                    console.log('Erreur lors de la création de l\'utilisateur');
                                }
                            }                  
                        }
                    },
                    error: function(xhr, status, error) {
                        console.log(baseUrl + $('#guest-form').attr('action'));
                        console.log('AJAX error: ' + error);
                    }
                });

            });
        });
    });

    function signup_verify() {
        var firstname_input = $('#signup-form input[name="firstname"]');
        var lastname_input = $('#signup-form input[name="lastname"]');
        var email_input = $('#signup-form input[name="email"]');
        var password_input = $('#signup-form input[name="password"]');
        // var gender_input = $('#signup-form select[name="gender"]');
    
        // Attacher l'événement input au champ de saisie
        firstname_input.on('input', function() {
            verifyAndDisableSubmitButton(firstname_input, lastname_input, email_input, password_input);
        });
        lastname_input.on('input', function() {
            verifyAndDisableSubmitButton(firstname_input, lastname_input, email_input, password_input);
        });
        email_input.on('input', function() {
            verifyAndDisableSubmitButton(firstname_input, lastname_input, email_input, password_input);
        });
        password_input.on('input', function() {
            verifyAndDisableSubmitButton(firstname_input, lastname_input, email_input, password_input);
        });
        // gender_input.on('input', function() {
        //     verifyAndDisableSubmitButton(firstname_input, lastname_input, email_input, password_input, gender_input);
        // });
    
        function verifyAndDisableSubmitButton(firstname_input, lastname_input, email_input, password_input) {
            var firstname = firstname_input.val().trim();
            var lastname = lastname_input.val().trim();
            var email = email_input.val().trim();
            var password = password_input.val().trim();
            // if(gender_input.length > 0)
            //     var gender = gender_input.val().trim();
            // else
            //     var gender = '';
    
            if (verifyErrors(firstname, lastname, email, password)) {
                $('#signup-form input[type="submit"]').prop('disabled', false);
            } else {
                $('#signup-form input[type="submit"]').prop('disabled', true);
            }
        }
    
        function verifyErrors(firstname, lastname, email, password) {
            if (firstname.length > 0 && lastname.length > 0 && email.length > 0 && password.length > 0) {
                if (!/^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/.test(email)) {
                    return false;
                }
                return true;
            }
            return false;
        }
    }    
    signup_verify();


    /*** LOGIN FORM SUBMISSION ***/

    $('#login-form').submit(function(e) {
        e.preventDefault(); // Empêche le rechargement de la page

        // Récupère les données du formulaire
        var formData = $(this).serialize();

        $('.error-message').remove();

        // Récupère les données du formulaire
        var email = $('#login-form input[name="email"]').val().trim();
        var password = $('#login-form input[name="password"]').val().trim();

        // Vérifie si les champs sont vides
        if (email === '') {
            addErrorMessage($('#login-form input[name="email"]'), oDict["enter_your_email"]);
        } else if (!/^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/.test(email)) {
            addErrorMessage($('#login-form input[name="email"]'), oDict["enter_valid_email"]);
        }

        if (password === '') {
            addErrorMessage($('#login-form input[name="password"]'), oDict["enter_your_password"]);
        }

        if($('#login-form .error-message').length > 0) {
            return;
        }

        var currentUrl = window.location.href;
        var urlObject = new URL(currentUrl);
        var baseUrl = urlObject.origin;

        $.ajax({
            url: baseUrl + $('#login-form').attr('action'),
            type: 'POST',
            data: formData,
            success: function(data, status, xhr) {
                var redirectUrl = xhr.getResponseHeader('Location');
                if (xhr.status === 201) {
                    var params = new URLSearchParams(window.location.search);
                    // Supprime le paramètre "key"
                    params.delete("key");

                    //if url contains /checkout/ then display a console.log
                    if (window.location.href.includes('/checkout/')) {
                        sendEventLogger('checkout_account_login');
                    }

                    // Récupère la nouvelle URL sans "key"
                    var loginUrl = params.get("login_url");
                    if(loginUrl) {
                        window.location.href = loginUrl;
                    } else {
                        //reload same url but removing "key" parameter if exists
                        var url = new URL(window.location.href);
                        url.searchParams.delete('key');
                        window.location.href = url;
                    }
                } else {
                    if (data.success) {
                        console.log('Utilisateur créé avec succès');
                    } else {
                        if (data.errorCode === -2) {
                            console.log('Email does not exists');
                            addErrorMessage($('#login-form input[name="email"]'), oDict["email_doesnt_exist"]);
                        } else if (data.errorCode === 0) {
                            console.log('Password does not match');
                            addErrorMessage($('#login-form input[name="password"]'), oDict["password_doesnt_match"]);
                        } else if (data.errorCode === -4) {
                            console.log('Your account is not verified yet, please check your email');
                            addErrorMessage($('#login-form input[name="password"]'), oDict["account_not_verified"]);

                            $('#verify_account-modal').attr('data-email', $('#login-form input[name="email"]').val().trim());
                            $.magnificPopup.close();
                            $.magnificPopup.open({
                                items: {
                                    src: $('#verify_account-modal'),
                                    closeMarkup: '',
                                    type: 'inline',
                                    closeBtnInside: false,
                                    closeOnBgClick: false,
                                },
                                closeOnBgClick: false,
                            });
                        } else {
                            console.log('Erreur lors de la création de l\'utilisateur');
                        }
                    }    
                }
            },
            error: function(xhr, status, error) {
                console.log(baseUrl + $('#login-form').attr('action'));
                console.log('AJAX error: ' + error);
            }
        });
    });

    $('#profile-form input').on('input', function(){
        $('#profile-form input[type="submit"]').show();
    });
    $('#profile-form select').on('change', function(){
        $('#profile-form input[type="submit"]').show();
    });
    $('#profile-form input[type="checkbox"]').on('change', function(){
        $('#profile-form input[type="submit"]').show();
    });

    /*** LOGIN CHECKOUT */
    $('#checkout-guest-form').submit(function(e) {
        e.preventDefault(); // Empêche le rechargement de la page

        checkGuestEmail( $('form#checkout-guest-form #email_address').val() );
    });

    /*** PROFILE FORM SUBMISSION ***/
    $('#profile-form').submit(function(e) {
        e.preventDefault(); // Empêche le rechargement de la page

        // Récupère les données du formulaire
        var formData = $(this).serialize();

        $('.error-message').remove();
        $('.success-message').remove();


        // Récupère les données du formulaire
        var firstname = $('#profile-form input[name="firstname"]').val().trim();
        var lastname = $('#profile-form input[name="lastname"]').val().trim();
        var phone = $('#profile-form input[name="phone"]').val().trim();
        var gender = $('#profile-form select[name="gender"]').val();
        // var birthday = $('#profile-form input[name="birthday"]').val().trim();
        var birthday_day = $('#profile-form select[name="birthday_day"]').val();
        var birthday_month = $('#profile-form select[name="birthday_month"]').val();
        var birthday_year = $('#profile-form select[name="birthday_year"]').val();
        var communication_style_drops = $('#profile-form input[name="communication-style-drops"]').val() === 'on' ? true : false;
        var communication_fashion_insights = $('#profile-form input[name="communication-fashion-insights"]').val() === 'on' ? true : false;
        var communication_stock_alerts = $('#profile-form input[name="communication-stock-alerts"]').val() === 'on' ? true : false;
        var communication_exclusive_offers = $('#profile-form input[name="communication-exclusive-offers"]').val() === 'on' ? true : false;
        var communication_cube_loyalty = $('#profile-form input[name="communication-cube-loyalty"]').val() === 'on' ? true : false;
        var ssn_number = $('#profile-form input[name="ssn"]').val().trim();
        var ein_number = $('#profile-form input[name="ein"]').val().trim();
        var customs_clearance = $('#profile-form input[name="customs-clearance"]').val() === 'on' ? true : false;

        // Vérifie si les champs sont vides
        if (firstname === '') {
            addErrorMessage($('input[name="firstname"]'), oDict["enter_valid_first_name"]);
        }

        if (lastname === '') {
            addErrorMessage($('input[name="lastname"]'), oDict["enter_valid_last_name"]);
        }
        
        if (birthday_day && !birthday_month) {
            addErrorMessage($('.account-area-section-profile-form-birthday'), oDict["birthday_missing"]);
        }
        if (!birthday_day && birthday_month) {
            addErrorMessage($('.account-area-section-profile-form-birthday'), oDict["birthday_missing"]);
        }
        if(ssn_number.length > 0 && ssn_number.length < 9) {
            addErrorMessage($('input[name="ssn"]'), oDict["ssn_length"]);
        }
        if(ein_number.length > 0 && ein_number.length < 9) {
            addErrorMessage($('input[name="ein"]'), oDict["ein_length"]);
        }

        if($('.error-message').length > 0) {
            return;
        }

        var currentUrl = window.location.href;
        var urlObject = new URL(currentUrl);
        var baseUrl = urlObject.origin;

        $.ajax({
            url: baseUrl + $('#profile-form').attr('action'),
            type: 'POST',
            data: formData,
            success: function(data, status, xhr) {
                var redirectUrl = xhr.getResponseHeader('Location');
                if (xhr.status === 201) {
                    $('#profile-form').append('<span class="success-message">' + oDict["profile_updated"] + '</span>');
                    setTimeout(function() {
                        $('.success-message').remove();
                    }, 15000);
                    $('#profile-form input[type="submit"]').hide();
                } else {
                    if (data.success) {
                        console.log('Utilisateur updaté avec succès');
                    } else {
                        console.log('Erreur lors de l\'update de l\'utilisateur');
                    }
                }
            },
            error: function(xhr, status, error) {
                console.log(baseUrl + $('#profile-form').attr('action'));
                console.log('AJAX error: ' + error);
            }
        });
    });
    // $('#profile-form input[name="birthday"]').on('input', function() {
    //     var value = $(this).val();
    //     var parts = value.split('-');
    
    //     if (parts.length === 3) {
    //         var year = parts[0];
            
    //         if (year.length > 4) {
    //             parts[0] = year.substring(0, 4);
    //             $(this).val(parts.join('-'));
    //         }
    //     }
    // });
    


    /*** SETTINGS FORM SUBMISSION ***/

    $('#settings-form').submit(function(e) {
        e.preventDefault(); // Empêche le rechargement de la page

        // Récupère les données du formulaire
        var formData = $(this).serialize();

        // Récupère les données du formulaire
        var country   = $('#settings-form select[name="delivery"]').val().trim();
        var language  = $('#settings-form select[name="language"]').val().trim();
        var currency  = $('#settings-form select[name="currency"]').val().trim();
        var email_com = $('#email-communication').prop('checked');
        var sms_com   = $('#sms-communication').prop('checked');

        var currentUrl = window.location.href;
        var urlObject = new URL(currentUrl);
        var baseUrl = urlObject.origin;

        $.ajax({
            url: baseUrl + $('#settings-form').attr('action'),
            type: 'POST',
            data: formData,
            success: function(data, status, xhr) {
                var redirectUrl = xhr.getResponseHeader('Location');
                if (xhr.status === 201) {
                    $('#settings-form').append('<span class="success-message">' + oDict["profile_updated"] + '</span>');
                    setTimeout(function() {
                        $('.success-message').remove();
                    }, 15000);
                } else {
                    if (data.success) {
                        console.log('Utilisateur updaté avec succès');
                    } else {
                        console.log('Erreur lors de l\'update de l\'utilisateur');
                    }
                }
            },
            error: function(xhr, status, error) {
                console.log(baseUrl + $('#settings-form').attr('action'));
                console.log('AJAX error: ' + error);
            }
        });
    });


    /*** NEWSLETTER FORM SUBMISSION ***/

    $('#newsletter_add').submit(function(e) {
        e.preventDefault(); // Empêche le rechargement de la page

        let email = $('#newsletter_add input[name="email"]').val().trim();

        $('.error-message').remove();

        if (email === '') {
            addErrorMessage($('#newsletter_add'), oDict["enter_your_email"]);
            return;
        } else if (!/^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/.test(email)) {
            addErrorMessage($('#newsletter_add'), oDict["enter_valid_email"]);
            return;
        }

        // Récupère les données du formulaire
        var formData = $(this).serialize();

        var currentUrl = window.location.href;
        var urlObject = new URL(currentUrl);
        var baseUrl = urlObject.origin;

        $.ajax({
            url: baseUrl + $('#newsletter_add').attr('action'),
            type: 'POST',
            data: formData,
            success: function(data, status, xhr) {
                var redirectUrl = xhr.getResponseHeader('Location');
                if (xhr.status === 201) {
                    //$('.homepage-newsletter').hide();
                    $('#email_newsletter').val('');
                    $('.newsletter_thanks .close-button, .newsletter_thanks .mfp-close').on('click', function(e) {
                        e.preventDefault();
                        $.magnificPopup.close();
                    });
                    $.magnificPopup.open({
                        items: {
                            src: $('.newsletter_thanks-modal'),
                            type: 'inline',
                            closeBtnInside: true,
                            modal: true,
                        },
                        closeOnBgClick: false,
                        callbacks: {
                            open: function() {
                                jQuery('body').addClass('noscroll');
                            },
                            close: function() {
                                jQuery('body').removeClass('noscroll');
                            }
                        }
                    });
                } else {
                    if(data.errorCode === -2) {
                        $('#newsletter_add').append('<span class="error-message">' + oDict["newsletter_subscription_already_exists"] + '</span>');
                    } else {
                        $('#newsletter_add').append('<span class="success-message">' + oDict["newsletter_subscription_error"] + '</span>');
                        setTimeout(function() {
                            $('.success-message').remove();
                        }, 15000);

                        console.log('Erreur lors de l\'update de l\'utilisateur');
                    }
                }
            },
            error: function(xhr, status, error) {
                console.log(baseUrl + $('#newsletter_add').attr('action'));
                console.log('AJAX error: ' + error);
            }
        });
    });


    $('#newsletter_popin_add').submit(function(e) {
        e.preventDefault(); // Empêche le rechargement de la page

        // Récupère les données du formulaire
        var formData = $(this).serialize();

        var currentUrl = window.location.href;
        var urlObject = new URL(currentUrl);
        var baseUrl = urlObject.origin;

        $.ajax({
            url: baseUrl + $('#newsletter_popin_add').attr('action'),
            type: 'POST',
            data: formData,
            success: function(data, status, xhr) {
                var redirectUrl = xhr.getResponseHeader('Location');
                if (xhr.status === 201) {
                    //$('.homepage-newsletter').hide();
                    $('#email_popin_newsletter').val('');
                    $('.newsletter_thanks .close-button, .newsletter_thanks .mfp-close').on('click', function(e) {
                        e.preventDefault();
                        $.magnificPopup.close();
                    });
                    $.magnificPopup.open({
                        items: {
                            src: $('.newsletter_thanks-modal'),
                            type: 'inline',
                            closeBtnInside: true,
                            modal: true,
                        },
                        closeOnBgClick: false,
                        callbacks: {
                            open: function() {
                                jQuery('body').addClass('noscroll');
                            },
                            close: function() {
                                jQuery('body').removeClass('noscroll');
                            }
                        }
                    });
                } else {
                    if(data.errorCode === -2) {
                        $('#newsletter_popin_add_err_msg').text(oDict["newsletter_subscription_already_exists"]);
                    } else {
                        $('#newsletter_popin_add_err_msg').text(oDict["newsletter_subscription_error"]);
                        setTimeout(function() {
                            $('.success-message').remove();
                        }, 15000);

                        console.log('Erreur lors de l\'update de l\'utilisateur');
                    }
                }
            },
            error: function(xhr, status, error) {
                console.log(baseUrl + $('#newsletter_popin_add').attr('action'));
                console.log('AJAX error: ' + error);
            }
        });
    });

    if (window.location.href.indexOf('account_verified=true') !== -1){
        var account_verified_url = new URL(window.location.href);
        var account_verified_params = new URLSearchParams(account_verified_url.search);
        if (account_verified_params.has('account_verified')) {
            account_verified_params.delete('account_verified');
            var modifiedUrl = account_verified_url.pathname + '?' + account_verified_params.toString();
            history.replaceState(null, null, modifiedUrl);
        }  
        $('.account_verified_popin .close-button, .account_verified_popin .mfp-close').on('click', function(e) {
            e.preventDefault();
            $.magnificPopup.close();
        });
        $.magnificPopup.open({
            items: {
                src: $('.account_verified_popin-modal'),
                type: 'inline',
                closeBtnInside: true,
                modal: true,
            },
            closeOnBgClick: false,
            callbacks: {
                open: function() {
                    jQuery('body').addClass('noscroll');
                },
                close: function() {
                    jQuery('body').removeClass('noscroll');
                }
            }
        });
    }

    
    /* Welcome popin */
    function checkCookie(name) {
        var decodedCookie = decodeURIComponent(document.cookie);
        var cookies = decodedCookie.split(';');
      
        for (var i = 0; i < cookies.length; i++) {
          var cookie = cookies[i].trim();
      
          if (cookie.indexOf(name + '=') === 0) {
            return true; // Le cookie existe
          }
        }
      
        return false; // Le cookie n'existe pas
      }

    var oConstant = JSON.parse(document.querySelector('[constant-json]').innerHTML);
    if ( oConstant["BID_MODE"] === undefined || oConstant["BID_MODE"] != "disabled" ) {
        // if(!checkCookie('welcome_popin') && $('.welcome_popin-modal').length > 0) {
        //     $('.welcome_popin .close-button, .welcome_popin .mfp-close').on('click', function(e) {
        //         e.preventDefault();
        //         $.magnificPopup.close();
        //     });
        //     setTimeout(function() {
        //         if (!$.magnificPopup.instance.isOpen){
        //             $.magnificPopup.open({
        //                 items: {
        //                     src: '.welcome_popin-modal'
        //                 },
        //                 type: 'inline',
        //                 closeOnBgClick: false,
        //                 callbacks: {
        //                     close: function () {
        //                         console.log('added cookie');
        //                         function setCookie(name, value) {
        //                             var expirationDate = new Date();

        //                             // Expire à la fin de la journée en cours
        //                             expirationDate.setHours(23, 59, 59, 999);

        //                             var cookieValue = encodeURIComponent(value) + '; expires=' + expirationDate.toUTCString() + '; path=/';
        //                             document.cookie = name + '=' + cookieValue;
        //                         }

        //                         setCookie('welcome_popin', 'true');
        //                     }
        //                 }
        //             });
        //         }
        //     }, 40000);
        // }

        if(checkCookie('tfs_ce') && !checkCookie('newsletter_popin') && $('.newsletter_popin-modal').length > 0) {
            $('.newsletter_popin .close-button, .newsletter_popin .mfp-close').on('click', function(e) {
                e.preventDefault();
                $.magnificPopup.close();
            });
            // setTimeout(function() {
            //     if(!checkCookie('newsletter_popin') && !checkCookie('newsletter_sent') && $('.newsletter_popin-modal').length > 0){
            //         if (!$.magnificPopup.instance.isOpen){
            //             $.magnificPopup.open({
            //                 items: {
            //                     src: '.newsletter_popin-modal'
            //                 },
            //                 type: 'inline',
            //                 closeOnBgClick: false,
            //                 callbacks: {
            //                     close: function () {
            //                         console.log('added cookie');
            //                         function setCookie(name, value) {
            //                             var expirationDate = new Date();

            //                             // Expire à la fin de la journée en cours
            //                             expirationDate.setHours(23, 59, 59, 999);

            //                             var cookieValue = encodeURIComponent(value) + '; expires=' + expirationDate.toUTCString() + '; path=/';
            //                             document.cookie = name + '=' + cookieValue;
            //                         }

            //                         setCookie('newsletter_popin', 'true');
            //                     }
            //                 }
            //             });
            //         }
            //     }
            // }, 40000);
        }
    }

    if(!checkCookie('wishlist_steps_popin') && $('.wishlist_steps_popin-modal').length > 0) {
        $('.wishlist_steps_popin .close-button, .wishlist_steps_popin .mfp-close').on('click', function(e) {
            e.preventDefault();
            $.magnificPopup.close();
        });
        setTimeout(function() {
            if (!$.magnificPopup.instance.isOpen){
                $.magnificPopup.open({
                    items: {
                        src: '.wishlist_steps_popin-modal'
                    },
                    type: 'inline',
                    closeOnBgClick: false,
                    callbacks: {
                        close: function () {
                            if($('.account-area-section-moodboard-item-products').length > 0) {
                                console.log('added cookie');
                                function setCookie(name, value) {
                                    var expirationDate = new Date();

                                    // Expire à la fin de la journée en cours
                                    expirationDate.setHours(23, 59, 59, 999);

                                    var cookieValue = encodeURIComponent(value) + '; expires=' + expirationDate.toUTCString() + '; path=/';
                                    document.cookie = name + '=' + cookieValue;
                                }

                                setCookie('wishlist_steps_popin', 'true');
                            }
                        }
                    }
                });
            }
        }, 1000);
    }

    $('.open_newsletter_popin').click(function(e) {
        $.magnificPopup.open({
            items: {
                src: '.newsletter_popin-modal'
            },
            type: 'inline',
            closeOnBgClick: false,
        });
    });
    
    /* Tilt active */
    $('.tilt-active').tilt({
        maxTilt: 10,
        perspective: 1000,
        easing: 'cubic-bezier(.03,.98,.52,.99)',
        speed: 1200,
        glare: true,
        maxGlare: 0.4,
        scale: 1
    });
    
    /*-----------------------
        Shop filter active 
    ------------------------- */
    $('.shop-filter-active').on('click', function(e) {
        e.preventDefault();
        $('.product-filter-wrapper').slideToggle();
    })
    
    /*---------------------
        Price slider
    --------------------- */
    var sliderrange = $('#slider-range');
    var amountprice = $('#amount');
    $(function() {
        sliderrange.slider({
            range: true,
            min: 13,
            max: 100,
            values: [0, 80],
            slide: function(event, ui) {
                amountprice.val("$" + ui.values[0] + " - $" + ui.values[1]);
            }
        });
        amountprice.val("$" + sliderrange.slider("values", 0) +
            " - $" + sliderrange.slider("values", 1));
    });
    
    // Instantiate EasyZoom instances
    var $easyzoom = $('.easyzoom').easyZoom();
    
    /*--
        Product details big image slider
    -----------------------------------*/
    $('.pro-dec-big-img-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        draggable: false,
        fade: false,
        asNavFor: '.product-dec-slider',
    });

    /*--
        Product details slider active
    -----------------------------------*/
    $('.product-dec-slider').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        vertical: false,
        asNavFor: '.pro-dec-big-img-slider',
        dots: false,
        focusOnSelect: true,
        fade: false,
        prevArrow: '<span class="pro-dec-icon pro-dec-prev"><i class="fa fa-angle-left"></i></span>',
        nextArrow: '<span class="pro-dec-icon pro-dec-next"><i class="fa fa-angle-right"></i></span>',
        responsive: [{
                breakpoint: 767,
                settings: {
                }
            },
            {
                breakpoint: 420,
                settings: {
                    autoplay: true,
                    slidesToShow: 2,
                }
            }
        ]
    });
    
    /*--
        Product details slider 2
    -----------------------------------*/
    $('.pro-dec-big-img-slider-2').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        draggable: false,
        fade: false,
        asNavFor: '.product-dec-slider-2',
    });
    
    /*--
        Product details 2 slick carousel as Nav
    --------------------------------------------*/
    $('.product-dec-slider-2').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        vertical: true,
        asNavFor: '.pro-dec-big-img-slider-2',
        dots: false,
        focusOnSelect:true,
        fade: false,
        prevArrow: '<span class="pro-dec-icon-2 pro-dec-prev-2"><i class="fa fa-angle-up"></i></span>',
        nextArrow: '<span class="pro-dec-icon-2 pro-dec-next-2"><i class="fa fa-angle-down"></i></span>',
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    
                }
            },
            {
                breakpoint: 420,
                settings: {
                    autoplay: true,
                    slidesToShow: 3,
                }
            }
        ]
    });
    
    /*----------------------------
    	Cart Plus Minus Button
    ------------------------------ */
    var CartPlusMinus = $('.cart-plus-minus');
    CartPlusMinus.prepend('<div class="dec qtybutton">-</div>');
    CartPlusMinus.append('<div class="inc qtybutton">+</div>');
    $(".qtybutton").on("click", function() {
        var $button = $(this);
        var oldValue = $button.parent().find("input").val();
        if ($button.text() === "+") {
            var newVal = parseFloat(oldValue) + 1;
        } else {
            // Don't allow decrementing below zero
            if (oldValue > 0) {
                var newVal = parseFloat(oldValue) - 1;
            } else {
                newVal = 1;
            }
        }
        $button.parent().find("input").val(newVal);
    });
    
    /*-----------------------
        Login register active 
    ------------------------- */
    $('.vendor-close').click(function(){
        $('.vendor-customar-active').slideDown('fast');
    });
    $('.vendor-active').click(function(){
        $('.vendor-customar-active').slideUp(400);
    });
    
    /*--- showlogin toggle function ----*/
    $('.checkout-click').on('click', function(e) {
        e.preventDefault();
        $('.checkout-login-info').slideToggle(1000);
    });
    /*--- showlogin toggle function ----*/
    $('.checkout-click-2').on('click', function(e) {
        e.preventDefault();
        $('.checkout-login-info-2').slideToggle(1000);
    });
    
    /*-------------------------
        Create an account toggle
    --------------------------*/
    $('.checkout-toggle2').on('click', function() {
        $('.open-toggle2').slideToggle(1000);
    });
    
    /*-------------------------
    Create an account toggle
    --------------------------*/
    $('.checkout-ship').on('click', function() {
        $('.checkout-ship-open').slideToggle(1000);
    });
    
    /*-------------------------
        Checkout toggle function
    --------------------------*/
    var checked = $( '.sin-payment input:checked' )
    if(checked){
        $(checked).siblings( '.payment-box' ).slideDown(900);
    };
	 $( '.sin-payment input' ).on('change', function() {
        $( '.payment-box' ).slideUp(900);
        $(this).siblings( '.payment-box' ).slideToggle(900);
    });
    
    /*---------------------
        Select active
    --------------------- */
    $('.select-active').select2();
    
    /*---------------------
        Countdown
      --------------------- */
    // $('.timer [data-countdown]').each(function() {
    //     var $this = $(this),
    //         finalDate = $(this).data('countdown');
    //     $this.countdown(finalDate, function(event) {
    //         $this.html(event.strftime('<span class="cdown years"> <span>%-Y </span><p>Years</p></span> <span class="cdown month"> <span>%-M </span><p>Months</p></span> <span class="cdown week"> <span>%-w </span><p>Weeks</p></span> <span class="cdown day"> <span>%-D </span><p>Days</p></span> <span class="cdown hour"> <span> %-H</span> <p>Hrs</p></span> <span class="cdown minutes"><span>%M</span> <p>Mins</p></span class="cdown second"> <span> <span>%S</span> <p>Secs</p></span>'));
    //     });
    // });
    
    /*---------------------
        Countdown 2
      --------------------- */
    // $('.timer-2 [data-countdown]').each(function() {
    //     var $this = $(this),
    //         finalDate = $(this).data('countdown');
    //     $this.countdown(finalDate, function(event) {
    //         $this.html(event.strftime('<span class="cdown day"> <span>%-D </span><p>Days</p></span> <span class="cdown hour"> <span> %-H</span> <p>Hrs</p></span> <span class="cdown minutes"><span>%M</span> <p>Mins</p></span class="cdown second"> <span> <span>%S</span> <p>Secs</p></span>'));
    //     });
    // });
    
    /*---------------------
       Circular Bars - Knob
    --------------------- */	
    if(typeof($.fn.knob) != 'undefined') {
        $('.knob').each(function () {
            var $this = $(this),
              knobVal = $this.attr('data-rel');
            $this.knob({
                'draw' : function () { 
                  $(this.i).val(this.cv + '%')
                }
            });
          $this.appear(function() {
            $({
              value: 0
            }).animate({
              value: knobVal
            }, {
              duration : 2000,
              easing   : 'swing',
              step     : function () {
                $this.val(Math.ceil(this.value)).trigger('change');
              }
            });
          }, {accX: 0, accY: -150});
        });
    }
    
    /*--------------------------
    counterUp
    ---------------------------- */
    $('.count').counterUp({
        delay: 10,
        time: 5000
    });
    
    /*---------------------
        Sidebar sticky active
    --------------------- */
    $('.sidebar-sticky').stickySidebar({
        topSpacing: 40,
        bottomSpacing: 30,
        minWidth: 991,
    });
    
    /*---------------------
        Sidebar active
    --------------------- */
    $('.sidebar-sticky-2').stickySidebar({
        topSpacing: 121, 
        bottomSpacing: 50,
        minWidth: 991,
    });


    /**** CUSTOM JS */
    $(document).on("click", ".pro-sidebar-title", function(e) {
        $(this).siblings('.shop-sidebar-box').find('.sidebar-widget-list').toggleClass('active');
        $(this).siblings('.sidebar-widget-list-filtered').toggleClass('inactive');
        $(this).siblings('.shop-sidebar-box').find('#brandSearch').toggleClass('active');
        $(this).toggleClass('active');
    });
    $(document).on("click", ".sidebar-widget-list-filtered", function(e) {
        $(this).siblings('.pro-sidebar-title').click();
    });

    // Search brand in category brand filter
    //function filterSearch(){
        $(document).on("input", "#brandSearch", function() {
            console.log('search');
            var searchText = $(this).val().trim().toLowerCase();
      
            var brandItems = $(".sidebar-widget-list li");
      
            brandItems.each(function() {
              var brandName = $(this).find("a").text().toLowerCase();
      
              if (searchText === "" || brandName.includes(searchText)) {
                $(this).show();
              } else {
                $(this).hide();
              }
            });
          });

          $(document).on("input", "#brandSearchMobile", function() {
            console.log('searchMobile');
            var searchText = $(this).val().trim().toLowerCase();
      
            var brandItems = $("div[data-cat='brandId'] .shop-area-mobile-filters-section-choices label");
      
            brandItems.each(function() {
              var brandName = $(this).text().toLowerCase();
      
              if (searchText === "" || brandName.includes(searchText)) {
                //$(this).show();
                $(this).parent().show();
              } else {
                //$(this).hide();
                $(this).parent().hide();
              }
            });
          });
    //}
    //filterSearch();
    

    /* CATEGORY FILTERS */
    // LIST VIEW

    

    //$('.shop-area .sidebar-widget:first-of-type .pro-sidebar-title').click();


    // SELECTED FILTER
    /*$('.shop-area-mobile-filters-section-entries a').click(function(e){
        e.preventDefault();
        var cat = $(this).attr('data-cat');
        $('.shop-area-mobile-filters-selected[data-cat="'+cat+'"]').addClass('active');
        $('.shop-area-mobile-filters-selected .shop-area-mobile-filters-submit').hide();
    });
    $('.shop-area-mobile-filters-selected .shop-area-mobile-filters-submit-btn').click(function(){
        $('.shop-area-mobile-filters-selected').removeClass('active');

        
        displayCategoryProductsMobile(checkFilters());
    });*/
    $('.shop-area-mobile-filters-selected .shop-area-mobile-filters-close').click(function(){
        $('.shop-area-mobile-filters-selected').removeClass('active');
    });

    function checkFilters(){
        var values = {};
        $('.shop-area-mobile-filters-selected').each(function(){      
            var cat = $(this).attr('data-cat');      
            $(this).find('.shop-area-mobile-filters-section-filter input').each(function(){
                if($(this).is(':checked')){
                    if (!values[cat]) {
                        values[cat] = [];
                    }
                    values[cat].push($(this).attr('data-filter-value'));
                }
            });
        });

        // On ajoute la catégorie de la page courante
        if (!values['catId'] || !Array.isArray(values['catId'])) {
            values['catId'] = [];
            if($('.products-list-display-results').attr('data-inter-cat-name') != ""){
                var currentCat = $('.products-list-display-results').attr('data-inter-cat-value');
            }else{
                var currentCat = $('.products-list-display-results').attr('data-cat');
            }
            values['catId'].push(currentCat);
        }
        console.log('checkFilters')
        console.log(values);
        return values;
    }


    /*** MY ACCOUNT ***/
    /* ORDER ITEM SHOW DETAILS */
    // $('.account-area-section-orders-item-summary').click(function(){
    //     var details = $(this).siblings('.account-area-section-orders-item-details');
    //     if (details.hasClass('inactive')) {
    //         $('.account-area-section-orders-item-details').addClass('inactive');
    //         details.removeClass('inactive');
    //         //scroll to the top of the item
    //         $('html, body').animate({
    //             scrollTop: $(this).offset().top - 200
    //         }, 500);
    //     } else {
    //         $('.account-area-section-orders-item-details').addClass('inactive');
    //     }
    // });
    
    /* ORDERS AND RETURNS FILTER */
    $('.return-item').hide();
    $('input[name="status"]').change(function() {
        var selectedStatus = $(this).attr('id');
        if (selectedStatus === 'orders') {
          $('.order-item').show();
          $('.return-item').hide();
        } else if (selectedStatus === 'returns') {
          $('.order-item').hide();
          $('.return-item').show();
        }
      });

    /* REMOVE PAYMENT METHOD */
    $('.account-area-section-payments-remove').click(function(){

        // if($(this).attr('data-default') == 'true'){
        //     $(this).text( oDict["see_new_default_payment_before_delete"] );
        //     $(this).addClass('active');
        //     return;
        // }

        if($(this).attr('confirm') != 'true'){
            $(this).attr('confirm', 'true');
            $(this).text( oDict["payment_method_confirm_deletion"]);
            return;
        }
        

        var formData = {
            'data-type': $(this).attr('data-type'),
            'data-fgp': $(this).attr('data-fgp')
        };

        var fullUrl = window.location.href;
        var urlObject = new URL(fullUrl);
        var baseUrl = urlObject.origin + urlObject.pathname.split('/account')[0];

        $.ajax({
            url: baseUrl + "/account/delete-payment/",
            type: 'POST',
            data: formData,
            success: function(data, status, xhr) {
                var redirectUrl = xhr.getResponseHeader('Location');
                if (xhr.status === 201) {
                    $('.account-area-section-payments-items-item[data-fgp=' + formData['data-fgp'] + ']').remove();

                    if($('.account-area-section-payments-items-item').length == 0){
                        window.location.reload();
                    }
                } else {
                    if (data.success) {
                        console.log('Payment deleted with success');
                    } else {
                        if (data.errorCode === 0) {
                           
                        } else {
                            console.log('Error during data delete');
                        }
                    }    
                }
            },
            error: function(xhr, status, error) {
                // Gère les erreurs de la requête AJAX
                console.log('AJAX error: ' + error);
            }
        });

    });

    /* SET DEFAULT METHOD PAYMENT */
    $('.account-area-section-payments-default').click(function(){

        var formData = {
            'data-id': $(this).attr('data-id')
        };

        var fullUrl = window.location.href;
        var urlObject = new URL(fullUrl);
        var baseUrl = urlObject.origin + urlObject.pathname.split('/account')[0];

        $.ajax({
            url: baseUrl + "/account/default-payment/",
            type: 'POST',
            data: formData,
            success: function(data, status, xhr) {
                var redirectUrl = xhr.getResponseHeader('Location');
                if (xhr.status === 201) {
                    var clean_uri = location.protocol + "//" + location.host + location.pathname;
                    window.location.href = clean_uri;
                } else {
                    if (data.success) {
                        console.log('Payment deleted with success');
                    } else {
                        if (data.errorCode === 0) {
                           
                        } else {
                            console.log('Error during data delete');
                        }
                    }    
                }
            },
            error: function(xhr, status, error) {
                // Gère les erreurs de la requête AJAX
                console.log('AJAX error: ' + error);
            }
        });

    });

    // $(document).on("click", ".account-area-section-payments-select", function(e) {
    //     var payment = $(this).attr('data-id');

    //     var url = new URL(window.location.href);
    //     url.searchParams.delete('payment_method');
    //     url.searchParams.append('payment_method', payment);

    //     window.location.href = url.href;

    // });
    $(document).on("click", ".account-area-section-payments-select", function(e) {
        var payment = $(this).attr('data-id');

        var url = new URL(window.location.href);
        var typeTransaction = url.searchParams.get('act');
        var transactionId = url.searchParams.get('key');
        changePaymentMethod(e, payment, typeTransaction, transactionId);

    });

    //on receive trigger paymentChangeEvent
    document.addEventListener('paymentChangeEvent', function(e) {
        changePaymentMethod(e, e.detail.payment, e.detail.typeTransaction, e.detail.transactionId);
    });

    document.addEventListener('event_checkout_payment_saved', function(e) {
        if(e.detail.error_code){
            sendEventLogger('checkout_payment_saved', {'status': e.detail.status, 'error': { code: e.detail.error_code, message: e.detail.error_message, type: e.detail.error_type }});
        }else if(e.detail.error){
            sendEventLogger('checkout_payment_saved', {'status': e.detail.status, 'error': e.detail.error});
        }
        else{
            sendEventLogger('checkout_payment_saved', {'status': e.detail.status});
        }
    });
    
    document.addEventListener('event_confirm_setup_intent', function(e) {
        if(e.detail.error){
            sendEventLogger('confirm_setup_intent', {'status': e.detail.status, 'error': e.detail.error});
        }else{
            sendEventLogger('confirm_setup_intent', {'status': e.detail.status});
        }
    });

    async function changePaymentMethod(e, payment, typeTransaction, transactionId) {
        e.preventDefault();
        const response = await fetch("/update-payment-transaction", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ payment_id: payment, type_transaction: typeTransaction, transaction_id: transactionId }),
        }).then((r) => r.json());

        if (response.success) {  
            var payment_info = "";

            if(response.type == "card"){
                payment_info = `${response.type.charAt(0).toUpperCase() + response.type.slice(1)}<br>(${String(response.card_brand).charAt(0).toUpperCase() + response.card_brand.slice(1)} ${oDict["payment_ending_in"]} ${response.card_last4})`;
            }else if(response.type == "paypal"){
                const email = response.paypal_email; // L'email à tronquer
                const truncatedEmail = email.length > 24 ? `${email.slice(0, 24)}*` : email;
                payment_info = `${response.type.charAt(0).toUpperCase() + response.type.slice(1)}<br>(${truncatedEmail})`;
            }else{
                payment_info = `${response.type.charAt(0).toUpperCase() + response.type.slice(1)}`;
            }

            var provider_psp = response.psp;
            console.log('provider_psp=' + provider_psp);
            if(response.psp != "stripe" && response.psp != "adyen"){
                if(response.stripe_payment_method != ""){
                    provider_psp = "stripe";
                }else{
                    provider_psp = "adyen";
                }
            }
            $('.payment_provider').attr('data-provider', provider_psp);

            $(".method_overlay").addClass('hidden');
            $(".method_overlay_content.step1").addClass('hidden');

            $(".bid-area-section-content-details-additional_infos-right-payment").html(payment_info);
  
            function decodeHtml(html) {
              var txt = document.createElement("textarea");
              txt.innerHTML = html;
              return txt.value;
            }
  
            $('.account-area-section-payments-items').html(decodeHtml(response.html));
            $('.bid-area-section-content-steps').empty().append(decodeHtml(response.html_checkout_btn));
            $('.change_payment-btn').show();

            if($('.checkout-container-left-payment-method-list').length > 0 && $('.checkout-container-left-payment-method-list-item[data-id="' + payment + '"]').length == 0){
                var new_payment = "<div data-id='" + payment + "' class='checkout-container-left-payment-method-list-item active'>";
                new_payment += "<span>" + response.type.charAt(0).toUpperCase() + response.type.slice(1) + "</span>";
                if(response.type == "card"){
                    new_payment += "<span>" + String(response.card_brand).charAt(0).toUpperCase() + response.card_brand.slice(1) + " (" + oDict["payment_ending_in"] + " " + response.card_last4 + ")</span>";
                }else if(response.type == "paypal"){
                    const email = response.paypal_email; // L'email à tronquer
                    const truncatedEmail = email.length > 24 ? `${email.slice(0, 24)}*` : email;
                    new_payment += "<span>" + truncatedEmail + "</span>";
                }else{
                    new_payment += "<span></span>";
                }
                new_payment += "</div>";

                console.log(new_payment);
                //add new payment method to the list of payment methods
                $('.checkout-container-left-payment-method-list-item').removeClass('active');
                $('.checkout-container-left-payment-method-list').append(new_payment);

                $('.checkout-container-left-btns #confirmOrder').prop('disabled', false);
            }

  
            $.magnificPopup.close();
        }
    }


    /* New address model */

    $(document).on("click", ".account-area-section-address-select", function(e) {
        var address = $(this).attr('data-id');

        var url = new URL(window.location.href);
        var typeTransaction = url.searchParams.get('act');
        var transactionId = url.searchParams.get('key');
        changeAddress(e, address, typeTransaction, transactionId);

    });

    //on receive trigger paymentChangeEvent
    document.addEventListener('addressChangeEvent', function(e) {
        changeAddress(e, e.detail.address, e.detail.typeTransaction, e.detail.transactionId);
    });

    async function changeAddress(e, address, typeTransaction, transactionId) {
        e.preventDefault();
        //get sgz and lang from current url as /sgz/lang/
        var url = new URL(window.location.href);
        var sgz = url.pathname.split('/')[1];
        var lang = url.pathname.split('/')[2];
        const response = await fetch("/" + sgz + "/" + lang + "/update-address-transaction", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ delivery_id: address, type_transaction: typeTransaction, transaction_id: transactionId }),
        }).then((r) => r.json());

        if (response.success) {  
            if($('.bid-area').length > 0)
                sendEventLogger('checkout_address_saved')

            var address_info = "";

            address_info = `${response.first_name} ${response.last_name}<br>${response.address_1}<br>${
                response.address_2 ? `${response.address_2}<br>` : ""
            }${response.zipcode} ${response.city}<br>${response.country.toUpperCase()}`;

            function decodeHtml(html) {
                var txt = document.createElement("textarea");
                txt.innerHTML = html;
                return txt.value;
              }

            $('#change_address_delivery-modal .account-area-section-address').html(decodeHtml(response.html));
              
            $(".bid-area-section-content-details-additional_infos-right-address").html(address_info);

            $('#account-area-section-address-form input[type="submit"]').prop('disabled', false);
            $('#account-area-section-address-form input[type="submit"]').val(oDict["save_address"]);
            $.magnificPopup.close();

            $('.change_address-btn').show();

            $('.bid-area-section-content-steps').empty().append(decodeHtml(response.html_checkout_btn));

            return true;
        }else{
            return false;
        }
    }

    async function changeAddressBilling(e, address, typeTransaction, transactionId) {
        e.preventDefault();
        var url = new URL(window.location.href);
        var sgz = url.pathname.split('/')[1];
        var lang = url.pathname.split('/')[2];
        const response = await fetch("/" + sgz + "/" + lang + "/update-address-transaction", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ delivery_id: address, type_transaction: typeTransaction, transaction_id: transactionId, billing: true }),
        }).then((r) => r.json());

        if (response.success) {  
            return true;
        }else{
            return false;
        }
    }

    $('.checkout-container-left-payment-billing-section-selector').click(function(e){
        e.preventDefault();
        $('.checkout-container-left-payment-billing-section-selector').removeClass('active');
        $(this).addClass('active');
        if($(this).attr('data-billing') == "different"){
            $('.checkout-container-left-payment-billing-section-selector-form').show();
        }else{
            $('.checkout-container-left-payment-billing-section-selector-form').hide();
        }
    });

    async function getAddresses() {
        var url = new URL(window.location.href);
        var sgz = url.pathname.split('/')[1];
        var lang = url.pathname.split('/')[2];

        const response = await fetch("/" + sgz + "/" + lang + "/get-user-addresses", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ }),
        }).then((r) => r.json());

        if (response.success) {  
            function decodeHtml(html) {
                var txt = document.createElement("textarea");
                txt.innerHTML = html;
                return txt.value;
              }

            $('.account-area-section-address-list').html(decodeHtml(response.html));
              
            $('#account-area-section-address-form input[type="submit"]').prop('disabled', false);
            $('#account-area-section-address-form input[type="submit"]').val(oDict["save_address"]);
            $.magnificPopup.close();
        }
    }

    /* Ending new address model */

    // $('.account-area-section-address-select').on('click', function(e) {
    //     e.preventDefault();
    //     var delivery_address = $(this).attr('data-id');

    //     var url = new URL(window.location.href);
    //     url.searchParams.delete('delivery_address');
    //     url.searchParams.append('delivery_address', delivery_address);

    //     window.location.href = url.href;
    // });

    function checkoutBuyNowKey(){
        var url = window.location.href;
        var params = new URLSearchParams(window.location.search);

        // Vérifie si le paramètre 'act' existe et a la valeur 'bn'
        if (params.has('act') && params.get('act') === 'bn') {
            // Vérifie si le paramètre 'key' n'existe pas
            if (!params.has('key')) {
                // Ajoute le paramètre 'key=true'
                params.append('key', $('input#buykey').val());
                // Construit la nouvelle URL
                var newUrl = url.split('?')[0] + '?' + params.toString();
                // Change l'URL dans la barre d'adresse
                history.pushState({}, "", newUrl);
            }
        }
    }
    checkoutBuyNowKey();

    
    // $('.open-change_payment_method-modal').magnificPopup({
    //     type: 'inline',
    //     closeMarkup: '<button title="%title%" type="button" class="mfp-close mfp-fade-out"><img style="width: 25px;margin: 17px 20px 0 0;cursor: pointer;" src="/assets/251129145240/images/icon-img/big-close.svg" alt="Fermer" /></button>',
    //     callbacks: {
    //         open: function() {
    //             $('.mfp-close').on('click', function() {
    //                 $.magnificPopup.close(); // Fermer la popup lors du clic sur le bouton de fermeture
    //             });
    //             }
    //         }
    // });

    $(document).on('click', '.open-change_payment_method-modal', function(e) {
        e.preventDefault(); // Empêche le comportement par défaut du bouton (si c'est un lien)
        $.magnificPopup.open({
            items: {
                src: $(this).attr('href') || '#popup-content', // Lien vers le contenu inline
                type: 'inline'
            },
            closeMarkup: '<button title="%title%" type="button" class="mfp-close mfp-fade-out"><img style="width: 25px;margin: 17px 20px 0 0;cursor: pointer;" src="/assets/251129145240/images/icon-img/big-close.svg" alt="Fermer" /></button>',
            callbacks: {
                open: function() {
                    $('.mfp-close').on('click', function() {
                        $.magnificPopup.close(); // Fermer la popup lors du clic sur le bouton de fermeture
                    });
                    if($('.bid-area').length > 0)
                        sendEventLogger('checkout_payment_open');
                }
            }
        });
    });

    $('.open-change_address_delivery-modal').magnificPopup({
        type: 'inline',
        closeOnBgClick: false,
        // fixedContentPos: true,
        closeMarkup: '<button title="%title%" type="button" class="mfp-close mfp-fade-out"><img style="width: 25px;margin: 17px 20px 0 0;cursor: pointer;" src="/assets/251129145240/images/icon-img/big-close.svg" alt="Fermer" /></button>',
        callbacks: {
            open: function() {
                var regex = /@privaterelay\.appleid\.com$/;
                var email = $('#form_address_popin-modal input[type="email"][name="email_address"]').data('default-email');
                var emailData = "";
                if (regex.test(email)) {
                    console.log("L'adresse email termine par @privaterelay.appleid.com");
                    emailData = "";
                    $('#form_address_popin-modal input[type="email"][name="email_address"]').val('')
                }

                if($('.bid-area').length > 0)
                    sendEventLogger('checkout_address_open')

                $('.mfp-close').on('click', function() {
                    $.magnificPopup.close(); // Fermer la popup lors du clic sur le bouton de fermeture
                });
                }
            }
    });


    /*** PAGES FOOTER ***/
    /* DROPDOWNS */
    $('.page-area-dropdown-content').hide();
    $('.page-area-dropdown-title').click(function(){
        // active class on the parent
        if($(this).parent().hasClass('active')){
            $(this).parent().removeClass('active');
            $(this).siblings('.page-area-dropdown-content').hide();
        } 
        else {
            $(this).parent().addClass('active');
            $(this).siblings('.page-area-dropdown-content').show();
        }
    });

    /*** PRODUCT PAGE ***/

    $('#accordion_product_details').click(function(){
        if (typeof gtag === 'function') {
            gtag("event", "see_product_details", { });
        }
    });
    $('#accordion_size_fit').click(function(){
        if (typeof gtag === 'function') {
            gtag("event", "see_size_fit", { });
        }
    });
    $('#accordion_delivery_returns').click(function(){
        if (typeof gtag === 'function') {
            gtag("event", "see_delivery_returns", { });
        }
    });
    $('#see_trustpilot').click(function(){
        if (typeof gtag === 'function') {
            gtag("event", "see_trustpilot", { });
        }
    });

    /* SIZE SELECTOR */
    $('.product-size__choices').css('display', 'grid');
    $('.product-size__choices').slideUp(0);

    //on click everywhere except on the size selector
    $(document).mouseup(function(e) {
        var container = $(".product-size__choices");
        var select = $(".product-size__choices__select");
        if (!container.is(e.target) && container.has(e.target).length === 0 && !select.is(e.target) && select.has(e.target).length === 0) {
            container.slideUp(200);
            container.removeClass('open');
            $('.product-size__choices__select').removeClass('active');
        }
    });
    //if we scroll the page and we don't see the size selector anymore
    $.fn.isInViewport = function() {
        var elementTop = $(this).offset().top;
        var elementBottom = elementTop + $(this).outerHeight();
    
        var viewportTop = $(window).scrollTop();
        var viewportBottom = viewportTop + $(window).height();
    
        return elementBottom > viewportTop && elementTop < viewportBottom;
    };
    
    $(window).scroll(function() {
        var container = $(".product-size__choices");
        if (container.hasClass('open') && !container.isInViewport()) {
            container.slideUp(200);
            container.removeClass('open');
            $('.product-size__choices__select').removeClass('active');
        }
    });
    

    $('.product-size__choices__select:not(.singlesize)').click(function() {
        const $choicesElement = $(this).next('.product-size__choices');

        sendEventLogger('size_selector_open');
    
        const isOpen = $choicesElement.hasClass('open');
        if (isOpen) {
            $(".product-size__choices").slideUp(200); // Fermer l'élément si déjà ouvert
            $(".product-size__choices").removeClass('open');
        } else {
            $(".product-size__choices").slideUp(200); // Fermer l'élément si déjà ouvert
            $(".product-size__choices").removeClass('open');
            $choicesElement.slideDown(200); // Ouvrir l'élément si fermé
            $choicesElement.addClass('open');

            if (typeof gtag === 'function') {
                gtag("event", "select_size", {});
            }
        }
    
        if (!$(this).hasClass('inactive')) {
            $(this).toggleClass('active');
        }
    });
    /* SIZE SELECTOR - WISHLIST SELECTION AUTO */
    $('.product-size__choices__select').each(function() {
        var selectElement = $(this);
        var wishlistData = selectElement.attr('data-wishlist');
        var choicesItems = selectElement.siblings('.product-size__choices').find('.product-size__choices__item');
        
        choicesItems.each(function() {
          var itemElement = $(this);
          var sizeData = itemElement.attr('data-size');
          //console.log(sizeData);
          
          if (wishlistData === sizeData) {
            var itemText = itemElement.text();
            selectElement.text(itemText);
            return false; // Sortir de la boucle each une fois l'équivalence trouvée
          }
        });
    });   
    
    $( document ).on( "sizeSelected", {}, function( event, productId, size ) {
        var currentUrl = window.location.href;
        var urlObject = new URL(currentUrl);
        var baseUrl = urlObject.origin;

        var gender = "";
        if(gender_page_data){
            gender = gender_page_data;
        }

        var formData = {
            'size': size,
            'product': productId,
            'gender': gender
        };

        $.ajax({
            url: baseUrl + "/update-recently-viewed",
            type: 'POST',
            data: formData,
            success: function(data, status, xhr) {
                var redirectUrl = xhr.getResponseHeader('Location');
                if (xhr.status === 201) {
                    console.log('Recently viewed updated with success');
                } else {
                    console.log('Error during recently viewed update');
                }
            },
            error: function(xhr, status, error) {
                // Gère les erreurs de la requête AJAX
                console.log('AJAX error: ' + error);
            }
        });
    });

    //Centrer le sélecteur de taille en mobile sur la taille selected
    if ($('.product-size__choices').find('.product-size__choices__item.active').length) {
        const containerWidth = $('.product-size__choices').outerWidth();
        const itemOffset = $('.product-size__choices').find('.product-size__choices__item.active').position().left;
        const itemWidth = $('.product-size__choices').find('.product-size__choices__item.active').outerWidth();
        const scrollLeft = itemOffset - (containerWidth / 2) + (itemWidth / 2);
        $('.product-size__choices').animate({ scrollLeft: scrollLeft }, 400);
    }


    /** Début code sélecteur taille en mode select */
    $('.product-size__choices__item').click(function( ){

        const $choicesItem = $(this);
        const $choicesSelect = $choicesItem.closest('.product-size__choices').prev('.product-size__choices__select');
    
        $('.product-size__choices__item').removeClass('active');
        $choicesItem.addClass('active');

        $('.wishlist-trigger').next('span').remove();
        $('.wishlist-error').remove();

        var productId = $choicesItem.attr('data-productid');
        var productSku = $choicesItem.attr('data-sku');
        var size = $choicesItem.attr('data-size');
        $choicesSelect.attr('data-size', size);

        $( document ).trigger( "sizeSelected", [ productId, size ] );

        var bidLink = $('.product-actions__bid a');
        bidLink.attr('data-href', "?act=mab&s=" + size.toLowerCase() + "&tte=1");
        if($('#product-bid_predict-bar-slider').length > 0){
            var predictedAmount = $('#product-bid_predict-bar-slider').attr('data-amount');
            var bidLinkWithPredicted = bidLink.attr('data-href') + "&amt=" + predictedAmount;
            bidLink.attr('data-href', bidLinkWithPredicted);
        }

        var buyNow = $('.product-actions__buy a.pdp-buy_now-btn');
        //get the /us/en from the href
        var hrefParts = buyNow.attr('data-href').split('/');
        var baseHref = hrefParts.slice(0, 3).join('/');

        if(buyNow.attr('data-href') != "#login-modal"){
            buyNow.attr('data-href', baseHref + "/checkout/new?act=bn&pid=" + productSku + "&s=" + size.toLowerCase());
        }
        
        var quantity = $choicesItem.attr('data-quantity');
        $choicesSelect.attr('data-quantity', quantity);

        var oDict = JSON.parse(document.querySelector('[dict-json]').innerHTML);


        var originalPrice = $choicesItem.attr('data-original-price');
        var salesPrice = $choicesItem.attr('data-sales-price');
        var originalPriceRaw = $choicesItem.attr('data-original-price-raw');
        var salesPriceRaw = $choicesItem.attr('data-sales-price-raw');
        var reductionPrice = Math.round((originalPriceRaw - salesPriceRaw) / originalPriceRaw * 100);
        if(originalPriceRaw > 0 && salesPriceRaw > 0){
            $('span[data-action="pdp-original-price"]').text(originalPrice);
            $('span[data-action="pdp-sales-price"]').text(salesPrice);
            $('span[data-action="pdp-reduction-price"]').text(reductionPrice);

            $('.product-sales').show();
            $('.product-sales-price').show();
            $('.product-price').hide();

            $('klarna-placement[data-key="credit-promotion-badge"]').attr('data-purchase-amount', salesPriceRaw * 100);
        }else{
            $('span[data-action="pdp-original-price"]').text(originalPrice);
            $('span[data-action="pdp-sales-price"]').text("");
            $('span[data-action="pdp-reduction-price"]').text("");

            $('.product-sales').hide();
            $('.product-sales-price').hide();
            $('.product-price').show();

            $('klarna-placement[data-key="credit-promotion-badge"]').attr('data-purchase-amount', originalPriceRaw * 100);
        }

        var prefix = "";
        if($choicesItem.data('prefix')){
            prefix = $choicesItem.data('prefix') + " ";
            console.log('prefix=' + prefix);
        }
        if(quantity == 1) {
            $choicesSelect.text(prefix + $choicesItem.find('span').text() + " (" + oDict["last_one_left"] + ")");
        } else if(quantity == 0) {
            $choicesSelect.text(prefix + $choicesItem.find('span').text() + " (" + oDict["out_of_stock"] + ")");
        }
        else {
            $choicesSelect.text(prefix + $choicesItem.find('span').text());
        }
    
        if(quantity == 0) {
            $('.product-actions__bid').addClass('inactive');
            $('.product-actions__buy').addClass('inactive');
            $('.product-actions__notify').removeClass('inactive');
            $('.product-delivery').removeClass('active');

            console.log("data-notify")
            console.log($choicesItem.attr('data-notify'))

            if($choicesItem.data('notify') == true || $choicesItem.attr('data-notify') == "true"){
                $('.product-actions__notify a').text( oDict["you_are_already_registered"] ).addClass('registered');
                console.log('already registered');
            }else{
                $('.product-actions__notify a').text( oDict["notify_me"] ).removeClass('registered');
                console.log('not already registered');
            }
            
        } else {
            $('.product-actions__bid').removeClass('inactive');
            $('.product-actions__buy').removeClass('inactive');
            $('.product-actions__notify').addClass('inactive');
            $('.product-delivery').addClass('active');
            console.log('exit');

        }
    
        $choicesSelect.toggleClass('active');
        $choicesItem.closest('.product-size__choices').slideUp(200);
        $choicesItem.closest('.product-size__choices').removeClass('open');

        if(is_clicked_wishlist){
            $('.wishlist-trigger').click();
            is_clicked_wishlist = false;
        }
    });
    /** Fin code sélecteur taille en mode select */

    //retirer le style display
    $('.product-size').css('display', '');

    $('.product-size_container__item').click(function( ){

        const $choicesItem = $(this);
        const $choicesSelect = $choicesItem.closest('.product-size_container');
    
        $('.product-size_container__item').removeClass('active');
        $choicesItem.addClass('active');

        $('.wishlist-trigger').next('span').remove();
        $('.wishlist-error').remove();

        var productId = $choicesItem.attr('data-productid');
        var size = $choicesItem.attr('data-size');
        var productSku = $choicesItem.attr('data-sku');
        $choicesSelect.attr('data-size', size);

        $( document ).trigger( "sizeSelected", [ productId, size ] );

        var bidLink = $('.product-actions__bid a');
        bidLink.attr('data-href', "?act=mab&s=" + size.toLowerCase() + "&tte=1");
        if($('#product-bid_predict-bar-slider').length > 0){
            var predictedAmount = $('#product-bid_predict-bar-slider').attr('data-amount');
            var bidLinkWithPredicted = bidLink.attr('data-href') + "&amt=" + predictedAmount;
            bidLink.attr('data-href', bidLinkWithPredicted);
        }

        var buyNow = $('.product-actions__buy a:not(.product-express-btn)'); 

        var hrefParts = buyNow.attr('data-href').split('/');
        var baseHref = hrefParts.slice(0, 3).join('/');
        if(buyNow.attr('data-href') != "#login-modal"){
            // buyNow.attr('href', "?act=bn&s=" + size.toLowerCase());
            $(this).attr('data-href', baseHref + "/checkout/new?act=bn&pid=" + productSku + "&s=" + size.toLowerCase());
        }
        
        var quantity = $choicesItem.attr('data-quantity');
        $choicesSelect.attr('data-quantity', quantity);

        var oDict = JSON.parse(document.querySelector('[dict-json]').innerHTML);

        var prefix = "";
        if($choicesItem.data('prefix')){
            prefix = $choicesItem.data('prefix') + " ";
            console.log('prefix=' + prefix);
        }
        // if(quantity == 1) {
        //     $choicesSelect.text(prefix + $choicesItem.find('span').text() + " (" + oDict["last_one_left"] + ")");
        // } else if(quantity == 0) {
        //     $choicesSelect.text(prefix + $choicesItem.find('span').text() + " (" + oDict["out_of_stock"] + ")");
        // }
        // else {
        //     $choicesSelect.text(prefix + $choicesItem.find('span').text());
        // }
    
        if(quantity == 0) {
            $('.product-actions__bid').addClass('inactive');
            $('.product-actions__buy').addClass('inactive');
            $('.product-actions__notify').removeClass('inactive');
            $('.product-delivery').removeClass('active');

            console.log("data-notify")
            console.log($choicesItem.attr('data-notify'))

            if($choicesItem.data('notify') == true || $choicesItem.attr('data-notify') == "true"){
                $('.product-actions__notify a').text( oDict["you_are_already_registered"] ).addClass('registered');
                console.log('already registered');
            }else{
                $('.product-actions__notify a').text( oDict["notify_me"] ).removeClass('registered');
                console.log('not already registered');
            }
            
        } else {
            $('.product-actions__bid').removeClass('inactive');
            $('.product-actions__buy').removeClass('inactive');
            $('.product-actions__notify').addClass('inactive');
            $('.product-delivery').addClass('active');
            console.log('exit');

        }
    
        $choicesSelect.toggleClass('active');
        $choicesItem.closest('.product-size__choices').slideUp(200);
        $choicesItem.closest('.product-size__choices').removeClass('open');

        if(is_clicked_wishlist){
            $('.wishlist-trigger').click();
            is_clicked_wishlist = false;
        }
    });

    // $('.product-details-content .product-actions__bid, .product-details-content .product-actions__buy').click(function(e){
    //     e.preventDefault();
    //     var size = $('.product-details-content .product-size__choices__select').attr('data-size');
    //     if($(this).hasClass('bid-disabled')){
    //         return;
    //     }
    //     if(size == "") {
    //         $('.product-size__choices__select').click();
    //     }else if($(this).find('a').attr('data-href') == "#login-modal" || $(this).find('a').attr('data-href') == "#"){
    //         return;
    //     }else{
    //         window.location.href = $(this).find('a').attr('data-href');
    //     }
    // });

    document.querySelectorAll('.product-details-content .product-actions__bid a.pdp-buy_now-btn, .product-details-content .product-actions__buy a.pdp-buy_now-btn').forEach(function(btn) {
        btn.addEventListener('click', function(e) {
            e.preventDefault();
            console.log('click on product action', btn);
            var sizeSelect = document.querySelector('.product-details-content .product-size__choices__select');
            var size = sizeSelect ? sizeSelect.getAttribute('data-size') : "";
            if (btn.classList.contains('bid-disabled')) {
                return;
            }
            var aTag = $(this);
            var href = aTag ? aTag.attr('data-href') : "";
            console.log('size=', size, ' href=', href, ' sizeSelect=', sizeSelect, ' aTag=', aTag);
            if (size === "") {
                if (sizeSelect) sizeSelect.click();
            } else if (href === "#login-modal" || href === "#") {
                return;
            } else {
                window.location.href = href;
            }
        });
    });

    $('.product-actions__bid.bid-disabled').click(function(e){
        var oDict = JSON.parse(document.querySelector('[dict-json]').innerHTML);

        $('.product-actions__bid.bid-disabled').append('<span class="bid-disabled-message orange-text">' + oDict["bid_disabled"] + '</span>');

        if(window.innerWidth < 768){
            $('.product-delivery').css('visibility', 'hidden')
        }

        setTimeout(function(){
            $('.bid-disabled-message').remove();
            $('.product-delivery').css('visibility', 'visible')

        }, 5000);
    });
    
    $('.product-size__choices__item').hover(function( ){
        var quantity = $(this).attr('data-quantity');
        var oDict = JSON.parse(document.querySelector('[dict-json]').innerHTML);
        if(quantity == 1) {
            $('.product-size__choices__message').text( oDict["last_one_left"] );
        } else if(quantity == 0) {
            $('.product-size__choices__message').text( oDict["out_of_stock"] );
        } else if (quantity <= 2) {
            $('.product-size__choices__message').text(oDict["low_stock"]);
        } else {
            $('.product-size__choices__message').text("");
        }
    });
    $('.product-size__choices__item').mouseleave(function(){
        $('.product-size__choices__message').text("");
        // $('.product-size__choices__item').removeClass('active');
    });

    // if($('.product-details-area').length > 0){

    //     if($('.product-size_container__item').length == 1){
    //         $('.product-size_container__item').click();
    //     }

    //     let isOutOfStock = true;
    //     $('.product-size__choices__item').each(function() {
    //         if($(this).attr('data-quantity') > 0){
    //             isOutOfStock = false;
    //         }
    //     });
    //     $('.product-size_container__item').each(function() {
    //         if($(this).attr('data-quantity') > 0){
    //             isOutOfStock = false;
    //         }
    //     });
    //     if(isOutOfStock){
    //         $('.product-size__choices__item').first().click();
    //         $('.product-size_container__item').first().click();
    //     }
    // }

    $('.product-actions__bid a:not(.product-express-btn), .product-actions__buy a:not(.product-express-btn)').click(function(e){
        e.preventDefault();
        if(window.innerWidth < 768){
            if($(this).attr('href') == "#"){
                $('.product-nosize-selected').show();
                setTimeout(function(){
                    $('.product-nosize-selected').fadeOut(function() {
                        $(this).hide();
                    });
                }, 2000);
            }
        }
    });

    /*** BUY PAGE ***/
    /* FACTURATION SELECTOR */
    $('.bid-area-section-content-address #facturation').on('change', function() {
        //if it's checked
        if($(this).is(':checked')) {
            //show the facturation address
            $('.bid-area-section-content-address-facturation').slideUp(200);
        } else {
            //hide the facturation address
            $('.bid-area-section-content-address-facturation').slideDown(200).css('display', 'flex');;
        }
    });

    /*** BID PAGE ***/
    /* TIME TO EXPIRE SELECTOR */
    /* SIZE SELECTOR */
    $('.expiry_selector__choices').css('display', 'grid');
    $('.expiry_selector__choices').slideUp(0);

    $('.expiry_selector__choices__select').click(function() {
        const $choicesElement = $(this).next('.expiry_selector__choices');
    
        const isOpen = $choicesElement.hasClass('open');
        if (isOpen) {
            $(".expiry_selector__choices").slideUp(200); // Fermer l'élément si déjà ouvert
            $(".expiry_selector__choices").removeClass('open');
        } else {
            $(".expiry_selector__choices").slideUp(200); // Fermer l'élément si déjà ouvert
            $(".expiry_selector__choices").removeClass('open');
            $choicesElement.slideDown(200); // Ouvrir l'élément si fermé
            $choicesElement.addClass('open');
        }
    
        if (!$(this).hasClass('inactive')) {
            $(this).toggleClass('active');
        }
    });
    
    
    $('.expiry_selector__choices__item').click(function(){
        const $choicesItem = $(this);
        const $choicesSelect = $choicesItem.closest('.expiry_selector__choices').prev('.expiry_selector__choices__select');
        
        $('.expiry_selector__choices__item').removeClass('active');
        $choicesItem.addClass('active');

        $('.bid-area-section-content-product_size-error').remove();

        $choicesSelect.text($choicesItem.find('span').text());
    
        $choicesSelect.toggleClass('active');
        $choicesSelect.addClass('filled');
        $choicesItem.closest('.expiry_selector__choices').slideUp(200);
        $choicesItem.closest('.expiry_selector__choices').removeClass('open');

        $('.expiry_selector__choices__select').attr('data-time', $choicesItem.attr('data-time'));
    });
    
    $('.expiry_selector__choices__item').hover(function(){
        $('.expiry_selector__choices__item').removeClass('active');
        $(this).addClass('active');
    });
    $('.expiry_selector__choices__item').mouseleave(function(){
        $('.expiry_selector__choices__item').removeClass('active');
    });

    $('#bid-number').on('input', function() {
        var currentValue = $(this).val();
        var newValue = currentValue.replace(/[^0-9]/g, '');
        $(this).val(newValue);
        if(newValue == ""){
            $('.curr-symbol').removeClass('active');
        }else{
            $('.curr-symbol').addClass('active');
        }
        sendEventLogger('bid_value_typed');
    });

    $('#bid-submit-step1').on('click', function(e) {
        e.preventDefault();
        var size = $('.bid-area-section-content-product_size').attr('data-size');
        var productSku = $('.bid-area-section-content-product_size').attr('data-sku');
        // var quantity = $('.product-size__choices__select').attr('data-quantity');
        // var time = $('.expiry_selector__choices__select').attr('data-time');
        var bidNumber = $('#bid-number').val();
        var bidKey = $('#bidkey').val();
        var fullPrice = $(this).attr('data-fullprice');

        var isError = false;

        $('.bid-area-section-content-product_size-error').remove();
        
        if(bidNumber == "" || bidNumber < 1) {
            isError = true;
            $('.bid-area-input-amt').after('<div class="bid-area-section-content-product_size-error">' + oDict["bid_please_enter_bid_value"] + '</div>');
        } 
        if(size == "" || size == undefined) {
            isError = true;
            $('.bid-area-section-content-product_size').append('<div class="bid-area-section-content-product_size-error">' + oDict["select_size"] + '</div>');
        }
        // if(quantity == "" || quantity == undefined || quantity < 1) {
        //     isError = true;
        //     $('.bid-area-section-content-product_size').append('<div class="bid-area-section-content-product_size-error">' + oDict["select_available_product"] + '</div>');
        // }
        // if(parseFloat(bidNumber) < parseFloat(fullPrice)) {
        //     if(time == "" || time == undefined) {
        //         isError = true;
        //         $('.bid-area-input-tte').after('<div class="bid-area-section-content-product_size-error">' + oDict["bid_select_bid_duration"] + '</div>');
        //     }
        // }

        if(isError == true) {
            return;
        }

        if(parseFloat(bidNumber) >= parseFloat(fullPrice)){
            //get current url
            const url = new URL(window.location.href);
            // Sépare les segments de pathname en enlevant les éventuels éléments vides
            const segments = url.pathname.split('/').filter(Boolean);
            // Construit "/us/en" à partir des deux premiers segments de chemin
            const baseHref = `/${segments[0]}/${segments[1]}`;

            // $(this).attr('href', "?act=bn&s=" + size.toLowerCase());
            $(this).attr('href', baseHref + "/checkout/new?act=bn&pid=" + productSku + "&s=" + size.toLowerCase());
        }else{
            $(this).attr('href', "?act=rb&key=" + bidKey + "&s=" + size.toLowerCase() + "&tte=1&amt=" + bidNumber);
        }
        window.location.href = $(this).attr('href');
    });


    // $('.open-form_address_popin-modal').magnificPopup({
    //     type: 'inline',
    //     closeMarkup: '<button title="%title%" type="button" class="mfp-close mfp-fade-out"><img style="width: 25px;margin: 17px 20px 0 0;cursor: pointer;" src="/assets/251129145240/images/icon-img/big-close.svg"/></button>',
    //     closeOnBgClick: false,
    //     callbacks: {
    //         open: function() {
    //             var regex = /@privaterelay\.appleid\.com$/;
    //             var email = $('#form_address_popin-modal input[type="email"][name="email_address"]').data('default-email');
    //             var emailData = "";
    //             if (regex.test(email)) {
    //                 emailData = "";
    //                 $('#form_address_popin-modal input[type="email"][name="email_address"]').val('')
    //             }

    //             $('.mfp-close').on('click', function() {
    //                 updateAddressForm({email: emailData, first_name: $('#account-area-section-address-form #first_name').attr('data-default-firstname'), last_name: $('#account-area-section-address-form #last_name').attr('data-default-lastname')});
    //                 $.magnificPopup.close();
    //             });
    //         }
    //     }
    // });

    $(document).on("click", ".open-form_address_popin-modal", function(e) {
        e.preventDefault();
        console.log('click open address modal');
        $.magnificPopup.close();
        $.magnificPopup.open({
            items: {
                src: $('.form_address_popin-modal'),
                type: 'inline',
            },
            closeMarkup: '<button title="%title%" type="button" class="mfp-close mfp-fade-out"><img style="width: 25px;margin: 17px 20px 0 0;cursor: pointer;" src="/assets/251129145240/images/icon-img/big-close.svg"/></button>',
            closeOnBgClick: false,
            // fixedContentPos: true,
            callbacks: {
                open: function() {
                    if($('.bid-area').length > 0)
                        sendEventLogger('checkout_address_open');
                    var regex = /@privaterelay\.appleid\.com$/;
                    var email = $('#form_address_popin-modal input[type="email"][name="email_address"]').data('default-email');
                    var emailData = "";
                    if (regex.test(email)) {
                        emailData = "";
                        $('#form_address_popin-modal input[type="email"][name="email_address"]').val('')
                    }else{
                        emailData = email;
                    }

                    //fix the body scroll
                    $('body').css('overflow', 'hidden!important');

                    $('.mfp-close').on('click', function() {
                        updateAddressForm({email: emailData, first_name: $('#account-area-section-address-form #first_name').attr('data-default-firstname'), last_name: $('#account-area-section-address-form #last_name').attr('data-default-lastname')});
                        $.magnificPopup.close(); // Fermer la popup lors du clic sur le bouton de fermeture
                    });
                },
                close: function() {
                    //fix the body scroll
                    $('body').css('overflow', 'auto');
                }
            }
        });
    });

    $(document).on("click", ".open-add_payment_account-modal", function(e) {
        e.preventDefault();
        $.magnificPopup.close();
        $.magnificPopup.open({
            items: {
                src: $('.add_payment_account-modal'),
                type: 'inline',
            },
            closeMarkup: '<button title="%title%" type="button" class="mfp-close mfp-fade-out"><img style="width: 25px;margin: 17px 20px 0 0;cursor: pointer;" src="/assets/251129145240/images/icon-img/big-close.svg"/></button>',
            callbacks: {
                open: function() {
                    $('.mfp-close').on('click', function() {
                        $.magnificPopup.close(); // Fermer la popup lors du clic sur le bouton de fermeture
                    });
                }
            }
        });
    });

    $(document).on("click", ".open-add_payment_account_adyen-modal", function(e) {
        e.preventDefault();
        sendEventLogger('checkout_payment_open');
        $.magnificPopup.close();
        $.magnificPopup.open({
            items: {
                src: $('.add_payment_account_adyen-modal'),
                type: 'inline',
            },
            closeMarkup: '<button title="%title%" type="button" class="mfp-close mfp-fade-out"><img style="width: 25px;margin: 17px 20px 0 0;cursor: pointer;" src="/assets/251129145240/images/icon-img/big-close.svg"/></button>',
            callbacks: {
                open: function() {
                    $('.mfp-close').on('click', function() {
                        $.magnificPopup.close(); // Fermer la popup lors du clic sur le bouton de fermeture
                    });
                }
            }
        });
    });


    // $('.open-add_payment_account-modal').magnificPopup({
    //     type: 'inline',
    //     closeMarkup: '<button title="%title%" type="button" class="mfp-close mfp-fade-out"><img style="width: 25px;margin: 17px 20px 0 0;cursor: pointer;" src="/assets/251129145240/images/icon-img/big-close.svg"/></button>',
    //     callbacks: {
    //         open: function() {
    //             $('.mfp-close').on('click', function() {
    //                 $.magnificPopup.close(); // Fermer la popup lors du clic sur le bouton de fermeture
    //             });
    //             }
    //         }
    // });

    /*** SIZE GUIDE ***/
    $('.open-size_guide-modal').magnificPopup({
        type: 'inline',
        closeMarkup: '<button title="%title%" type="button" class="mfp-close mfp-fade-out"><img style="width: 25px;margin: 17px 20px 0 0;cursor: pointer;" src="/assets/251129145240/images/icon-img/big-close.svg"/></button>',
        callbacks: {
            open: function() {
                $('.mfp-close').on('click', function() {
                  $.magnificPopup.close(); // Fermer la popup lors du clic sur le bouton de fermeture
                });
                //var sizeGuide = '{"col1":{"name":"Italy","values":["34","34,5","35","35,5","36","36,5","37","37,5","38","38,5","39","39,5","40","40,5","41","41,5","42","42,5","43","43,5","44","44,5","45"]},"col2":{"name":"US","values":["4","4,5","5","5,5","6","6,5","7","7,5","8","8,5","9","9,5","10","10,5","11","11,5","12","12,5","13","13,5","14","14,5","15"]},"coldyn":{"France":["35","35,5","36","36,5","37","37,5","38","38,5","39","39,5","40","40,5","41","41,5","42","42,5","43","43,5","44","","","",""],"UK":["1","1,5","2","2,5","3","3,5","4","4,5","5","5,5","6","6,5","7","7,5","8","8,5","9","9,5","10","10,5","11","11,5","12"],"Foot length (cm)":["22","22,3","22,6","23","23,3","23,6","24","24,3","24,6","25","25,3","25,6","26","26,3","26,6","27","27,3","27,6","28","","","",""],"Foot length (in)":["8,7","8,8","8,9","9,1","9,2","9,3","9,4","9,6","9,7","9,8","10","10,1","10,2","10,4","10,5","10,6","10,7","10,9","11","","","",""],"Japan":["21","21,5","22","22,5","23","23,5","24","24,5","25","25,5","26","26,5","27","27,5","28","28,5","29","29,5","30","30,5","31","31,5","32"],"Mexico":["21","21,5","22","22,5","23","23,5","24","24,5","25","25,5","26","26,5","27","27,5","28","28,5","","","","","","",""],"Europe":["34","34,5","35","35,5","36","36,5","37","37,5","38","38,5","39","39,5","40","40,5","41","41,5","42","42,5","43","43,5","44","44,5","45"],"Standard":["XS","XS","XS","XS","XS","","S","S","S","S","S","","M","M","M","M","M","","L","L","L","L","L"]}}';
                //var sizeGuide = '{"col1":{"name":"Italy","values":["34","34,5","35","35,5","36","36,5","37","37,5","38","38,5","39","39,5","40","40,5","41","41,5","42","42,5","43","43,5","44","44,5","45"]},"coldyn":{"France":["35","35,5","36","36,5","37","37,5","38","38,5","39","39,5","40","40,5","41","41,5","42","42,5","43","43,5","44","","","",""],"UK":["1","1,5","2","2,5","3","3,5","4","4,5","5","5,5","6","6,5","7","7,5","8","8,5","9","9,5","10","10,5","11","11,5","12"],"Foot length (cm)":["22","22,3","22,6","23","23,3","23,6","24","24,3","24,6","25","25,3","25,6","26","26,3","26,6","27","27,3","27,6","28","","","",""],"Foot length (in)":["8,7","8,8","8,9","9,1","9,2","9,3","9,4","9,6","9,7","9,8","10","10,1","10,2","10,4","10,5","10,6","10,7","10,9","11","","","",""],"Japan":["21","21,5","22","22,5","23","23,5","24","24,5","25","25,5","26","26,5","27","27,5","28","28,5","29","29,5","30","30,5","31","31,5","32"],"Mexico":["21","21,5","22","22,5","23","23,5","24","24,5","25","25,5","26","26,5","27","27,5","28","28,5","","","","","","",""],"Europe":["34","34,5","35","35,5","36","36,5","37","37,5","38","38,5","39","39,5","40","40,5","41","41,5","42","42,5","43","43,5","44","44,5","45"],"Standard":["XS","XS","XS","XS","XS","","S","S","S","S","S","","M","M","M","M","M","","L","L","L","L","L"]}}';
                sizeGuideInit(sizeGuide);

                //send event logger
                sendEventLogger('size_guide_open');

                var size = $('.product-size__choices__select').attr('data-size');
                if(size != undefined){
                    size = size.replace(/\D/g, '');
                }
                var sizeguide_table = $('.size_guide-conversion table');


                // we check if the size is in one of the first column, if yes we set the whole tr to active
                sizeguide_table.find('tr').each(function(){
                    if($(this).find('td:first-child').text() == size){
                        $(this).addClass('active');
                        // console log with html to see if the class is added
                    }else{
                        $(this).removeClass('active');
                    }
                });
              }
          }
    });

    function sizeGuideInit(sizeGuide){
        var sizeGuide = JSON.parse(sizeGuide);
        var table = $('.size_guide-conversion');

        if(sizeGuide.coldyn.length == 0){
            $('.size_guide-modal').find('.empty-hide').hide();
            $('.size_guide-modal').find('.empty-show').show();
            return;
        }else{
            $('.size_guide-modal').find('.empty-hide').show();
            $('.size_guide-modal').find('.empty-show').hide();
        }

        var firstColdynTable = sizeGuide.coldyn[Object.keys(sizeGuide.coldyn)[0]];
        var firstCountryName = Object.keys(sizeGuide.coldyn)[0];

        var tbody = table.find('tbody');
        tbody.empty();

        //Titles rows
        table.find('th:first-child').text(sizeGuide['col1']['name']);
        if(sizeGuide['col2'] != null){
            table.find('th:nth-child(2)').text(sizeGuide['col2']['name']);
        }else{
            table.find('th:nth-child(2)').hide();
        }
        
        table.find('.size_guide__choices__select').text(firstCountryName);

        //Pour le mobile on ajoute la 2nde colonne dans le sélecteur
        if ($(window).width() < 768){
            if (sizeGuide['col2'] != null) {
                sizeGuide['coldyn'][sizeGuide['col2']['name']] = sizeGuide['col2']['values'];
            }
        }

        //Countries
        var select_country = table.find('.size_guide__choices');
        select_country.empty();
        for (var country in sizeGuide['coldyn']) {
            var country_name = country;
            var country_value = sizeGuide['coldyn'][country];
            var country_item = $('<div class="size_guide__choices__item" data-country="'+country+'"><span>'+country+'</span></div>');
            select_country.append(country_item);
        }

        //Row values
        for (var i = 0; i < sizeGuide['col1']['values'].length; i++) {
            var row = $('<tr></tr>');
            var col1 = $('<td></td>').text(sizeGuide['col1']['values'][i]);
            if(sizeGuide['col2'] != null){
                var col2 = $('<td></td>').text(sizeGuide['col2']['values'][i]);
            }else{
                var col2 = $('<td style="display: none;"></td>').text('');
            }
            
            var col3 = $('<td data-size="'+ i +'"></td>').text(firstColdynTable[i]);
            row.append(col1);
            row.append(col2);
            row.append(col3);
            tbody.append(row);
        }

        $('.size_guide__choices__item').first().hide();

        var sizes_by_country = sizeGuide['coldyn'];

        $('.size_guide__choices').css('display', 'grid');
        $('.size_guide__choices').slideUp(0);

        $(document).off('click', '.size_guide__choices__select').on('click', '.size_guide__choices__select', function(){
            const $choicesElement = $(this).next('.size_guide__choices');
        
            const isOpen = $choicesElement.hasClass('open');
            if (isOpen) {
                $(".size_guide__choices").slideUp(200); // Fermer l'élément si déjà ouvert
                $(".size_guide__choices").removeClass('open');
            } else {
                $(".size_guide__choices").slideUp(200); // Fermer l'élément si déjà ouvert
                $(".size_guide__choices").removeClass('open');
                $choicesElement.slideDown(200); // Ouvrir l'élément si fermé
                $choicesElement.addClass('open');
            }
        
            if (!$(this).hasClass('inactive')) {
                $(this).toggleClass('active');
            }
        });
        
        $(document).off('click', '.size_guide__choices__item').on('click', '.size_guide__choices__item', function(){
            const $choicesItem = $(this);
            const $choicesSelect = $choicesItem.closest('.size_guide__choices').prev('.size_guide__choices__select');
    
            $('.size_guide__choices__item').show();
            
            $('.size_guide__choices__item').removeClass('active');
            $choicesItem.addClass('active');
    
            $choicesSelect.text($choicesItem.find('span').text());
        
            $choicesSelect.toggleClass('active');
            $choicesSelect.addClass('filled');
            $choicesItem.closest('.size_guide__choices').slideUp(200);
            $choicesItem.closest('.size_guide__choices').removeClass('open');
    
            var country = $choicesItem.attr('data-country');
            $('.size_guide-conversion table tr').each(function() {
                var lastTd = $(this).find('td:last');
                var size = lastTd.attr('data-size');
                var size_by_country = sizes_by_country[country][size];
                $(this).find('td:last').text(size_by_country);
            });
            $choicesItem.hide();
        });
        
        $('.size_guide__choices__item').hover(function(){
            $('.size_guide__choices__item').removeClass('active');
            $(this).addClass('active');
        });
        $('.size_guide__choices__item').mouseleave(function(){
            $('.size_guide__choices__item').removeClass('active');
        });

    }


    

    /*** NEWSLETTER THANKS ***/
    /*$('.open-newsletter_thanks-modal').magnificPopup({
        type: 'inline',
        closeMarkup: '<button title="%title%" type="button" class="mfp-close mfp-fade-out"><img style="width: 25px;margin: 17px 20px 0 0;cursor: pointer;" src="/assets/251129145240/images/icon-img/big-close.svg" alt="Fermer" /></button>',
    });*/

    /*setTimeout(function() {
        $.magnificPopup.open({
            items: {
                src: '.newsletter_thanks-modal'
            },
            type: 'inline'
        });
    }, 1000);*/


    /*** PREFERENCES ***/
    /*$('.open-preferences-modal').magnificPopup({
        type: 'inline',
        closeMarkup: '<button title="%title%" type="button" class="mfp-close mfp-fade-out"><img style="width: 25px;margin: 17px 20px 0 0;cursor: pointer;" src="/assets/251129145240/images/icon-img/big-close.svg" alt="Fermer" /></button>',
        callbacks: {
            open: function() {
                $('.mfp-close').on('click', function() {
                    $.magnificPopup.close(); // Fermer la popup lors du clic sur le bouton de fermeture
                });
    
                $('.mfp-content').on('click', function(e) {
                    e.stopPropagation(); // Empêcher la propagation de l'événement click à l'extérieur de la pop-up
                });
    
                $('.mfp-content input, .mfp-content select, .mfp-content textarea').on('click', function(e) {
                    e.stopPropagation(); // Empêcher la propagation de l'événement click pour les éléments à l'intérieur de la pop-up
                });
            },
            beforeClose: function () {
                // Callback available since v0.9.0
                return false;
            },
            close: function () {
                // Will fire when popup is closed
                return false;
            }

        },
    });*/

    $('.open-preferences-modal').on('click', function (e) {
        e.preventDefault();
        var container = $('.mobile-off-canvas-active');
        var wrapper = $('.main-wrapper-3');
        container.removeClass('inside');
        wrapper.removeClass('overlay-active-3');

        $.magnificPopup.open({
            items: {
                src: $('#preferences-modal'),
                type: 'inline',
                closeBtnInside: true,
                modal: true,
            },
            closeOnBgClick: false,
            callbacks: {
                open: function() {
                    jQuery('body').addClass('noscroll');
                },
                close: function() {
                    jQuery('body').removeClass('noscroll');
                }
            }
        });
    });
    
    

    /* START LANGUAGE */
    $('.preferences__choices__select.language').click(function() {
        const $choicesElement = $(this).next('.preferences__choices.language');
        const isOpen = $choicesElement.hasClass('open');

        $(".preferences__choices").slideUp(200).removeClass('open');
        
        $(".language .preferences__choices").slideUp(200).removeClass('open');
        
        if (!isOpen) {
            $choicesElement.slideDown(200).addClass('open');
        }else{
            $choicesElement.slideUp(200).removeClass('open');
        }
        
        if (!$(this).hasClass('inactive')) {
            $(this).toggleClass('active');
        }
    });
    
    $('.language .preferences__choices__item').click(function(){
        const $choicesItem = $(this);
        const $choicesSelect = $choicesItem.closest('.preferences__choices').prev('.preferences__choices__select.language');
        
        $('.preferences__choices__item').removeClass('active');
        $choicesItem.addClass('active');
        $choicesSelect.text($choicesItem.find('span').text()).toggleClass('active filled');
        $choicesSelect.attr('data-language', $choicesItem.data('language'));
        $choicesItem.closest('.preferences__choices').slideUp(200).removeClass('open');
    });
    
    $('.language .preferences__choices__item').hover(function(){
        $(this).addClass('active');
    }, function(){
        $(this).removeClass('active');
    });
    /* END LANGUAGE */

    /* START COUNTRY */
    $('.preferences__choices__select.country').click(function() {
        const $choicesElement = $(this).next('.preferences__choices.country');
        const isOpen = $choicesElement.hasClass('open');

        $(".preferences__choices").slideUp(200).removeClass('open');
        
        $(".country .preferences__choices").slideUp(200).removeClass('open');
        
        if (!isOpen) {
            $choicesElement.slideDown(200).addClass('open');
        }else{
            $choicesElement.slideUp(200).removeClass('open');
        }
        
        if (!$(this).hasClass('inactive')) {
            $(this).toggleClass('active');
        }
    });
    
    $('.country .preferences__choices__item').click(function(){
        const $choicesItem = $(this);
        const $choicesSelect = $choicesItem.closest('.preferences__choices').prev('.preferences__choices__select.country');
        
        $('.preferences__choices__item').removeClass('active');
        $choicesItem.addClass('active');
        $choicesSelect.text($choicesItem.find('span').text()).toggleClass('active filled');
        $choicesSelect.attr('data-country', $choicesItem.data('country'));
        $choicesItem.closest('.preferences__choices').slideUp(200).removeClass('open');
    });
    
    $('.country .preferences__choices__item').hover(function(){
        $(this).addClass('active');
    }, function(){
        $(this).removeClass('active');
    });
    /* END COUNTRY */

    /* START CURRENCY */
    $('.preferences__choices__select.currency').click(function() {
        const $choicesElement = $(this).next('.preferences__choices.currency');
        const isOpen = $choicesElement.hasClass('open');

        $(".preferences__choices").slideUp(200).removeClass('open');
        
        $(".currency .preferences__choices").slideUp(200).removeClass('open');
        
        if (!isOpen) {
            $choicesElement.slideDown(200).addClass('open');
        }else{
            $choicesElement.slideUp(200).removeClass('open');
        }
        
        if (!$(this).hasClass('inactive')) {
            $(this).toggleClass('active');
        }
    });
    
    $('.currency .preferences__choices__item').click(function(){
        const $choicesItem = $(this);
        const $choicesSelect = $choicesItem.closest('.preferences__choices').prev('.preferences__choices__select.currency');
        
        $('.preferences__choices__item').removeClass('active');
        $choicesItem.addClass('active');
        $choicesSelect.text($choicesItem.find('span').text()).toggleClass('active filled');
        $choicesItem.closest('.preferences__choices').slideUp(200).removeClass('open');
    });
    
    $('.currency .preferences__choices__item').hover(function(){
        $(this).addClass('active');
    }, function(){
        $(this).removeClass('active');
    });
    /* END CURRENCY */


    /*** ACCOUNT CHANGE PASSWORD */
    $('.open-change_password').on('click', function (e) {
        e.preventDefault();
        $('input').blur();
        $.magnificPopup.open({
            items: {
                src: $('#change_password-modal'),
                type: 'inline',
                closeBtnInside: true,
                modal: true,
            },
            closeOnBgClick: false,
            callbacks: {
                open: function() {
                    jQuery('body').addClass('noscroll');
                },
                close: function() {
                    jQuery('body').removeClass('noscroll');
                }
            }
        });
    });

    /*** CHANGE PASSWORD FORM SUBMISSION ***/

    $('#change_password-form').submit(function(e) {
        e.preventDefault(); // Empêche le rechargement de la page

        // Récupère les données du formulaire
        var formData = $(this).serialize();

        $('.error-message').remove();

        // Récupère les données du formulaire
        var current_password = $('#change_password-form input[name="current_password"]').val().trim();
        var new_password = $('#change_password-form input[name="new_password"]').val().trim();
        var confirm_new_password = $('#change_password-form input[name="confirm_new_password"]').val().trim();

        // Vérifie si les champs sont vides
        if (current_password === '') {
            addErrorMessage($('#change_password-form input[name="current_password"]'), oDict["enter_current_password"]);
        }
        var passwordRegex = /^(?=.*[A-Z])(?=.*\d).*$/;
        if (new_password === '') {
            addErrorMessage($('#change_password-form input[name="new_password"]'), oDict["enter_new_password"]);
        } else if (!passwordRegex.test(new_password)) {
            addErrorMessage($('input[name="new_password"]'), oDict["password_policy"] );
            $('.password-message').hide();
        }
        if (confirm_new_password === '') {
            addErrorMessage($('#change_password-form input[name="confirm_new_password"]'), oDict["confirm_new_password"]);
        }

        if (new_password !== confirm_new_password) {
            addErrorMessage($('#change_password-form input[name="confirm_new_password"]'), oDict["passwords_dont_match"]);
        }

        if($('#change_password-form .error-message').length > 0) {
            return;
        }

        var currentUrl = window.location.href;
        var urlObject = new URL(currentUrl);
        var baseUrl = urlObject.origin;

        $.ajax({
            url: baseUrl + $('#change_password-form').attr('action'),
            type: 'POST',
            data: formData,
            success: function(data, status, xhr) {
                var redirectUrl = xhr.getResponseHeader('Location');
                if (xhr.status === 201) {
                    $('#change_password-form input[name="current_password"]').val('');
                    $('#change_password-form input[name="new_password"]').val('');
                    $('#change_password-form input[name="confirm_new_password"]').val('');
                    $.magnificPopup.close();
                } else {
                    if (data.success) {
                    } else {
                        if (data.errorCode === 0) {
                            addErrorMessage($('#change_password-form input[name="current_password"]'), oDict["password_doesnt_match"]);
                        } else if (data.errorCode === -2) {
                            addErrorMessage($('#change_password-form input[name="password"]'), oDict["user_not_found"]);
                        } else {
                            console.log('Error during password update');
                        }
                    }    
                }
            },
            error: function(xhr, status, error) {
                // Gère les erreurs de la requête AJAX
                console.log(baseUrl + $('#change_password-form').attr('action'));
                console.log('AJAX error: ' + error);
            }
        });
    });

    /*** ADDRESS BOOK ***/

    function updateAddressForm($aAddressData){
        var form = $('#account-area-section-address-form');

        var addressId = $('.address_selector:visible option:selected').attr('data-id');
        var firstName = form.find('input[name="first_name"]');
        var lastName = form.find('input[name="last_name"]');
        var email = form.find('input[name="email_address"]');
        var address1 = form.find('input[name="address_1"]');
        var address2 = form.find('input[name="address_2"]');
        var city = form.find('input[name="city"]');
        var zipCode = form.find('input[name="zipcode"]');
        var country = form.find('select[name="country"]');
        var phone = form.find('input[name="phone"]');
        var delivery = form.find('input[name="delivery"]');
        var billing = form.find('input[name="billing"]');
        var state = form.find('select[name="state"]');

        //update state and zipcode


        if (addressId && addressId.length) {
            addressId.val($aAddressData.address_id);
        }
        firstName.val($aAddressData.first_name);
        lastName.val($aAddressData.last_name);
        email.val($aAddressData.email);
        address1.val($aAddressData.address_1);
        address2.val($aAddressData.address_2);
        city.val($aAddressData.city);
        zipCode.val($aAddressData.zipcode);
        if($aAddressData.state){
            state.val($aAddressData.state);
            state.attr('data-value', $aAddressData.state);
            //select option with state value
            state.find('option').each(function() {
                if ($(this).val() === $aAddressData.state) {
                    $(this).prop('selected', true);
                }
            });
        }
        if ( $aAddressData.country != undefined ){
            if($aAddressData.country.toLowerCase() == "gb") {
                $aAddressData.country = "UK";
            }
            country.val($aAddressData.country).trigger('change');
        }
        phone.val($aAddressData.phone);
        if($aAddressData.phone_details != undefined && $aAddressData.phone_details.country_code != undefined){
            phone.attr('data-country', $aAddressData.phone_details.country_code);
            //trigger changePhoneCountry event
            const event = new CustomEvent('changePhoneCountry', {
                detail: { countryCode: $aAddressData.phone_details.country_code }
            });
            document.dispatchEvent(event);
        }
        delivery.prop('checked', $aAddressData.is_fav_delivery);
        billing.prop('checked', $aAddressData.is_fav_billing);     
    }

    $(document).on('click', '.account-area-section-address-edit', function (e) {
        e.preventDefault();
        var addressId = $(this).attr('data-id');

        $('#account-area-section-address-form input[name="address_id"]').val(addressId);

        $.ajax({
            url: '/account/address/' + addressId,
            method: 'GET',
            dataType: 'json',
            success: function (response) {
                var $aAddressData = response; // Les données de l'adresse reçues du serveur
                updateAddressForm($aAddressData);
                console.log($aAddressData);
                //send event updateAccountFormInputs
                const event = new CustomEvent('updateAccountFormInputs', {
                    detail: { addressData: $aAddressData }
                });
                document.dispatchEvent(event);
            },
            error: function (xhr, status, error, response) {
                console.log(response);
                console.log(error); // Gérer les erreurs de requête
            }
        });
    });

    // Fonction pour valider un email
    function validateEmail(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    $(document).on('change', '#account-area-section-address-form .country', function (e) {
        console.log('change country')
        const countryToCode = {
            bahrain: "BH",
            canada: "CA",
            china: "CN",
            "hong kong": "HK",
            japan: "JP",
            kuwait: "KW",
            oman: "OM",
            qatar: "QA",
            "saudi arabia": "SA",
            singapore: "SG",
            "south korea": "KR",
            taiwan: "TW",
            "united arab emirates (uae)": "AE",
            "united states of america": "US"
        };
        let aCountryCodesWithZipCodes = [ 'AD', 'AR', 'AS', 'AT', 'AU', 'AX', 'AZ', 'BD', 'BE', 'BG', 'BM', 'BR', 'BY', 'CA', 'CH', 'CL', 'CN', 'CO', 'CR', 'CY', 'CZ', 'DE', 'DK', 'DO', 'DZ', 'EC', 'EE', 'ES', 'FI', 'FM', 'FO', 'FR', 'GB', 'GF', 'GG', 'GL', 'GP', 'GT', 'GU', 'HR', 'HT', 'HU', 'IE', 'IM', 'IN', 'IS', 'IT', 'JE', 'JP', 'KR', 'LI', 'LK', 'LT', 'LU', 'LV', 'MA', 'MC', 'MD', 'MH', 'MK', 'MP', 'MQ', 'MT', 'MW', 'MX', 'MY', 'NC', 'NL', 'NO', 'NZ', 'PA', 'PE', 'PH', 'PK', 'PL', 'PM', 'PR', 'PT', 'PW', 'RE', 'RO', 'RS', 'RU', 'SE', 'SG', 'SI', 'SJ', 'SK', 'SM', 'TH', 'TR', 'UA', 'US', 'UY', 'VA', 'VI', 'WF', 'YT', 'ZA' ];
        if(aCountryCodesWithZipCodes.includes(countryToCode[$(this).val().toLowerCase()])){
            $('label[for="zipcode"] span').text(oDict["address_zipcode_req"]);
            console.log('zipcode required')
        }else{
            $('label[for="zipcode"] span').text(oDict["address_zipcode"]);
            console.log('zipcode not required')
        }
    });
    
    $('.account-area-section-address-form-cancel').on('click', function (e) {
        e.preventDefault();
        var $form = $('#account-area-section-address-form');

        var regex = /@privaterelay\.appleid\.com$/;
        var email = $('input[type="email"][name="email_address"]').data('default-email');
        var emailData = "";
        if (regex.test(email)) {
            emailData = "";
        }else{
            emailData = email;
        }

        updateAddressForm({email: emailData, first_name: $('#account-area-section-address-form #first_name').attr('data-default-firstname'), last_name: $('#account-area-section-address-form #last_name').attr('data-default-lastname')});
        $('.error-message').remove();
            
        $.magnificPopup.close();
    });
    

    $('.account-area-section-address-add').on('click', function (e) {
        e.preventDefault();
        var $form = $('#account-area-section-address-form');
        $form.appendTo('.account-area-section-address-emptyform');
        if($('.account-area-section-address-item').length == 0){
            $form.find('input[type=checkbox]').prop('disabled', true);
            $form.find('input[type=checkbox]').prop('checked', true);
        }else{
            $form.find('input[type=checkbox]').prop('disabled', false);
            $form.find('input[type=checkbox]').prop('checked', true);
        }
        $form.find('input[name="address_id"]').val('');
        $form.show();

        var regex = /@privaterelay\.appleid\.com$/;
        var email = $('#account-area-section-address-form #email_address').attr('data-default-email');
        var emailData = "";
        if (regex.test(email)) {
            emailData = "";
        }else{
            emailData = email;
        }

        updateAddressForm({email: emailData, first_name: $('#account-area-section-address-form #first_name').attr('data-default-firstname'), last_name: $('#account-area-section-address-form #last_name').attr('data-default-lastname')});
    });

    $('#account-area-section-address-form').on('submit', function (e) {
        e.preventDefault(); // Empêche le rechargement de la page

        // Récupère les données du formulaire
        var formData = $(this).serialize();

        $('.error-message').remove();

        var first_name = $(this).find('input[name="first_name"]');
        var last_name = $(this).find('input[name="last_name"]');
        var country = $(this).find('.country');
        var email = $(this).find('input[name="email_address"]');
        var emailValue = email.val();
        var address_1 = $(this).find('input[name="address_1"]');
        var address_2 = $(this).find('input[name="address_2"]');
        var city = $(this).find('input[name="city"]');
        var zipcode = $(this).find('input[name="zipcode"]');
        var phone = $(this).find('input[name="phone"]');
        var state = $(this).find('.state');

        // Vérifie si les champs sont vides
        if (first_name.val() === '') {
            addErrorMessage(first_name, oDict['address_enter_first_name']);
        }
        if (last_name.val() === '') {
            addErrorMessage(last_name, oDict["address_enter_last_name"]);
        }
        if (country.val() === null) {
            addErrorMessage(country, oDict["address_select_country"]);
        }
        if (emailValue === '') {
            addErrorMessage(email, oDict["address_enter_email"]);
        }else if(!validateEmail( emailValue )){
            addErrorMessage(email, oDict["enter_valid_email"]);
        }
        if (address_1.val() === '') {
            addErrorMessage(address_1, oDict["address_enter_address"]);
        }
        if (city.val() === '') {
            addErrorMessage(city, oDict["address_enter_city"]);
        }
        console.log('zipcode', zipcode.val(), 'require', zipcode.attr('data-require'));
        if (zipcode.val() === '' && zipcode.attr('data-require') == 'yes') {
            addErrorMessage(zipcode, oDict["address_enter_zipcode"]);
        }
        if (state.is(':visible') && state.val() === '' && state.attr('data-require') == 'yes') {
            addErrorMessage(state, oDict["address_enter_state"]);
        }
        if (phone.val() === '') {
            addErrorMessage(phone, oDict["address_enter_phone"]);
            $('.phone-description').hide();
        }else{
            $('.phone-description').show();
        }

        if($('#account-area-section-address-form .error-message').length > 0) {
            //scroll to the first error message
            $('html, body').animate({
                scrollTop: $('.error-message').first().offset().top - 100
            }, 500);
            return;
        }

        $('#account-area-section-address-form input[type="submit"]').prop('disabled', true);
        $('#account-area-section-address-form input[type="submit"]').val(oDict["saving_address"]);

        var currentUrl = window.location.href;
        var urlObject = new URL(currentUrl);
        var baseUrl = urlObject.origin;

        $.ajax({
            url: baseUrl + $('#account-area-section-address-form').attr('action'),
            type: 'POST',
            data: formData,
            success: function(data, status, xhr) {
                var redirectUrl = xhr.getResponseHeader('Location');
                if (xhr.status === 201) {
                    var emailData = $('#form_address_popin-modal input[type="email"][name="email_address"]').data('default-email');
                    updateAddressForm({email: emailData, first_name: $('#account-area-section-address-form #first_name').attr('data-default-firstname'), last_name: $('#account-area-section-address-form #last_name').attr('data-default-lastname')});

                    var url = new URL(window.location.href);
                    var typeTransaction = url.searchParams.get('act');
                    var transactionId = url.searchParams.get('key');
                    if(typeTransaction && transactionId){
                        //si nous sommes dans le checkout
                        changeAddress(e, "last", typeTransaction, transactionId);
                    }else{
                        //si nous sommes dans account address book
                        getAddresses();
                    }

                } else {
                    if (data.success) {
                        console.log('Address updated with success');
                    } else {
                        if (data.errorCode === 0) {
                           
                        } else {
                            console.log('Error during data update');
                        }
                    }    
                }
            },
            error: function(xhr, status, error) {
                // Gère les erreurs de la requête AJAX
                console.log('AJAX error: ' + error);
            }
        });
    });

    function addAddress(formElement, is_checkout_v2 = false, is_new_address = true, address_id = "last", is_billing = false) {
        return new Promise((resolve, reject) => {
    
            // Récupère les données du formulaire
            var formData = formElement.serialize();

            $('.error-message').remove();
            //add address_id to formData
    
            var first_name = formElement.find('input[name="first_name"]');
            var last_name = formElement.find('input[name="last_name"]');
            var country = formElement.find('.country');
            var email = formElement.find('input[name="email_address"]');
            var emailValue = email.val();
            var address_1 = formElement.find('input[name="address_1"]');
            var address_2 = formElement.find('input[name="address_2"]');
            var city = formElement.find('input[name="city"]');
            var zipcode = formElement.find('input[name="zipcode"]');
            var phone = formElement.find('input[name="phone"]');
            var state = formElement.find('.state');

            if( !is_new_address && address_id != "same" && address_id != "different"){ 
            formData += '&address_id=' + address_id;
            }
            formData += '&is_billing=' + is_billing;
    
            // Vérifie si les champs sont vides
            if (first_name.val() === '') addErrorMessage(first_name, oDict['address_enter_first_name']);
            if (last_name.val() === '') addErrorMessage(last_name, oDict["address_enter_last_name"]);
            if (country.val() === null) addErrorMessage(country, oDict["address_select_country"]);
            if (state.val() === '') addErrorMessage(state, oDict["address_select_state"]);
            console.log('state', state.val());
            if (emailValue === '' && is_billing == false) {
                addErrorMessage(email, oDict["address_enter_email"]);
            } else if ((!validateEmail(emailValue) || ( ! is_checkout_v2 && emailValue.includes("privaterelay.appleid.com") )) && is_billing == false) {
                addErrorMessage(email, oDict["enter_valid_email"]);
            }
            if (address_1.val() === '') addErrorMessage(address_1, oDict["address_enter_address"]);
            if (city.val() === ''){
                console.log('city is empty');
                addErrorMessage(city, oDict["address_enter_city"]);
            }
            if (zipcode.val() === '' && zipcode.attr('data-require') == 'yes') addErrorMessage(zipcode, oDict["address_enter_zipcode"]);
            if (phone.val() === '') {
                addErrorMessage(phone, oDict["address_enter_phone"]);
                $('.phone-description').hide();
            } else {
                $('.phone-description').show();
            }
    
            if ($('#account-area-section-address-form .error-message').length > 0) {
                reject({ success: false });
                $('html, body').animate({
                    scrollTop: $('.error-message').first().offset().top - 100
                }, 500);
                return;
            }
    
            $('#account-area-section-address-form input[type="submit"]').prop('disabled', true);
            $('#account-area-section-address-form input[type="submit"]').val(oDict["saving_address"]);
    
            $.ajax({
                url: formElement.attr('action'),
                type: 'POST',
                data: formData,
                success: async function (data, status, xhr) {
                    var redirectUrl = xhr.getResponseHeader('Location');
    
                    if (xhr.status === 201) {
                        var e = new Event('click');
    
                        if (!is_checkout_v2) {
                            var emailData = $('#form_address_popin-modal input[type="email"][name="email_address"]').data('default-email');
                            updateAddressForm({
                                email: emailData,
                                first_name: $('#account-area-section-address-form #first_name').attr('data-default-firstname'),
                                last_name: $('#account-area-section-address-form #last_name').attr('data-default-lastname')
                            });
    
                            var url = new URL(window.location.href);
                            var typeTransaction = url.searchParams.get('act');
                            var transactionId = url.searchParams.get('key');
    
                            if (typeTransaction && transactionId) {
                                await changeAddress(e, "last", typeTransaction, transactionId);
                            } else {
                                getAddresses();
                            }
                        } else {
                            if( address_id == "different"){
                                
                                if(data.address_id){
                                    address_id = data.address_id;
                                }else if($('.checkout-container-left-payment-billing-section-selector-form .address_selector option:selected').length > 0){
                                    address_id = $('.checkout-container-left-payment-billing-section-selector-form .address_selector option:selected').val();
                                }
                            }
                            if(is_billing == false){
                                const address_result = await changeAddress(e, address_id, 'bn', $('input[name="buykey"]').val());

                                if (address_result) {
                                    $('.checkout-container-left-step').removeClass('active');
                                    $('.checkout-container-left-step[data-step="shipping"]').addClass('active');
                                }
                            }else{
                                const address_result = changeAddressBilling(e, address_id, "bn", document.querySelector('input[name="buykey"').value);
                            }
                        }
    
                        // Construction de l'adresse inline
                        var address_inline = '';
                        address_inline += address_1.val()
                        if (address_2.val() !== '') address_inline += ', ' + address_2.val();
                        address_inline += ', ' + city.val() + ' ' 
                        if(state.find('option:selected').val()){
                            address_inline += state.find('option:selected').val() + ' '
                        }
                        if (zipcode.val()) {
                            address_inline += zipcode.val() + ', ';
                        }
                        address_inline += country.find('option:selected').text();
                        
                        var address_details = {
                            first_name: first_name.val(),
                            last_name: last_name.val(),
                            email: email.val(),
                            address_1: address_1.val(),
                            address_2: address_2.val(),
                            city: city.val(),
                            zipcode: zipcode.val(),
                            country: country.find('option:selected').text(),
                            phone: phone.val(),
                            state: state.find('option:selected').val()
                        }
    
                        resolve({ success: true, address: address_inline, address_details: address_details, address_id: data.address_id });
    
                    } else {
                        reject({ success: false });
                    }
                },
                error: function (xhr, status, error) {
                    console.log('AJAX error: ' + error);
                    reject({ success: false });
                }
            });
        });
    }

    function updateStep(step){

        $('.checkout-container-left-country_change_message').hide();

        if(step != "payment"){
            $('.checkout-container-left-header-nav span').removeClass('active');
            $('.checkout-container-left-header-nav span[data-step="' + step + '"]').addClass('active');

            $('.checkout-container-left-step').removeClass('active');
            $('.checkout-container-left-step[data-step="' + step + '"]').addClass('active');

            $('.checkout-btn-go-step').removeClass('active');
            $('.checkout-btn-go-step[data-step="' + step + '"]').addClass('active');
        }

        if(step == 'information'){
            $('.checkout-container-left-summary').removeClass('active');
        }else if(step == 'shipping'){
            $('.checkout-container-left-summary-contact.shipping').removeClass('active');
        }else{
            $('.checkout-container-left-summary').addClass('active');
        }

        if ( step == 'information' ) {
            // $('.checkout-container-right-coupon').addClass( 'd-none' ); // ced
            sendEventLogger( 'buy_step_information' );
            $('.checkout-container-right-coupon').hide()
        }
        if ( step == 'shipping' ) {
            // $('.checkout-container-right-coupon').addClass( 'd-none' ); // ced
            $('.checkout-container-right-coupon').show()
            $('.checkout-container-right').removeClass('active');
            sendEventLogger( 'buy_step_shipping' );

            //request /update-shipping 

        }
        if ( step == 'payment' ) {
            // $('.checkout-container-right-coupon').removeClass( 'd-none' ); // ced
            // $('.checkout-container-right-coupon').hide()
            $('.checkout-container-right').removeClass('active');
            sendEventLogger( 'buy_step_payment' );

            //var buykey = $('input[name="buykey"]').val();
            //initiateAdyenSession(buykey);
            console.log('NEW: initiate adyen session');
            //reload page
            
        }

        //get param step and update it or create it
        var url = new URL(window.location.href);
        url.searchParams.set('step', step);
        history.pushState({}, '', url);

        if ( step == 'payment' ) {
            window.location.reload();
        }

        $('html, body').animate({ scrollTop: 0 }, 500);
    }

    $('.checkout-btn-go-step').on('click', function (e) {
        e.preventDefault(); // Empêche le rechargement de la page
        //get current step from url param step
        var currentStep = new URL(window.location.href).searchParams.get('step');
        var stepOrder = ['information', 'shipping', 'payment'];
        var step = $(this).data('step');
        //if step is after the current step then block the click
        if (stepOrder.indexOf(step) > stepOrder.indexOf(currentStep)) {
            return;
        }
        if (!$(this).hasClass('blocked')) {
            updateStep(step);
        }
    });

    $('a[data-action="checkout-shipping-form"]').on('click', function (e) {
        e.preventDefault(); // Empêche le rechargement de la page

        //call pour ajouter frais de shipping
        var shipping = $('.checkout-container-left-shipping-method-item.active').data('shipping');
        var key = $('input[name="buykey"]').val();

        if (shipping) {
            $.ajax({
                url: $(this).data('url'),
                type: 'POST',
                data: { key: key, shipping: shipping, type: 'buy' },
                success: function (data, status, xhr) {
                    if (xhr.status === 201) {
                        
                        //get json response with amount_total and amount_shipping
                        var amount_total = data.amount_total;
                        var amount_shipping = data.amount_shipping;
                        var currencySymbol = $('span[data-checkout-summary="amount_shipping"]').data('currency');
                        // $('span[data-checkout-summary="amount_total"]').text(amount_total);
                        // $('span[data-checkout-summary="amount_total"]').text(
                        //     Number(amount_total).toLocaleString('en-US')
                        // );
                        // $('span[data-checkout-summary="amount_shipping"]').text(currencySymbol + '' + amount_shipping);

                        updateStep('payment');
                    }
                },
                error: function (xhr, status, error) {
                    console.log('AJAX error: ' + error);
                }
            });
        }

        // $('[data-checkout-field="shipping"]').closest('.checkout-container-left-summary-contact').addClass('active');
    });

    const url_checkout = new URL(window.location.href);
    // Vérifier si l'URL contient "/checkout/new" et le paramètre "key"
    if (url_checkout.pathname.includes('/checkout/new') && url_checkout.searchParams.has('key')) {
        const key = url_checkout.searchParams.get('key');
        // Remplacer "/checkout/new" par "/checkout/{key}"
        const newPath = url_checkout.pathname.replace('/checkout/new', `/checkout/${key}`);
        // Mettre à jour l'URL sans les paramètres
        history.replaceState({}, '', newPath);

        //replace in href
        var checkoutLink = $('#checkout-guest-form .btn-google').attr('href');
        if(checkoutLink) {
            checkoutLink = checkoutLink.replace('/checkout/new', `/checkout/${key}`);
            $('#checkout-guest-form .btn-google').attr('href', checkoutLink);
        }
        
    }
    if($('.payment_overlay-content.step_error a').attr('href') && $('.payment_overlay-content.step_error a').attr('href').includes('/checkout/new')) {
        // Replace '/checkout/new' by '/checkout/' + buykey value
        var buykey = $('input[name="buykey"]').val();
        var newHref = $('.payment_overlay-content.step_error a').attr('href').replace('/checkout/new', '/checkout/' + buykey);
        //if it contains ?step=payment we update to ?step=payment
        if(newHref.includes('shipping')) {
            newHref = newHref.replace('shipping', 'payment');
        }
        $('.payment_overlay-content.step_error a').attr('href', newHref);
    }
    // Vérifier si l'URL contient "/checkout/" et les paramètres paypal
    if (url_checkout.pathname.includes('/checkout/')) {
        //get params addp + redirect_status == "succeeded"
        const addp = url_checkout.searchParams.get('addp');
        const redirect_status = url_checkout.searchParams.get('redirect_status');
        if(addp && redirect_status == "succeeded"){    
            const eventLog = new CustomEvent('event_checkout_payment_saved', { 
                detail: { status: 'ok' }
            });                                    
            document.dispatchEvent(eventLog);
            $('.payment_overlay').removeClass('hidden');
            setTimeout(function() {  
                $('#confirmOrder').trigger('click');
            }, 1000);
            setTimeout(function() {
                $('.payment_overlay').addClass('hidden');
            }, 5000);
        }else if(addp && redirect_status != "succeeded"){
            const eventLog = new CustomEvent('event_checkout_payment_saved', { 
                detail: { status: 'ko', error: "Paypal adding failed" }
            });  
            document.dispatchEvent(eventLog);
        }
    }

    async function initiateAdyenSession(buykey = null) {

        const response = await fetch('/us/en/adyen/get_new_session', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ sgz: 'us', is_json: true, buykey: buykey }),
        });

        if (response.ok) {
            const data = await response.json(); // Convertir la réponse en JSON
            $('.initiate_adyen_checkout').html(data.results);
            initCheckout(false);
            console.log('INIT CHECKOUT JS')
        } else {
            console.error('Erreur dans la réponse de l\'API:', response);
            return;
        }
    }
    

    $('#checkout-guest-form, .checkout-address-form').on('submit', function (e) {
        e.preventDefault(); // Empêche le rechargement de la page
    });

    let firstFilledLogged = false;

    $('#fa_address_checkout.checkout-address-form :input').on('blur', function () {
        const value = $(this).val().trim();

        setTimeout(function() {
            if($('#fa_address_checkout.checkout-address-form select[name="state"]').val() != ''){
                $('#fa_address_checkout.checkout-address-form select[name="state"]').css('color', 'rgb(42, 42, 42)');
                $('#fa_address_checkout.checkout-address-form select[name="state"]').css('border-radius', '7px !important');
            }
        }, 300);

        if (!firstFilledLogged && value !== '') {
            sendEventLogger('checkout_shipping_form_started')
            firstFilledLogged = true;
        }
    });

    $('#fa_checkout_billing.checkout-address-form :input').on('blur', function () {

        setTimeout(function() {
            if($('#fa_checkout_billing.checkout-address-form select[name="state"]').val() != ''){
                $('#fa_checkout_billing.checkout-address-form select[name="state"]').css('color', 'rgb(42, 42, 42)');
                $('#fa_checkout_billing.checkout-address-form select[name="state"]').css('border-radius', '7px !important');
            }
        }, 300);
    });

    function callUpdateShipping(){
        var shipping = $('.checkout-container-left-shipping-method-item.active').data('shipping');
        var key = $('input[name="buykey"]').val();

        if (shipping) {
            $.ajax({
                url: $('a[data-action="checkout-shipping-form"]').data('url'),
                type: 'POST',
                data: { key: key, shipping: shipping, type: 'buy' },
                success: function (data, status, xhr) {
                    if (xhr.status === 201) {
                        
                        var amount_total = data.amount_total_with_currency;
                        var amount_shipping = data.amount_shipping_with_currency;
                        var currencySymbol = $('span[data-checkout-summary="amount_shipping"]').data('currency');
                        $('span[data-checkout-summary="amount_total"]').text(amount_total);
                        // $('span[data-checkout-summary="amount_total"]').text(
                        //     Number(amount_total).toLocaleString('en-US')
                        // );
                        $('span[data-checkout-summary="amount_shipping"]').text(amount_shipping);
                        $('.checkout-container-right-total-credit').remove();

                        updateStep('shipping');
                    }
                },
                error: function (xhr, status, error) {
                    console.log('AJAX error: ' + error);
                }
            });
        }
    }

    $('#fa_address_checkout.checkout-address-form select').on('change', function () {
        var currentSgz = $(this).data('sgz');
        var selectedOptionSgz = $(this).find('option:selected').data('sgz');
        if (currentSgz !== selectedOptionSgz && selectedOptionSgz) {
            //get the current url, and replace the market segment
            var currentUrl = window.location.href;
            var newUrl = currentUrl.replace(/\/[a-z]{2}\//, '/' + selectedOptionSgz + '/');
            //adding param the addrid
            setTimeout(function() {
                var addrId = $('#fa_address_checkout.checkout-address-form input[name="address_id"]').val();
                if (addrId) {
                    if (newUrl.indexOf('?') !== -1) {
                        newUrl += '&addrid=' + addrId;
                    } else {
                        newUrl += '?addrid=' + addrId;
                    }
                }
                window.history.pushState({ path: newUrl }, '', newUrl);
                //reload the page
                console.log('addrid', addrId);
                // reload the page without addrid param
                window.location.href = newUrl;
            }, 300);
            }
    });
    //si on trouve le param addrid on le supprime de l'url
    const urlParamsCheckout = new URLSearchParams(window.location.search);
    if (urlParamsCheckout.has('addrid')) {
        const addrid = urlParamsCheckout.get('addrid');
        console.log('remove addrid from url', addrid);
        urlParamsCheckout.delete('addrid');
        const newUrl = window.location.pathname + (urlParamsCheckout.toString() ? '?' + urlParamsCheckout.toString() : '');
        window.history.replaceState({}, '', newUrl);
    }


    function mobileScrollToTop() {
        if (window.innerWidth <= 768) {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }
    }

    function levenshtein(a, b) {
        if (a.length === 0) return b.length;
        if (b.length === 0) return a.length;

        const matrix = [];

        for (let i = 0; i <= b.length; i++) {
            matrix[i] = [i];
            if (i === 0) continue;

            for (let j = 1; j <= a.length; j++) {
                matrix[0][j] = j;
                matrix[i][j] = Math.min(
                    matrix[i - 1][j] + 1,      // suppression
                    matrix[i][j - 1] + 1,      // insertion
                    matrix[i - 1][j - 1] + (a[j - 1] === b[i - 1] ? 0 : 1) // substitution
                );
            }
        }

        return matrix[b.length][a.length];
    }

    const knownDomains = [
        "163.com",
        "aim.com",
        "att.net",
        "bell.net",
        "bellsouth.net",
        "btinternet.com",
        "comcast.net",
        "cox.net",
        "earthlink.net",
        "eim.ae",
        "emirates.net.ae",
        "freenet.de",
        "gmail.com",
        "gmx.de",
        "googlemail.com",
        "hotmail.ae",
        "hotmail.co.uk",
        "hotmail.com",
        "hotmail.com.sa",
        "hotmail.com.tw",
        "icloud.com",
        "live.co.uk",
        "live.com",
        "m1.com.sg",
        "mac.com",
        "mail.com",
        "mail.ru",
        "me.com",
        "msa.hinet.net",
        "msn.com",
        "myyahoo.com",
        "naver.com",
        "optonline.net",
        "outlook.ae",
        "outlook.com",
        "outlook.sa",
        "pchome.com.tw",
        "proton.me",
        "protonmail.com",
        "qq.com",
        "rocketmail.com",
        "rogers.com",
        "sbcglobal.net",
        "seed.net.tw",
        "shaw.ca",
        "singnet.com.sg",
        "sky.com",
        "starhub.net.sg",
        "sympatico.ca",
        "t-online.de",
        "verizon.net",
        "virginmedia.com",
        "web.de",
        "yahoo.ca",
        "yahoo.co.jp",
        "yahoo.co.uk",
        "yahoo.com",
        "yahoo.com.hk",
        "yahoo.com.tw",
        "yahoo.de",
    ];

    let hasConfirmedSuspiciousEmail = false;
    let lastSuspiciousEmail = null;

    function isSuspiciousDomain(email) {
        const domain = email.split('@')[1]?.toLowerCase().trim();
        if (!domain) return false;

        // 1. Si le domaine est déjà dans la liste, ce n'est PAS suspect
        if (knownDomains.includes(domain)) {
            return false;
        }

        // 2. Sinon, on cherche une suggestion
        let bestMatch = null;
        let bestDistance = Infinity;

        for (const good of knownDomains) {
            const distance = levenshtein(domain, good);

            if (distance < bestDistance) {
                bestDistance = distance;
                bestMatch = good;
            }
        }

        // On suggère seulement si c'est assez proche (1 ou 2)
        if (bestDistance > 0 && bestDistance <= 2) {
            return bestMatch;
        }

        return false;
    }

    $(document).on('click', 'a[data-action="checkout-login-form"]', function (e) {
        e.preventDefault(); 

        const $email = $('#checkout-guest-form input[name="email"]');
        const emailVal = $email.val().trim();
        $('.error-message').remove();

        if (!emailVal) {
            addErrorMessage($email, oDict["address_enter_email"]);
            return;
        }

        if (emailVal.includes('@example')) {
            addErrorMessage($email, oDict["enter_valid_email"]);
            return;
        }

        if (hasConfirmedSuspiciousEmail && lastSuspiciousEmail === emailVal) {
            $('#checkout-guest-form').submit();
            return;
        }

        const suggestion = isSuspiciousDomain(emailVal);
        if (suggestion) {
            hasConfirmedSuspiciousEmail = true;       // l’utilisateur confirme au prochain clic
            lastSuspiciousEmail = emailVal;

            addErrorMessage(
                $email,
                `${oDict["enter_email_similar"]} 
                <strong style="text-decoration: underline; cursor: pointer;" 
                        class="similar_email_select" 
                        data-email='${emailVal.split('@')[0]}@${suggestion}'>
                    ${emailVal.split('@')[0]}@${suggestion}
                </strong> ?`
            );
            return;
        }

        hasConfirmedSuspiciousEmail = false;
        lastSuspiciousEmail = null;

        $('#checkout-guest-form').submit();
    });

    $(document).on('click', '.similar_email_select', function () {
        const suggestedEmail = $(this).data('email');
        $('#checkout-guest-form input[name="email"]').val(suggestedEmail);
        $('.error-message').remove();
    });

    $(document).on('click', 'a[data-action="checkout-address-form"]', function (e) {
    // $('a[data-action="checkout-address-form"]').on('click', function (e) {
        e.preventDefault(); // Empêche le rechargement de la page

        $('.btn-tel-input-validate').trigger('click');

        $('.error-message').remove();

        if ($('#checkout-guest-form input[name="newsletter"]').is(':visible')) {
            if ($('#checkout-guest-form input[name="newsletter"]').is(':checked')) {
                //call ajax to subscribe to newsletter
                console.log('sent newsletter');
                
                $.ajax({
                    url: '/account/email-comm',
                    type: 'POST',
                    data: {},
                    success: function(data, status, xhr) {
                        $('#checkout-guest-form label[for="newsletter"]').fadeOut();
                    },
                    error: function(xhr, status, error) {
                        console.log('AJAX error: ' + error);
                    }
                });
            }
        }


        var form_element = $('.checkout-container-left-address .checkout-address-form');

        var first_name = form_element.find('input[name="first_name"]');
        var last_name = form_element.find('input[name="last_name"]');
        var country = form_element.find('.country');
        var email = $('form#checkout-guest-form input[name="email"]')
        var emailValue = email.val();
        var address_1 = form_element.find('input[name="address_1"]');
        var address_2 = form_element.find('input[name="address_2"]');
        var city = form_element.find('input[name="city"]');
        var zipcode = form_element.find('input[name="zipcode"]');
        var phone = form_element.find('input[name="phone"]');
        var state = form_element.find('select[name="state"]');

        // Vérifie si les champs sont vides
        if (first_name.val() === '') {
            addErrorMessage(first_name, oDict['address_enter_first_name']);
        }
        if (last_name.val() === '') {
            addErrorMessage(last_name, oDict["address_enter_last_name"]);
        }
        if (country.val() === null) {
            addErrorMessage(country, oDict["address_select_country"]);
        }
        // if (emailValue === '') {
        //     addErrorMessage(email, oDict["address_enter_email"]);
        // }else if(!validateEmail( emailValue )){
        //     addErrorMessage(email, oDict["enter_valid_email"]);
        // }else if(emailValue.includes("privaterelay.appleid.com")){
        //     addErrorMessage(email, oDict["enter_valid_email"]);
        // }
        if (address_1.val() === '') {
            addErrorMessage(address_1, oDict["address_enter_address"]);
        }
        if (city.val() === '') {
            addErrorMessage(city, oDict["address_enter_city"]);
            console.log('city is empty');
        }
        if (state.val() === '' || state.val() === 'State') {
            addErrorMessage(state, oDict["address_enter_state"]);
        }
        console.log('zipcode', zipcode.val(), 'require', zipcode.data('require'));
        if (zipcode.val() === '' && zipcode.data('require') == 'yes') {
            addErrorMessage(zipcode, oDict["address_enter_zipcode"]);
        }

        if ( phone.val() === '' ) {
            addErrorMessage(phone, oDict["address_enter_phone"]);
            $('.phone-description').hide();
        } else {
            // window.validatePhoneNumber();
            if ( $('#error-msg-tel-input').text() != '' ) {
                addErrorMessage(phone, '' );
                $('.phone-description').hide();
            } else {
                $('.phone-description').show();
            }
        }

        if($('.checkout-address-form .error-message').length > 0) {
            $('html, body').animate({
                scrollTop: $('.error-message').first().offset().top - 100
            }, 500);
            return;
        }
        // if($('#checkout-guest-form input[name="email"]').val().length > 0){
        //     //check if email is valid
        //     console.log('testing 1')
        //     $.ajax({
        //     url: $('#checkout-guest-form').attr('data-verify'),
        //     type: 'POST',
        //     data: { email: $('#checkout-guest-form input[name="email"]').val() },
        //     success: function(data, status, xhr) {
        //         console.log('testing 2')
        //         var redirectUrl = xhr.getResponseHeader('Location');
        //         if (xhr.status === 201) {
        //             $('#checkout-guest-form .error-message').remove();
        //         } else if (xhr.status === 202) {
        //             if($('#checkout-guest-form .error-message').length > 0){
        //                 $('#checkout-guest-form .error-message').remove();
        //             }
        //             addErrorMessage($('#checkout-guest-form input[name="email"]'), oDict["email_already_exists_long"]);
        //             return;
        //         }
        //     },
        //     error: function(xhr, status, error) {
        //         console.log(baseUrl + $('#checkout-guest-form').attr('action'));
        //         console.log('AJAX error: ' + error);
        //     }
        //     });
        // }

        sendEventLogger('checkout_shipping_form_filled')

        //check if user is logged in
        $.ajax({
            url: '/account/isloggedin',
            type: 'POST',
            data: {},
            success: function(data, status, xhr) {
                var redirectUrl = xhr.getResponseHeader('Location');
                if (xhr.status === 201) {
                    //we can update the address
                    // changeAddress(e, "last", 'bn', $('input[name="buykey"]').val());
                    var is_new_address = false;
                    var address_id = "last";
                    if($('select[name="address_selector"]').val() == 'new' || $('select[name="address_selector"]').val() == undefined){
                        is_new_address = true;
                    } else {
                        address_id = $('select[name="address_selector"] option:selected').data('id');
                    }

                    if(is_new_address){
                        addAddress($('.checkout-container-left-address .checkout-address-form'), true, is_new_address).then(address_result => {
                            console.log(address_result);
                            if (address_result.success === true) {

                                //request /update-shipping
                                callUpdateShipping();

                                $('.checkout-container-left-summary').addClass('active');

                                $('.checkout-container-left-header-nav span').removeClass('active');
                                $('.checkout-container-left-header-nav span[data-step="shipping"]').addClass('active');
                        
                                $('[data-checkout-field="email"]').text($('#checkout-guest-form input[name="email"]').val().trim());
                                $('[data-checkout-field="email"]').closest('.checkout-container-left-summary-contact').addClass('active');
                        
                                $('[data-checkout-field="address"]').text(address_result.address);
                                $('[data-checkout-field="address"]').closest('.checkout-container-left-summary-contact').addClass('active');

                                //we add the address to the select
                                $('select[name="address_selector"]').append('<option selected value="' + address_result.address_id + '" data-id="' + address_result.address_id + '" data-details=\'' + JSON.stringify(address_result.address_details) + '\'>' + address_result.address + '</option>');
                                $('select[name="address_selector"]').val(address_result.address_id).trigger('change');

                                $('.checkout-container-left-payment-billing-section-selector-form input[name="email_address"]').val($('#checkout-guest-form input[name="email"]').val().trim());

                                // sendEventLogger('checkout_shipping_form_filled')

                                updateStep('shipping');
                            }
                        }).catch(error => {
                            console.error('Erreur lors de l’ajout de l’adresse :', error);
                        });

                    }else{
                        // Update address in case it has been changed + temp fix for missing state
                        addAddress($('.checkout-container-left-address .checkout-address-form'), true, false, address_id).then(address_result => {
                            console.log(address_result);
                            if (address_result.success === true) {

                                //request /update-shipping
                                callUpdateShipping();

                                $('.checkout-container-left-summary').addClass('active');

                                $('.checkout-container-left-header-nav span').removeClass('active');
                                $('.checkout-container-left-header-nav span[data-step="shipping"]').addClass('active');
                        
                                $('[data-checkout-field="email"]').text($('#checkout-guest-form input[name="email"]').val().trim());
                                $('[data-checkout-field="email"]').closest('.checkout-container-left-summary-contact').addClass('active');
                        
                                $('[data-checkout-field="address"]').text(address_result.address);
                                $('[data-checkout-field="address"]').closest('.checkout-container-left-summary-contact').addClass('active');

                                $('.checkout-container-left-payment-billing-section-selector-form input[name="email_address"]').val($('#checkout-guest-form input[name="email"]').val().trim());

                                // sendEventLogger('checkout_shipping_form_filled')

                                updateStep('shipping');
                            }
                        }).catch(error => {
                            console.error('Erreur lors de l’ajout de l’adresse :', error);
                        });

                        /*
                        const address_result = changeAddress(e, $('select[name="address_selector"] option:selected').data('id'), 'bn', $('input[name="buykey"]').val());
    

                        if (address_result) {
                            $('.checkout-container-left-step').removeClass('active');
                            $('.checkout-container-left-step[data-step="shipping"]').addClass('active');

                            if($('select[name="address_selector"] option:selected').data('details')){
                                var lineDetails = $('select[name="address_selector"] option:selected').data('details');
                                var address_inline = '';
                                address_inline += lineDetails.address_1
                                if (lineDetails.address_2 !== '') address_inline += ', ' + lineDetails.address_2;
                                address_inline += ', ' + lineDetails.city + ' ' + lineDetails.state + ' ' + lineDetails.zipcode + ', ' + lineDetails.country;

                                $('[data-checkout-field="address"]').text(address_inline);
                                $('[data-checkout-field="address"]').closest('.checkout-container-left-summary-contact').addClass('active');

                                updateStep('shipping');
                            }
                            
                        }
                        */
                    }

                    // if(address_result.success == true){
                    //     $('.checkout-container-left-summary').addClass('active');

                    //     $('[data-checkout-field="email"]').text($('#checkout-guest-form input[name="email"]').val().trim());
                    //     $('[data-checkout-field="email"]').closest('.checkout-container-left-summary-contact').addClass('active')

                    //     $('[data-checkout-field="address"]').text(address_result.address);
                    //     $('[data-checkout-field="address"]').closest('.checkout-container-left-summary-contact').addClass('active');
                    // }

                    $('html, body').animate({ scrollTop: 0 }, 500);

                } else {
                    //we need to signup as guest  
                    
                    var email = $('#checkout-guest-form input[name="email"]').val().trim();
                    console.log(email);

                    if (email === '') {
                        addErrorMessage($('input[name="email"]'), oDict["enter_your_email"]);
                        mobileScrollToTop();

                    } else if (!/^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/.test(email)) {
                        addErrorMessage($('input[name="email"]'), oDict["enter_valid_email"]);
                        mobileScrollToTop();
                    }

                    if($('.error-message').length > 0) {
                        return;
                    }

                    $('.checkout-container-left-address .checkout-address-form input[name="email_address"]').val(email);

                    grecaptcha.enterprise.ready(function() {
                        grecaptcha.enterprise.execute('6LdkTGQpAAAAADf8F07OFECYPJZ2-TPT-KzZAX5l', {action: 'signup'}).then(function(token) {
                            $('#recaptchaTokenSignupCheckoutGuest').val(token);

                            var currentUrl = window.location.href;
                            var urlObject = new URL(currentUrl);
                            var baseUrl = urlObject.origin;

                            var formData = $('#checkout-guest-form').serialize();
                            formData += '&guest=true';

                            $.ajax({
                                url: $('#checkout-guest-form').attr('action'),
                                type: 'POST',
                                data: formData,
                                success: function(data, status, xhr) {
                                    var redirectUrl = xhr.getResponseHeader('Location');
                                    if (xhr.status === 201) {
                                        addAddress($('.checkout-container-left-address .checkout-address-form'), true).then(address_result => {
                                            console.log(address_result);
                                            if (address_result.success === true) {

                                                //request /update-shipping
                                                callUpdateShipping();

                                                $('.checkout-container-left-summary').addClass('active');

                                                $('html, body').animate({ scrollTop: 0 }, 500);

                                                $('.checkout-container-left-header-nav span').removeClass('active');
                                                $('.checkout-container-left-header-nav span[data-step="shipping"]').addClass('active');
                                        
                                                $('[data-checkout-field="email"]').text($('#checkout-guest-form input[name="email"]').val().trim());
                                                $('[data-checkout-field="email"]').closest('.checkout-container-left-summary-contact').addClass('active');
                                        
                                                $('[data-checkout-field="address"]').text(address_result.address);
                                                $('[data-checkout-field="address"]').closest('.checkout-container-left-summary-contact').addClass('active');

                                                $('.logout-btn.checkout-container-left-contact-connect').addClass('active');
                                                $('.open-login-modal.checkout-container-left-contact-connect').removeClass('active');
                                                $('.checkout-container-left-contact #checkout-guest-form #email_address').prop('disabled', true)

                                                $('.checkout-container-left-payment-billing-section-selector-form input[name="email_address"]').val($('#checkout-guest-form input[name="email"]').val().trim());

                                                // sendEventLogger('checkout_shipping_form_filled')

                                                updateStep('shipping');


                                                //initiate adyen session
                                                // console.log('initiate adyen session');
                                                // initiateAdyenSession();
                                            }
                                        }).catch(error => {
                                            console.error('Erreur lors de l’ajout de l’adresse :', error);
                                        });
                                    } else {
                                        if (data.success) {
                                            console.log('Utilisateur créé avec succès');
                                        } else {
                                            if (data.errorCode === -2) {
                                                console.log('Email already exists');
                                                addErrorMessage($('#checkout-guest-form input[name="email"]'), oDict["email_already_exists"]);
                                            } else if (data.errorCode === -3 ) { // recaptcha
                                                addErrorMessage($('#checkout-guest-form input[name="password"]'), oDict["pwd_reset_bot_detected"]);
                                            } else {
                                                console.log('Erreur lors de la création de l\'utilisateur');
                                            }
                                        }                  
                                    }
                                },
                                error: function(xhr, status, error) {
                                    console.log(baseUrl + $('#checkout-guest-form').attr('action'));
                                    console.log('AJAX error: ' + error);
                                }
                            });

                        });
                    });

                    $('html, body').animate({ scrollTop: 0 }, 500);

                }                
            },
            error: function(xhr, status, error) {
                console.log(baseUrl + $('#checkout-guest-form').attr('action'));
                console.log('AJAX error: ' + error);
            }
        });
    });

    function checkGuestEmail( email ) {
        //check if user is logged in
        if( email !== undefined && email !== null && email.length > 0){
            $.ajax({
                url: $('#checkout-guest-form').attr('data-verify'),
                type: 'POST',
                data: { email: email },
                success: function(data, status, xhr) {
                    var redirectUrl = xhr.getResponseHeader('Location');
                    if (xhr.status === 201) {
                        console.log('OK : email not exists');
                        sendEventLogger('checkout_email_entered', {status: 'ok'});
                        $('#checkout-guest-form .error-message').remove();
                        $('#checkout-guest-form').attr('action', $('#checkout-guest-form').attr('data-signup'));
                        $('#checkout-guest-form').attr('data-guest', 'true');
                        $('#login_password_checkout').fadeOut();

                        $('.error-message').remove();
                        //we need to signup as guest  

                        var email = $('#checkout-guest-form input[name="email"]').val().trim();
                        console.log(email);

                        if (email === '') {
                            addErrorMessage($('input[name="email"]'), oDict["enter_your_email"]);
                            mobileScrollToTop();

                        } else if (!/^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/.test(email)) {
                            addErrorMessage($('input[name="email"]'), oDict["enter_valid_email"]);
                            mobileScrollToTop();
                        }

                        if($('#checkout-guest-form .error-message').length > 0) {
                            return;
                        }

                        $('.checkout-container-left-address .checkout-address-form input[name="email_address"]').val(email);

                        grecaptcha.enterprise.ready(function() {
                            grecaptcha.enterprise.execute('6LdkTGQpAAAAADf8F07OFECYPJZ2-TPT-KzZAX5l', {action: 'signup'}).then(function(token) {
                                $('#recaptchaTokenSignupCheckoutGuest').val(token);

                                var currentUrl = window.location.href;
                                var urlObject = new URL(currentUrl);
                                var baseUrl = urlObject.origin;

                                var formData = $('#checkout-guest-form').serialize(); 
                                formData += '&guest=true';

                                $.ajax({
                                    url: $('#checkout-guest-form').attr('action'),
                                    type: 'POST',
                                    data: formData,
                                    success: function(data, status, xhr) {
                                        var redirectUrl = xhr.getResponseHeader('Location');
                                        if (xhr.status === 201) {

                                            //update checkout with user_id
                                            $.ajax({
                                                url: '/order/update-id',
                                                type: 'POST',
                                                data: { buykey: $('input#buykey').val(), type: 'buy' },
                                                success: function (data, status, xhr) {
                                                },
                                                error: function (xhr, status, error) {
                                                    console.log('AJAX error: ' + error);
                                                }
                                            });

                                            // $('html, body').animate({ scrollTop: 0 }, 500);

                                            // $('.checkout-container-left-header-nav span').removeClass('active');
                                            // $('.checkout-container-left-header-nav span[data-step="shipping"]').addClass('active');

                                            // $('[data-checkout-field="email"]').text($('#checkout-guest-form input[name="email"]').val().trim());
                                            // $('[data-checkout-field="email"]').closest('.checkout-container-left-summary-contact').addClass('active');

                                            // $('[data-checkout-field="address"]').closest('.checkout-container-left-summary-contact').addClass('active');

                                            // $('.logout-btn.checkout-container-left-contact-connect').addClass('active');
                                            // $('.open-login-modal.checkout-container-left-contact-connect').removeClass('active');
                                            // $('.checkout-container-left-contact #checkout-guest-form #email_address').prop('disabled', true)

                                            // $('.checkout-container-left-payment-billing-section-selector-form input[name="email_address"]').val($('#checkout-guest-form input[name="email"]').val().trim());

                                            // sendEventLogger('checkout_shipping_form_filled')

                                            // updateStep('shipping');

                                            //display shipping
                                            // $('.checkout-container-left-address').fadeIn();
                                            // $('.checkout-container-left-secure').hide();
                                            // $('.checkout-container-left-secure').addClass('d-none');
                                            // $('#checkout-guest-form label[for="newsletter"]').fadeIn();
                                            //Update button
                                            // $('.checkout-container-left-btns .btn-primary[data-action="checkout-login-form"]').text(oDict['checkout_btn_continue_to_shipping']);
                                            // $('.checkout-container-left-btns .btn-primary[data-action="checkout-login-form"]').attr('data-action', 'checkout-address-form');
                                            // $('#checkout-continue').removeClass('d-none');
                                            // $('#email-continue').addClass('d-none');
                                            // $('.checkout-container-left-express').addClass('d-none');
                                            // $('#email_submessage').addClass('d-none');
                                            // $('#or_continue_with').addClass('d-none');
                                            // $('.checkout-container-left-contact').css('padding-top', '30px');

                                            $('.checkout-sso-btns').hide();


                                            // initiate adyen session
                                            // initiateAdyenSession();
                                            //reload page
                                            window.location.reload();
                                        } else {
                                            if (data.success) {
                                                console.log('user successfully created');
                                                window.location.reload();
                                            } else {
                                                if (data.errorCode === -2) {
                                                    addErrorMessage($('#checkout-guest-form input[name="email"]'), oDict["email_already_exists"]);
                                                } else if (data.errorCode === -3 ) { // recaptcha
                                                    addErrorMessage($('#checkout-guest-form input[name="password"]'), oDict["pwd_reset_bot_detected"]);
                                                } else {
                                                }
                                            }                  
                                        }
                                    },
                                    error: function(xhr, status, error) {
                                        console.log(baseUrl + $('#checkout-guest-form').attr('action'));
                                        console.log('AJAX error: ' + error);
                                    }
                                });

                            });
                        });
                        //$('html, body').animate({ scrollTop: 0 }, 500);

                    } else if (xhr.status === 202 && data.user_login_type === 'native' && data.has_password == false){
                        var formData = $('#checkout-guest-form').serialize();
                        formData += '&guest=true';

                        const url = new URL(window.location.href);
                        const segments = url.pathname.split('/').filter(Boolean);
                        const baseHref = `/${segments[0]}/${segments[1]}`;

                        console.log(baseHref);

                        $.ajax({
                            url: `${baseHref}/account/login-guest`,
                            type: 'POST',
                            data: formData,
                            success: function(data, status, xhr) {
                                var redirectUrl = xhr.getResponseHeader('Location');
                                if (xhr.status === 201) {

                                    //update checkout with user_id
                                    $.ajax({
                                        url: '/order/update-id',
                                        type: 'POST',
                                        data: { buykey: $('input#buykey').val(), type: 'buy' },
                                        success: function (data, status, xhr) {
                                        },
                                        error: function (xhr, status, error) {
                                            console.log('AJAX error: ' + error);
                                        }
                                    });

                                    // $('html, body').animate({ scrollTop: 0 }, 500);

                                    // $('.checkout-container-left-header-nav span').removeClass('active');
                                    // $('.checkout-container-left-header-nav span[data-step="shipping"]').addClass('active');

                                    // $('[data-checkout-field="email"]').text($('#checkout-guest-form input[name="email"]').val().trim());
                                    // $('[data-checkout-field="email"]').closest('.checkout-container-left-summary-contact').addClass('active');

                                    // $('[data-checkout-field="address"]').closest('.checkout-container-left-summary-contact').addClass('active');

                                    // $('.logout-btn.checkout-container-left-contact-connect').addClass('active');
                                    // $('.open-login-modal.checkout-container-left-contact-connect').removeClass('active');
                                    // $('.checkout-container-left-contact #checkout-guest-form #email_address').prop('disabled', true)

                                    // $('.checkout-address-form input[name="email_address"]').val($('#checkout-guest-form input[name="email"]').val().trim());
                                    // $('.checkout-container-left-payment-billing-section-selector-form input[name="email_address"]').val($('#checkout-guest-form input[name="email"]').val().trim());

                                    // sendEventLogger('checkout_shipping_form_filled')

                                    // updateStep('shipping');

                                    //display shipping
                                    // $('.checkout-container-left-address').fadeIn();
                                    // $('#checkout-guest-form label[for="newsletter"]').fadeIn();
                                    //Update button
                                    // $('.checkout-container-left-btns .btn-primary[data-action="checkout-login-form"]').text(oDict["checkout_btn_continue_to_shipping"]);
                                    // $('.checkout-container-left-btns .btn-primary[data-action="checkout-login-form"]').attr('data-action', 'checkout-address-form');
                                    // $('#checkout-continue').removeClass('d-none'); // ced
                                    // $('#email-continue').addClass('d-none'); // ced
                                    // $('.checkout-container-left-express').addClass('d-none'); // ced
                                    // $('#email_submessage').addClass('d-none'); // ced
                                    // $('#or_continue_with').addClass('d-none'); // ced
                                    // $('.checkout-container-left-contact').css('padding-top', '30px');

                                    // $('.checkout-sso-btns').hide();


                                    //initiate adyen session
                                    // console.log('initiate adyen session');
                                    // initiateAdyenSession();
                                    //reload page
                                    window.location.reload();
                                } else {
                                    if (data.success) {
                                        console.log('user successfully created');
                                        window.location.reload();
                                    } else {
                                        if (data.errorCode === -2) {
                                            addErrorMessage($('#checkout-guest-form input[name="email"]'), oDict["email_already_exists"]);
                                        } else if (data.errorCode === -3 ) { // recaptcha
                                            addErrorMessage($('#checkout-guest-form input[name="password"]'), oDict["pwd_reset_bot_detected"]);
                                        } else {
                                        }
                                    }                  
                                }
                            },
                            error: function(xhr, status, error) {
                                console.log(baseUrl + $('#checkout-guest-form').attr('action'));
                                console.log('AJAX error: ' + error);
                            }
                        });
                    } else if (xhr.status === 202) {
                        $('#checkout-guest-form').attr('data-guest', 'false');
                        if($('#checkout-guest-form .error-message').length > 0){
                            $('#checkout-guest-form .error-message').remove();
                        }
                        $('#checkout-guest-form').attr('action', $('#checkout-guest-form').attr('data-login'));

                        $('#checkout-guest-form label[for="newsletter"]').fadeOut();
                        if(data.user_login_type == 'native'){
                            // $('#login_password_checkout').fadeIn();
                            // $('#checkout-guest-form .btn-google, #checkout-guest-form .btn-apple').css('opacity', '0.4');
                            //open login popup
                            $('#login-modal .login-modal-selector, #login-modal .btn-google, #login-modal .btn-apple, #login-modal [data-target="signup"], #login-modal .login-modal-proposition').hide();
                            $('#login_magic-modal input[name="email"]').val($('#checkout-guest-form input[name="email"]').val());
                            $('.open-login_magic-modal').click();
                            $('.login_magic-form_submit').click();
                        }else if(data.user_login_type == 'google'){
                            const origin = window.location.origin;
                            const encodedRelativeUrl = encodeURIComponent(window.location.pathname + window.location.search);
                            const googleRedir = origin + '/google-login/oauth?tfs_redirect=' + encodedRelativeUrl + '&sgz=us&lang=en';
                            window.location.href = googleRedir;
                            // addErrorMessage($('#checkout-guest-form input[name="email"]'), oDict["email_already_exists_long_google"]);
                        }else if(data.user_login_type == 'apple'){
                            const origin = window.location.origin;
                            const encodedRelativeUrl = encodeURIComponent(window.location.pathname + window.location.search);
                            const appleRedir = origin + '/apple-login/oauth?tfs_redirect=' + encodedRelativeUrl + '&sgz=us&lang=en';
                            window.location.href = appleRedir;
                            // addErrorMessage($('#checkout-guest-form input[name="email"]'), oDict["email_already_exists_long_apple"]);
                        }else{
                            addErrorMessage($('#checkout-guest-form input[name="email"]'), oDict["email_already_exists_long"]);
                        }
                        sendEventLogger('checkout_email_entered', {status: 'ko'});

                    }
                },
                error: function(xhr, status, error) {
                    if (xhr.status === 404) {
                        $('.error-message').remove();
                        addErrorMessage($('#email_address'), oDict["enter_valid_email"]);
                        console.log('AJAX error 404' );
                    } else {
                        console.log(baseUrl + $('#checkout-guest-form').attr('action'));
                        console.log('AJAX error: ' + error);
                    }
                }
            });
        }
    };

    //quand on presse enter dans le champ email
    $('#checkout-guest-form input[name="email"]').on('keypress', function(e) {
        if (e.which === 13 || e.key === 'Enter') {
            $('#checkout-guest-form a[data-action="checkout-login-form"]').click();
        }
    });

    //Check if url contains param sso_login, if yes we send the event to the logger and then remove it from the url
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('sso_login')) {
        const ssoLogin = urlParams.get('sso_login');
        sendEventLogger('checkout_account_login');
        urlParams.delete('sso_login');
        const newUrl = window.location.pathname + '?' + urlParams.toString();
        window.history.replaceState({}, '', newUrl);
    }

    //Custom event for billing
    // $(window).on('addAddressBilling', function (e) {
    //     if(e.originalEvent.detail.billingSelected == "same"){
    //         changeAddressBilling(e, "same", "bn", document.querySelector('input[name="buykey"').value);
    //     }else{
    //         addAddress($('.checkout-container-left-payment-billing-section-selector-form .checkout-address-form'), true, false, e.originalEvent.detail.billingSelected, true).then(address_result => {
    //             console.log(address_result);
    //             if (address_result.success === true) {
    //                 console.log('Adresse billing ajoutée avec succès');
    //             }
    //         }).catch(error => {
    //             console.error('Erreur lors de l’ajout de l’adresse :', error);
    //         });
    //     }
        
    // });
    window.addEventListener('addAddressBilling', function(e) {
        const billingSelected = e.detail.billingSelected;
        console.log('Event reçu :', billingSelected);
    
        if(e.detail.billingSelected == "same"){
            const address_result = changeAddressBilling(e, "same", "bn", document.querySelector('input[name="buykey"').value);
            const responseEvent = new CustomEvent('addAddressBillingResponse', {
                detail: {
                    success: true, 
                }
            });
            window.dispatchEvent(responseEvent);
        }else{
            addAddress($('.checkout-container-left-payment-billing-section-selector-form .checkout-address-form'), true, false, e.detail.billingSelected, true).then(address_result => {
                console.log(address_result);
                if (address_result.success === true) {
                    console.log('Adresse billing ajoutée avec succès');
                }

                // Puis renvoie une réponse
                const responseEvent = new CustomEvent('addAddressBillingResponse', {
                    detail: {
                        success: true, 
                    }
                });
                window.dispatchEvent(responseEvent);

            }).catch(error => {
                console.error('Erreur lors de l’ajout de l’adresse :', error);
                const responseEvent = new CustomEvent('addAddressBillingResponse', {
                    detail: {
                        success: false, 
                    }
                });
                window.dispatchEvent(responseEvent);
            });
        }
    
    });

    $('.checkout-container-right-quick').on('click', function (e) {
        if ($('.checkout-container-right-quick').hasClass('active')) {
            $('.checkout-container-right').fadeOut();
            $('.checkout-container-right-quick').removeClass('active');
        } else {
            // $('.checkout-container-right').css('display', 'flex').hide().fadeIn();
            $('.checkout-container-right').addClass('active').hide().fadeIn();
            $('.checkout-container-right-quick').addClass('active');
        }
    });

    $(document).on('click', '.checkout-container-left-payment-method-list-item ', function (e) {
        e.preventDefault(); // Empêche le rechargement de la page
        $('.checkout-container-left-payment-method-list-item').removeClass('active');
        $(this).addClass('active');

        var payment = $(this).attr('data-id');

        var url = new URL(window.location.href);
        var typeTransaction = 'bn';
        var transactionId = $('input[name="buykey"]').val();
        changePaymentMethod(e, payment, typeTransaction, transactionId);

        $('.checkout-container-left-btns #confirmOrder').prop('disabled', false);
    
    });

    $(document).on('change', 'select[name="payment_selector"]', function (e) {
        e.preventDefault(); // Empêche le rechargement de la page

        var payment = $('select[name="payment_selector"] option:selected').attr('data-id');

        if($('select[name="payment_selector"] option:selected').val() == 'new'){
            $('.checkout-container-left-payment-method').removeClass('hidden');
            $('.payment_provider').attr('data-provider', $('.payment_provider').attr('data-default-provider'));
            // $('.checkout-container-left-btns #confirmOrder').prop('disabled', true);
        }else{
            $('.checkout-container-left-payment-method').addClass('hidden');
            var url = new URL(window.location.href);
            var typeTransaction = 'bn';
            var transactionId = $('input[name="buykey"]').val();
            changePaymentMethod(e, payment, typeTransaction, transactionId);
            // $('.checkout-container-left-btns #confirmOrder').prop('disabled', false);
        }
        
    });

    

    $(document).on('click', '.account-area-section-address-remove', function (e) {
        e.preventDefault(); // Empêche le rechargement de la page

        var formData = {
            'data-id': $(this).attr('data-id')
        };

        var fullUrl = window.location.href;
        var urlObject = new URL(fullUrl);
        var baseUrl = urlObject.origin + urlObject.pathname.split('/account')[0];

        $.ajax({
            url: baseUrl + "/account/delete-address/",
            type: 'POST',
            data: formData,
            success: function(data, status, xhr) {
                var redirectUrl = xhr.getResponseHeader('Location');
                if (xhr.status === 201) {
                    getAddresses();
                } else {
                    if (data.success) {
                        console.log('Address deleted with success');
                    } else {
                        if (data.errorCode === 0) {
                           
                        } else {
                            console.log('Error during data delete');
                        }
                    }    
                }
            },
            error: function(xhr, status, error) {
                // Gère les erreurs de la requête AJAX
                console.log('AJAX error: ' + error);
            }
        });
    });


    $('.bid-area-section-content-address').on('submit', function (e) {
        e.preventDefault(); // Empêche le rechargement de la page

        // Récupère les données du formulaire
        var formData = $(this).serialize();

        $('.error-message').remove();

        var first_name = $(this).find('input[name="first_name"]');
        var last_name = $(this).find('input[name="last_name"]');
        var country = $(this).find('.country');
        var email = $(this).find('input[name="email_address"]');
        var address_1 = $(this).find('input[name="address_1"]');
        var city = $(this).find('input[name="city"]');
        var zipcode = $(this).find('input[name="zipcode"]');
        var phone = $(this).find('input[name="phone"]');

        var first_name_2 = $(this).find('input[name="first_name-f"]');
        var last_name_2 = $(this).find('input[name="last_name-f"]');
        var country_2 = $(this).find('#country-f');
        var email_2 = $(this).find('input[name="email_address-f"]');
        var address_1_2 = $(this).find('input[name="address_1-f"]');
        var city_2 = $(this).find('input[name="city-f"]');
        var zipcode_2 = $(this).find('input[name="zipcode-f"]');
        var phone_2 = $(this).find('input[name="phone-f"]');

        var isFacturation = $(this).find('input[name="facturation"]');

        // Vérifie si les champs sont vides
        if (first_name.val() === '') {
            addErrorMessage(first_name, oDict["address_enter_first_name"]);
        }
        if (last_name.val() === '') {
            addErrorMessage(last_name, oDict["address_enter_last_name"]);
        }
        if (country.val() === '') {
            addErrorMessage(country, oDict["address_select_country"]);
        }
        if (email.val() === '') {
            addErrorMessage(email, oDict["address_enter_email"]);
        }else if(!validateEmail(email.val())){
            addErrorMessage(email, oDict["enter_valid_email"]);
        }
        if (address_1.val() === '') {
            addErrorMessage(address_1, oDict["address_enter_address"]);
        }
        if (city.val() === '') {
            addErrorMessage(city, oDict["address_enter_city"]);
        }
        if (zipcode.val() === '') {
            addErrorMessage(zipcode, oDict["address_enter_zipcode"]);
        }
        if (phone.val() === '') {
            addErrorMessage(phone, oDict["address_enter_phone"]);
        }

        if(!isFacturation.is(':checked')){
            // Vérifie si les champs sont vides
            if (first_name_2.val() === '') {
                addErrorMessage(first_name_2, oDict["address_enter_first_name"]);
            }
            if (last_name_2.val() === '') {
                addErrorMessage(last_name_2, oDict["address_enter_last_name"]);
            }
            if (country_2.val() === '') {
                addErrorMessage(country_2, oDict["address_select_country"]);
            }
            if (email_2.val() === '') {
                addErrorMessage(email_2, oDict["address_enter_email"]);
            }else if(!validateEmail(email_2.val())){
                addErrorMessage(email_2, oDict["enter_valid_email"]);
            }
            if (address_1_2.val() === '') {
                addErrorMessage(address_1_2, oDict["address_enter_address"]);
            }
            if (city_2.val() === '') {
                addErrorMessage(city_2, oDict["address_enter_city"]);
            }
            if (zipcode_2.val() === '') {
                addErrorMessage(zipcode_2, oDict["address_enter_zipcode"]);
            }
            if (phone_2.val() === '') {
                addErrorMessage(phone_2, oDict["address_enter_phone"]);
            }
        }

        if($('.bid-area-section-content-address .error-message').length > 0) {
            $('html, body').animate({
                scrollTop: $('.error-message').first().offset().top - 100
            }, 500);
            return;
        }

        var currentUrl = window.location.href;
        var urlObject = new URL(currentUrl);
        var baseUrl = urlObject.origin;

        $.ajax({
            url: baseUrl + $('.bid-area-section-content-address').attr('action'),
            type: 'POST',
            data: formData,
            success: function(data, status, xhr) {
                var redirectUrl = xhr.getResponseHeader('Location');
                if (xhr.status === 201) {
                    window.location.reload();
                } else {
                    if (data.success) {
                        console.log('Address updated with success');
                    } else {
                        if (data.errorCode === 0) {
                           
                        } else {
                            console.log('Error during data update');
                        }
                    }    
                }
            },
            error: function(xhr, status, error) {
                console.log('AJAX error: ' + error);
            }
        });
    });

    $('.logout-btn').on('click', function (e) {
        e.preventDefault();

        var currentUrl = window.location.href;
        var urlObject = new URL(currentUrl);
        var baseUrl = urlObject.origin;

        $.ajax({
            url: baseUrl + "/logout",
            type: 'POST',
            data: '',
            success: function(data, status, xhr) {
                var redirectUrl = xhr.getResponseHeader('Location');
                if (xhr.status === 201) {
                    var currentUrl = window.location.href;
                    if (currentUrl.includes("/account")) {
                        window.location.href = "/";
                    } else {
                        window.location.reload();
                    }
                } else {
                    if (data.success) {
                        console.log('Successfully logged out');
                    } else {
                        console.log('Error during logout');
                    }    
                }
            },
            error: function(xhr, status, error) {
                console.log('AJAX error: ' + error);
            }
        });
    });


    /*** PASSWORD RESET LINK FORM SUBMISSION ***/

    $("#password_reset-modal .hide").hide();
    $("#password_reset-modal .hide_bot").hide();
    $('#password_reset-form').submit(function(e) {
        e.preventDefault(); // Empêche le rechargement de la page

        if($('#password_reset-form').attr('data-sent') === 'true') {
            return;
        }

        $('.error-message').remove();

        // Récupère les données du formulaire
        var email = $('#password_reset-form input[name="email"]').val().trim();
        

        // Vérifie si les champs sont vides
        if (email === '') {
            addErrorMessage($('#password_reset-form input[name="email"]'), oDict["enter_your_email"]);
        }

        if($('.error-message').length > 0) {
            return;
        }

        grecaptcha.enterprise.ready(function() {
            grecaptcha.enterprise.execute('6LdkTGQpAAAAADf8F07OFECYPJZ2-TPT-KzZAX5l', {action: 'password_reset'}).then(function(token) {
                $('#recaptchaToken').val(token);

                var currentUrl = window.location.href;
                var urlObject = new URL(currentUrl);
                var baseUrl = urlObject.origin;

                var formData = $('#password_reset-form').serialize();
                $.ajax({
                    url: baseUrl + $('#password_reset-form').attr('action'),
                    type: 'POST',
                    data: formData,
                    success: function(data, status, xhr) {
                        var redirectUrl = xhr.getResponseHeader('Location');
                        if (xhr.status === 201) {
                            //window.location.reload();
                            $("#password_reset-modal .hide").show();
                            $("#password_reset-modal .show").hide();
                            $("#password_reset-modal .hide_bot").hide();

                            $('#password_reset-form').attr('data-sent', 'true');
                            addErrorMessage($('#password_reset-form input[name="email"]'), oDict["password_sent"]);
                            $('.pwd_counter').text(60);
                            var interval = setInterval(function() {
                                var counter = $('.pwd_counter').text();
                                counter--;
                                $('.pwd_counter').text(counter);
                                if(counter == 0) {
                                    clearInterval(interval);
                                    $('#password_reset-form').attr('data-sent', 'false');
                                    $('.error-message').text('');
                                }
                            }, 1000);
                        } else {
                            if (data.success) {
                                console.log('OK');
                            } else {
                                if (data.errorCode === -2) {
                                    console.log("Error -2");
                                } else if(data.errorCode === -3){
                                    addErrorMessage($('#password_reset-form input[name="email"]'), oDict["account_not_verified"]);
                                } else if(data.errorCode === -4){
                                    $("#password_reset-modal .hide_bot").show();
                                    $("#password_reset-modal .hide").hide();
                                    $("#password_reset-modal .show").hide();
                                } else {
                                    console.log('Error during password reset');
                                }
                            }                  
                        }
                    },
                    error: function(xhr, status, error) {
                        console.log(baseUrl + $('#signup-form').attr('action'));
                        console.log('AJAX error: ' + error);
                    }
                });
            });
        });
    });

    if(getCookieValue("password_reset_popin")){
        deleteCookie("password_reset_popin");
        $.magnificPopup.open({
            items: {
                src: $('.password_reset_confirmation_popin-modal'),
                type: 'inline',
                closeBtnInside: true,
                modal: true,
            },
            closeOnBgClick: true,
            callbacks: {
                open: function() {
                    $('.password_reset_confirmation_popin-modal .close-button, .password_reset_confirmation_popin-modal .mfp-close').on('click', function(e) {
                        e.preventDefault();
                        $.magnificPopup.close();
                    });
                }
            }
        });
    }

    /*** PASSWORD RESET FORM SUBMISSION ***/
    $('#reset_update_password-form').submit(function(e) {
        e.preventDefault(); // Empêche le rechargement de la page

        // Récupère les données du formulaire
        var formData = $(this).serialize();

        $('.error-message').remove();

        // Récupère les données du formulaire
        var new_password = $('#reset_update_password-form input[name="new_password"]').val().trim();
        var confirm_new_password = $('#reset_update_password-form input[name="confirm_new_password"]').val().trim();
        
        // Vérifie si les champs sont vides
        if (new_password === '') {
            addErrorMessage($('#reset_update_password-form input[name="new_password"]'), oDict["enter_new_password"]);
        }
        if (confirm_new_password === '') {
            addErrorMessage($('#reset_update_password-form input[name="confirm_new_password"]'), oDict["confirm_new_password"]);
        }

        if($('.error-message').length > 0) {
            return;
        }

        var currentUrl = window.location.href;
        var urlObject = new URL(currentUrl);
        var baseUrl = urlObject.origin;

        $.ajax({
            url: baseUrl + $('#reset_update_password-form').attr('action'),
            type: 'POST',
            data: formData,
            success: function(data, status, xhr) {
                var redirectUrl = xhr.getResponseHeader('Location');
                if (xhr.status === 201) {

                    setCookie('password_reset_popin', true);
                    
                    //redirect to /account page
                    currentUrl = window.location.href;
                    var url = new URL(currentUrl);
                    var pathname = url.pathname;
                    var pathSegments = pathname.split('/');
                    var urlPrefix = '/' + pathSegments[1] + '/' + pathSegments[2];

                    //get cookie last_checkout_page
                    var last_checkout_page = getCookieValue('last_checkout_page');
                    if(last_checkout_page != null && last_checkout_page != undefined){
                        window.location.href = last_checkout_page;
                    }else{
                        window.location.href = "/account/home";
                    }
                    
                } else {
                    if (data.success) {
                        console.log('OK');
                    } else {
                        if (data.errorCode === -2) {
                            console.log("Error -2");
                        } else {
                            console.log('Error during password reset');
                        }
                    }                  
                }
            },
            error: function(xhr, status, error) {
                console.log('AJAX error: ' + error);
            }
        });
    });

    $(".wishlist-trigger").on("click", function(e) {
        e.preventDefault();

        $('.wishlist-trigger').next('span').remove();

        let productId = $(this).data("product");
        let productSize = $('.product-size__choices__select').attr('data-size')

        is_clicked_wishlist = true;

        if( !$('.wishlist-trigger-icon.active').hasClass('checked') ) {
            if(productSize == "") {
                $('.product-size__top').before('<span class="wishlist-error">' + oDict["select_size"] + '</span>');
                $('.product-size__choices__select').click();
                return;
            }
        }

        if($(this).data("connected") == false){
            $('.open-login_magic-modal').click();

            if((productSize != "") && (productSize != undefined)) {
                //adding a cookie to remember the product to add to wishlist after login
                var d = new Date();
                d.setTime(d.getTime() + (1*60*60*1000));
                var expires = "expires="+ d.toUTCString();
                document.cookie = "wishlist_product_after_login=" + productId + "|" + productSize + ";path=/;" + expires;
            }else{
                deleteCookie('wishlist_product_after_login');
            }
            return;
        }
        
        var currentUrl = window.location.href;
        var urlObject = new URL(currentUrl);
        var baseUrl = urlObject.origin;

        $.ajax({
            url: baseUrl + "/wishlist-update",
            type: 'POST',
            data: {product: productId, size: productSize},
            success: function(data, status, xhr) {
                if (xhr.status === 201) {
                    if($('.wishlist-trigger .wishlist-trigger-icon').first().hasClass('active')){
                        sendEventLogger('wishlist_add');
                    }else{
                        sendEventLogger('wishlist_remove');
                    }
                    $('.wishlist-trigger[data-product='+productId+'] .wishlist-trigger-icon').toggleClass('active');
                    $('.wishlist-error').remove();
                } else {
                    if (data.success) {
                        console.log('NOK');
                    } else {
                        if (data.errorCode === -2) {
                            console.log("Error -2");
                        } else {
                            console.log('Error during password reset');
                        }
                    }                  
                }
            },
            error: function(xhr, status, error) {
                console.log('AJAX error: ' + error);
            }
        });

    });

    var wishlistCookieValue = getCookieValue('wishlist_product_after_login');
    if (wishlistCookieValue && is_user_connected) {
        var parts = wishlistCookieValue.split('|');
        var productId = parts[0];
        var productSize = parts[1];

        var currentUrl = window.location.href;
        var urlObject = new URL(currentUrl);
        var baseUrl = urlObject.origin;
        $.ajax({
            url: baseUrl + "/wishlist-update",
            type: 'POST',
            data: {product: productId, size: productSize},
            success: function(data, status, xhr) {
                if (xhr.status === 201) {
                    $('.wishlist-trigger[data-product='+productId+'] .wishlist-trigger-icon').toggleClass('active');
                    $('.wishlist-error').remove();
                    deleteCookie('wishlist_product_after_login');
                } else {
                    if (data.success) {
                        console.log('NOK');
                    } else {
                        if (data.errorCode === -2) {
                            console.log("Error -2");
                        } else {
                            console.log('Error during password reset');
                        }
                    }                  
                }
            },
            error: function(xhr, status, error) {
                console.log('AJAX error: ' + error);
            }
        });
    }else{
        deleteCookie('wishlist_product_after_login');
    }

    $(".product-actions__notify a").on("click", function(e) {
        e.preventDefault();

        if($(this).hasClass('registered')){
            return;
        }

        let productId = $('.wishlist-trigger').data("product");
        let productSize = $('.product-size__choices__select').attr('data-size')

        if(is_user_connected == false){
            $('.open-login_magic-modal').click();

            var d = new Date();
            d.setTime(d.getTime() + (1*60*60*1000));
            var expires = "expires="+ d.toUTCString();
            document.cookie = "notifyme_after_login=" + productId + "|" + productSize + ";path=/;" + expires;
            return;
        }
        
        var currentUrl = window.location.href;
        var urlObject = new URL(currentUrl);
        var baseUrl = urlObject.origin;

        $.ajax({
            url: baseUrl + "/notifyme-update",
            type: 'POST',
            data: {product: productId, size: productSize},
            success: function(data, status, xhr) {
                if (xhr.status === 201) {
                    if($('.product-actions__notify a').hasClass('inactive')){
                        $('.product-actions__notify a').removeClass('inactive');
                        $('.product-actions__notify a').text( oDict["notification_registered"] );
                        $('.product-actions__notify a').addClass('registered');
                        $('.product-size__choices__item[data-size="'+productSize+'"]').attr('data-notify', 'true');

                        deleteCookie('notifyme_after_login');

                        var found = false;
                        if(notifyme_list != null){
                            for (var i = 0; i < notifyme_list.length; i++) {
                                var item = notifyme_list[i];
                            
                                if (item[0] === productId) {
                                    var indexOfSize = item[1].indexOf(productSize);
                                    item[1].push(productSize);
                                    found = true;
                                    break;
                                }
                            }
                        }else{
                            notifyme_list = [];
                        }
                        
                        if (!found) {
                            notifyme_list.push([productId, [productSize]]);
                        }       
                    }else{
                        $('.product-actions__notify a').addClass('inactive');
                        $('.product-actions__notify a').text(oDict["notify_me"]);
                        $('.product-actions__notify a').text( oDict["notification_registered"] );
                        $('.product-actions__notify a').addClass('registered');
                        $('.product-size__choices__item[data-size="'+productSize+'"]').attr('data-notify', 'true');

                        for (var i = 0; i < notifyme_list.length; i++) {
                            var item = notifyme_list[i];
                        
                            if (item[0] === productId) {
                                var indexOfSize = item[1].indexOf(productSize);
                                item[1].splice(indexOfSize, 1);
                            }
                        }
                    }
                    sendEventLogger('notifyme');
                } else {
                    if (data.success) {
                        console.log('NOK');
                    } else {
                        if (data.errorCode === -2) {
                            console.log("Error -2");
                        } else {
                            console.log('Error during password reset');
                        }
                    }                  
                }
            },
            error: function(xhr, status, error) {
                console.log('AJAX error: ' + error);
            }
        });

    });

    var notifymeCookieValue = getCookieValue('notifyme_after_login');
    if (notifymeCookieValue && is_user_connected) {
        var parts = notifymeCookieValue.split('|');
        var productId = parts[0];
        var productSize = parts[1];

        var currentUrl = window.location.href;
        var urlObject = new URL(currentUrl);
        var baseUrl = urlObject.origin;
        $.ajax({
            url: baseUrl + "/notifyme-update",
            type: 'POST',
            data: {product: productId, size: productSize},
            success: function(data, status, xhr) {
                if (xhr.status === 201) {
                    if($('.product-actions__notify a').hasClass('inactive')){
                        $('.product-actions__notify a').removeClass('inactive');
                        $('.product-actions__notify a').text( oDict["notification_registered"] );
                        $('.product-actions__notify a').addClass('registered');

                        $('.product-size__choices__item[data-size="'+productSize+'"]').click()

                        deleteCookie('notifyme_after_login');

                        var found = false;
                        for (var i = 0; i < notifyme_list.length; i++) {
                            var item = notifyme_list[i];
                        
                            if (item[0] === productId) {
                                var indexOfSize = item[1].indexOf(productSize);
                                item[1].push(productSize);
                                found = true;
                                break;
                            }
                        }
                        
                        if (!found) {
                            notifyme_list.push([productId, [productSize]]);
                        }       
                    }else{
                        $('.product-actions__notify a').addClass('inactive');
                        $('.product-actions__notify a').text(oDict["notify_me"]);

                        for (var i = 0; i < notifyme_list.length; i++) {
                            var item = notifyme_list[i];
                        
                            if (item[0] === productId) {
                                var indexOfSize = item[1].indexOf(productSize);
                                item[1].splice(indexOfSize, 1);
                            }
                        }
                    }
                } else {
                    if (data.success) {
                        console.log('NOK');
                    } else {
                        if (data.errorCode === -2) {
                            console.log("Error -2");
                        } else {
                            console.log('Error during password reset');
                        }
                    }                  
                }
            },
            error: function(xhr, status, error) {
                console.log('AJAX error: ' + error);
            }
        });
    }else{
        deleteCookie('notifyme_after_login');
    }

    // In the mobile menu, display the sub-menu of the selected menu item
    setTimeout(function() {
        $(".menu-item-has-children.selected > ul.dropdown").css('display', 'block');
    }, 500);

    //Preferences modal redirection
    $('#preferences-modal a.submit').on('click', function(e) {
        e.preventDefault();
        var market = $('#preferences-modal .preferences__choices__select.country.filled').data('country');
        var language = $('#preferences-modal .preferences__choices__select.language.filled').data('language');

        var currentUrl = window.location.href;
        var urlObject = new URL(currentUrl);
        var baseUrl = urlObject.origin;

        //redirect to the new url with the new market and language
        window.location.href = baseUrl + "/" + market + '/' + language + "/";
    });


    // If a selector has only one choice, select it
    // $('.product-size').each(function() {
    //     var $choices = $(this).find('.product-size__choices__item');
    //     if ($choices.length === 1) {
    //       $choices.click();
    //       $(this).find('.product-size__choices__select').addClass('single');
    //       $(this).find('.product-size__choices').remove();
    //       $(this).find('.open-size_guide-modal').remove();
    //     }
    //   });


    /*** BRANDS PAGE */
    $("#search-brand").on("input", function () {
        var searchTerm = $(this).val().toLowerCase();
        $('.brands-page-filters-item a').removeClass('active');
        $(".brands-item").each(function () {
            var brandName = String($(this).data("name")).toLowerCase();
            if (brandName.includes(searchTerm)) {
                $(this).show();
            } else {
                $(this).hide();
            }
        });
        $('.brand-section').show();
        $('.brand-section').each(function() {
            var $brands = $(this).find('.brands .brands-item:visible');
            if ($brands.length === 0) {
                $(this).hide();
            }else{
                $(this).show();
            }
        });
    });

    function brandSetFilter(){
        var hashValue = window.location.hash; 
        var result = hashValue.match(/-(\w+)$/);
        if ( result == undefined )
            return;
        var letter = result[1]

        $('.brand-section').hide();
        $('.brand-section[data-letter="' + letter + '"]').show();

        if(!$('.brands-page-filters-item a[data-letter="' + letter + '"]').hasClass('active')){
            $('.brands-page-filters-item a[data-letter="' + letter + '"]').addClass('active');
        }
    }

    $('.brands-page-filters-item a').on('click', function(e) {
        e.preventDefault();
        if($(this).hasClass('active')){
            $(this).removeClass('active');
            $('.brand-section').show();
            $('.brands .brands-item').show();

            history.pushState('', document.title, window.location.pathname);

            return;
        }
        $('.brands-page-filters-item a').removeClass('active');
        $(this).addClass('active');

        var nouvelleAncre = 'item-'+$(this).attr('data-letter');
        history.pushState(null, null, '#' + nouvelleAncre);

        $('.brands .brands-item').show();

        $('#search-brand').val('');
        setTimeout(function() {
            brandSetFilter();
        }, 100);
    });

    brandSetFilter();

    // On click on heart button
    $(document).on("click", ".brands-item-favorite-btn", function(e) {
        e.preventDefault();

        if($('.brands-item-fav').length > 19 && !$(this).hasClass('active')){
            $('.brands_limit_popin .close-button, .brands_limit_popin .mfp-close').on('click', function(e) {
                e.preventDefault();
                $.magnificPopup.close();
            });
            $.magnificPopup.open({
                items: {
                    src: $('.brands_limit_popin-modal'),
                    type: 'inline',
                    closeBtnInside: true,
                    modal: true,
                },
                closeOnBgClick: false,
                callbacks: {
                    open: function() {
                        jQuery('body').addClass('noscroll');
                    },
                    close: function() {
                        jQuery('body').removeClass('noscroll');
                    }
                }
            });
            return;
        }

        let brandName = $(this).attr('data-brand');
        let brandNameUpper = $(this).next('.brands-item-name').text();
        let brandLink = $(this).next('.brands-item-name').attr('href');
        let brandSlug = $(this).next('.brands-item-name').attr('data-slug');
        
        var currentUrl = window.location.href;
        var urlObject = new URL(currentUrl);
        var baseUrl = urlObject.origin;

        $.ajax({
            url: baseUrl + "/favorite-brand-update",
            type: 'POST',
            data: {brand: brandName, slug: brandSlug},
            success: function(data, status, xhr) {
                console.log([brandName, brandSlug]);
                if (xhr.status === 201) {
                    console.log('ok');

                    if($('.brands-item-favorite-btn[data-brand="'+brandName+'"]').hasClass('active')){
                        $('.brands-item-fav[data-brand="'+brandName+'"]').remove();
                    }else{
                        var divElement = $('<div/>', {
                            class: 'brands-item brands-item-fav',
                            'data-brand': brandName.toLowerCase(),
                            'data-name': brandNameUpper
                        });
                        
                        var link1 = $('<a/>', {
                            'data-brand': brandName.toLowerCase(),
                            class: 'brands-item-favorite-btn',
                            html: '<svg width="20" height="20" viewBox="0 0 69 69" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M44.93 13.9602C44.57 13.9302 44.2 13.9102 43.82 13.9102C39.83 13.9102 36.3 15.8402 34.08 18.8102C31.86 15.8402 28.33 13.9102 24.34 13.9102C23.97 13.9102 23.6 13.9302 23.23 13.9602C15.99 14.6102 11.81 22.1902 14.06 28.7602C14.48 29.9902 15.21 31.0902 16.03 32.1002L34.15 54.2602L52.13 32.0802C52.94 31.0802 53.65 29.9902 54.07 28.7802C56.34 22.2102 52.16 14.6202 44.91 13.9602H44.93Z" stroke="black" stroke-width="3" stroke-miterlimit="10"/></svg>'
                        });
                        
                        var link2 = $('<a/>', {
                            class: 'brands-item-name',
                            href: brandLink,
                            text: brandNameUpper
                        });
                        
                        divElement.append(link1, link2);
                        $('.brand-section[data-letter=wishlist] .brands').append(divElement);
                    }
                    $('.brands-item-favorite-btn[data-brand="'+brandName+'"]').toggleClass('active');

                } else {
                    if (data.success) {
                        console.log('NOK');
                    } else {
                        if (data.errorCode === -2) {
                            console.log("Error -2");
                        } else {
                            console.log('Error during password reset');
                        }
                    }                  
                }
            },
            error: function(xhr, status, error) {
                console.log('AJAX error: ' + error);
            }
        });

    });


    /*if ($('.homepage-hero-women').length > 0){
        if ($(window).width() < 768) {
            var randomNumber = Math.floor(Math.random() * 4) + 1;
            $('.homepage-hero').attr("style", "background-image: url('/assets/251129145240/images/homepage/homepage-mobile-" + randomNumber + ".webp')");
        }
    }*/

    // Category page description
    if ($('.shop-area-title').length > 0){
        var $paragraph = $('.shop-area-title-content p:not(.read-more-disabled)');
        var maxLines = 3;

        var originalHeight = $paragraph.css('height'); 
        $paragraph.css('height', 'auto');               
        var naturalHeight = $paragraph.height();       
        $paragraph.css('height', originalHeight);

        // Vérifie si le paragraphe est sur plusieurs lignes
        if (naturalHeight > (maxLines * parseFloat($paragraph.css('line-height')))) {
            $paragraph.find('.more-link').show();
        }

        $paragraph.on('click', '.read-more', function(e) {
            e.preventDefault();
            $paragraph.css('height', 'auto');
            $('.more-link').remove();
        });
    }

    // Account bids selector
    // $('.account-area-section-status-bids input[type="radio"][name="status"]').on('change', function() {
    //     if ($(this).attr('id') === 'ongoing' && $(this).is(':checked')) {
    //         $('.account-area-section-orders-item.status-ongoing').show();
    //         $('.account-area-section-orders-item.status-history').hide();
    //         $('.account-area-section-subtitle').css('display', '');
    //     } else if ($(this).attr('id') === 'history' && $(this).is(':checked')) {
    //         $('.account-area-section-orders-item.status-history').show();
    //         $('.account-area-section-orders-item.status-ongoing').hide();
    //         $('.account-area-section-subtitle').hide();
    //     }
    // });
    $('.account-area-section-status-bids span').on('click', function() {
        if (!$(this).hasClass('active')) {
            $('.account-area-section-status-bids span').removeClass('active');
            $(this).addClass('active');

            if($(this).hasClass('ongoing')){
                $('.account-area-section-orders-item.status-ongoing').show();
                $('.account-area-section-orders-item.status-history').hide();
            }else{
                $('.account-area-section-orders-item.status-history').show();
                $('.account-area-section-orders-item.status-ongoing').hide();
            }
        }
    });

    // Account orders selector
    // $('.account-area-section-status-orders input[type="radio"][name="status"]').on('change', function() {
    //     if ($(this).attr('id') === 'orders' && $(this).is(':checked')) {
    //         $('.account-area-section-orders-item[data-status="orders"]').show();
    //         $('.account-area-section-orders-item[data-status="returns"]').hide();
    //         $('.account-area-section-subtitle').css('display', '');
    //     } else if ($(this).attr('id') === 'returns' && $(this).is(':checked')) {
    //         $('.account-area-section-orders-item[data-status="returns"]').show();
    //         $('.account-area-section-orders-item[data-status="orders"]').hide();
    //         $('.account-area-section-subtitle').hide();
    //     }
    // });
    $('.account-area-section-status-orders span').on('click', function() {
        if (!$(this).hasClass('active')) {
            $('.account-area-section-status-orders span').removeClass('active');
            $(this).addClass('active');

            if($(this).hasClass('orders')){
                $('.account-area-section-orders-item[data-status="orders"]').show();
                $('.account-area-section-orders-item[data-status="returns"]').hide();
            }else{
                $('.account-area-section-orders-item[data-status="returns"]').show();
                $('.account-area-section-orders-item[data-status="orders"]').hide();
            }
        }
    });
    // Account bids cancel popin
    $('.cancel_bid_popin .cancel_bid_popin_no, .cancel_bid_popin .mfp-close').on('click', function(e) {
        e.preventDefault();
        $.magnificPopup.close();
    });
    $('.cancel_bid_popin .cancel_bid_popin_yes').on('click', function(e) {
        e.preventDefault();
        var bidId = $(".account-area-section-orders-item-details:not(.inactive)").parent().attr('data-id');    
        
        var currentUrl = window.location.href;
        var urlObject = new URL(currentUrl);
        var baseUrl = urlObject.origin;

        $.ajax({
            url: baseUrl + $('.cancel_bid_popin_yes').attr('action'),
            type: 'POST',
            data: {bidId: bidId},
            success: function(data, status, xhr) {
                if (xhr.status === 201) {

                    $.magnificPopup.close();

                    $.magnificPopup.open({
                        items: {
                            src: $('.cancel_bid_confirmed_popin-modal'),
                            type: 'inline',
                            closeBtnInside: true,
                            modal: true,
                        },
                        closeOnBgClick: false,
                        callbacks: {
                            open: function() {
                                jQuery('body').addClass('noscroll');
                            },
                            close: function() {
                                jQuery('body').removeClass('noscroll');
                            }
                        }
                    });

                    $('.cancel_bid_confirmed_popin-modal button').on('click', function(e) {
                        e.preventDefault();
                        window.location.reload();
                    });


                } else {
                    console.log('error')          
                }
            },
            error: function(xhr, status, error) {
                console.log('AJAX error: ' + error);
            }
        });
    });
    $('.account-area-section-orders-item-details-update a').on('click', function(e) {
        e.preventDefault();

        $.magnificPopup.open({
            items: {
                src: $('.cancel_bid_popin-modal'),
                type: 'inline',
                closeBtnInside: true,
                modal: true,
            },
            closeOnBgClick: false,
            callbacks: {
                open: function() {
                    jQuery('body').addClass('noscroll');
                },
                close: function() {
                    jQuery('body').removeClass('noscroll');
                }
            }
        });
    });

    // Account wishlist remove product
    $('.account-area-section-wishlist-btn-edit').on('click', function(e) {
        if(!$(this).hasClass('btn-primary')){
            $(this).addClass('btn-primary').removeClass('btn-secondary');
        }else{
            $(this).addClass('btn-secondary').removeClass('btn-primary');
        }
        if($('#moodboard-name').length > 0 && !$('#moodboard-name').is(':visible')){
            $('#moodboard-name').show();
            $('h1.title-one').hide();
        }else{
            $('#moodboard-name').hide();
            $('h1.title-one').show();
            $(this).text(oDict['moodboard_edit']);
            $('h1.title-one').text($('#moodboard-name').val());
            
            //request to save the moodboard name
            let productId = '';
            let name = $('#moodboard-name').val();
            let collection = $(this).data("collection");
            
            var currentUrl = window.location.href;
            var urlObject = new URL(currentUrl);
            var baseUrl = urlObject.origin;

            $.ajax({
                url: baseUrl + "/moodboard-update",
                type: 'POST',
                data: {product: productId, name: name, collection: collection},
                success: function(data, status, xhr) {
                    if (xhr.status === 201) {
                        console.log('OK');
                    } else {
                        if (data.success) {
                            console.log('NOK');
                        } else {
                            if (data.errorCode === -2) {
                                console.log("Error -2");
                            } else {
                                console.log('Error during moodboard update');
                            }
                        }                  
                    }
                },
                error: function(xhr, status, error) {
                    console.log('AJAX error: ' + error);
                }
            });
        }
        $('.remove-wishlist-btn').toggleClass('active');
        $('.delete-moodboard-item').toggleClass('active');
        $('.delete-wishlist-item').toggleClass('active');
    });

    $('#moodboard-name').on('keyup', function(e) {
        $('.account-area-section-wishlist-btn-edit.btn-primary').text(oDict['g_modify_info']);
    });


    $('.delete-wishlist-item').on('click', function(e) {
        e.preventDefault();

        console.log('delete');

        let productId = $(this).data("product");
        let productSize = "";
        var iteration = $(this).data("iteration");
        var type = $(this).data("type");
        var collection = $(this).data("collection");
        
        var currentUrl = window.location.href;
        var urlObject = new URL(currentUrl);
        var baseUrl = urlObject.origin;

        $.ajax({
            url: baseUrl + "/"+type+"-update",
            type: 'POST',
            data: {product: productId, collection: collection},
            success: function(data, status, xhr) {
                if (xhr.status === 201) {
                    $('.wishlist-single-product[data-iteration='+iteration+']').fadeOut(300, function() {$(this).remove();});
                } else {
                    if (data.success) {
                        console.log('NOK');
                    } else {
                        if (data.errorCode === -2) {
                            console.log("Error -2");
                        } else {
                            console.log('Error during password reset');
                        }
                    }                  
                }
            },
            error: function(xhr, status, error) {
                console.log('AJAX error: ' + error);
            }
        });

    });

    if (typeof draggable_plugin !== 'undefined' && draggable_plugin) {
        const swappable = new Draggable.Swappable(document.querySelectorAll('.account-area-section-wishlist .row'), {
            draggable: '.wishlist-single-product',
            mirror: {
                constrainDimensions: true, // Empêche Safari d'utiliser son aperçu natif
            },
            delay: 200,
        });

        swappable.on('swappable:stop', (e) => {
            console.log('Swapped', e);
            console.log('List updated');
            var list_products = [];
            setTimeout(function() {
                $('.account-area-section-wishlist .wishlist-single-product').each(function() {
                    list_products.push($(this).data('id'));
                });
                //make ajax call to update the list
                var currentUrl = window.location.href;
                var urlObject = new URL(currentUrl);
                var baseUrl = urlObject.origin;
                var type = $('.account-area-section-wishlist .wishlist-single-product').first().data('type');
                var moodboard_id = $('.account-area-section-wishlist .wishlist-single-product').first().data('moodboard');

                $.ajax({
                    url: baseUrl + "/" + type + "-update-order",
                    type: 'POST',
                    data: {order_list: list_products, moodboard_id: moodboard_id},
                    success: function(data, status, xhr) {
                        if (xhr.status === 201) {
                            console.log('OK');
                        } else {
                            if (data.success) {
                                console.log('NOK');
                            } else {
                                if (data.errorCode === -2) {
                                    console.log("Error -2");
                                } else {
                                    console.log('Error');
                                }
                            }                  
                        }
                    },
                    error: function(xhr, status, error) {
                        console.log('AJAX error: ' + error);
                    }
                });

            }, 100);

        });
    }

    $('.remove-wishlist-btn').on('click', function(e) {
        e.preventDefault();

        var collection = $(this).data("collection");

        $('.delete-moodboard-item').attr('data-collection', collection);

        $.magnificPopup.open({
            items: {
                src: $('.remove_wishlist_popin-modal'),
                type: 'inline',
                closeBtnInside: true,
                modal: true,
            },
            closeOnBgClick: false,
            callbacks: {
                open: function() {
                    jQuery('body').addClass('noscroll');
                },
                close: function() {
                    jQuery('body').removeClass('noscroll');
                }
            }
        });
    });

    $('.remove_wishlist_popin_no').on('click', function(e) {
        e.preventDefault();
        $.magnificPopup.close();
    });
    

    $('.delete-moodboard-item').on('click', function(e) {
        e.preventDefault();

        var collection = $(this).data("collection");
        
        var currentUrl = window.location.href;
        var urlObject = new URL(currentUrl);
        var baseUrl = urlObject.origin;

        $.ajax({
            url: baseUrl + "/moodboard-delete",
            type: 'POST',
            data: {collection: collection},
            success: function(data, status, xhr) {
                if (xhr.status === 201) {
                    $('.account-area-section-moodboard-item[data-collection='+collection+']').fadeOut(300, function() {
                        $(this).parent().remove();
                    });
                    $.magnificPopup.close();
                } else {
                    if (data.success) {
                        console.log('NOK');
                    } else {
                        if (data.errorCode === -2) {
                            console.log("Error -2");
                        } else {
                            console.log('Error');
                        }
                    }                  
                }
            },
            error: function(xhr, status, error) {
                console.log('AJAX error: ' + error);
            }
        });

    });

    $('.account-area-section-moodboard-item-products').each(function() {
        var width = $(this).width();
        $(this).css('height', width);
    });

    //Confettis bid
    let animationActive = true;

    if($('#confetti').length > 0){
        let W = window.innerWidth;
        let H = document.getElementById('confetti').clientHeight;
        const canvas = document.getElementById('confetti');
        const context = canvas.getContext("2d");
        const maxConfettis = 25;
        const particles = [];

        const possibleColors = [
        "#ff7336",
        "#f9e038",
        "#02cca4",
        "#383082",
        "#fed3f5",
        "#b1245a",
        "#f2733f"
        ];

        function randomFromTo(from, to) {
        return Math.floor(Math.random() * (to - from + 1) + from);
        }

        function confettiParticle() {
        this.x = Math.random() * W; // x
        this.y = Math.random() * H - H; // y
        this.r = randomFromTo(11, 33); // radius
        this.d = Math.random() * maxConfettis + 11;
        this.color =
            possibleColors[Math.floor(Math.random() * possibleColors.length)];
        this.tilt = Math.floor(Math.random() * 33) - 11;
        this.tiltAngleIncremental = Math.random() * 0.07 + 0.05;
        this.tiltAngle = 0;

        this.draw = function() {
            context.beginPath();
            context.lineWidth = this.r / 2;
            context.strokeStyle = this.color;
            context.moveTo(this.x + this.tilt + this.r / 3, this.y);
            context.lineTo(this.x + this.tilt, this.y + this.tilt + this.r / 5);
            return context.stroke();
        };
        }

        function Draw() {
        const results = [];

        if (animationActive) {
            requestAnimationFrame(Draw);
        }

        context.clearRect(0, 0, W, window.innerHeight);

        for (var i = 0; i < maxConfettis; i++) {
            results.push(particles[i].draw());
        }

        let particle = {};
        let remainingFlakes = 0;
        for (var i = 0; i < maxConfettis; i++) {
            particle = particles[i];

            particle.tiltAngle += particle.tiltAngleIncremental;
            particle.y += (Math.cos(particle.d) + 3 + particle.r / 2) / 2;
            particle.tilt = Math.sin(particle.tiltAngle - i / 3) * 15;

            if (particle.y <= H) remainingFlakes++;

            // If a confetti has fluttered out of view,
            // bring it back to above the viewport and let if re-fall.
            if (particle.x > W + 30 || particle.x < -30 || particle.y > H) {
            particle.x = Math.random() * W;
            particle.y = -30;
            particle.tilt = Math.floor(Math.random() * 10) - 20;
            }
        }

        return results;
        }

        window.addEventListener(
        "resize",
        function() {
            W = window.innerWidth;
            H = window.innerHeight;
            canvas.width = window.innerWidth;
            canvas.height = window.innerHeight;
        },
        false
        );

        // Push new confetti objects to `particles[]`
        for (var i = 0; i < maxConfettis; i++) {
        particles.push(new confettiParticle());
        }

        // Initialize
        canvas.width = W;
        canvas.height = H;
        Draw();

        setTimeout(function() {
            animationActive = false;
        }, 5000);
        setTimeout(function() {
            $("#confetti").fadeOut(1000);
        }, 4000);
    }

    //Footer mobile
    $('.footer-mobile-column-section').click(function() {
        if($(this).hasClass('active')){
            $(this).removeClass('active');
        }else{
            $('.footer-mobile-column-section').removeClass('active');
            $(this).toggleClass('active');
        }
        
    });


    //Coupons
    /*$('.bid-area-section-content-coupon-see').click(function() {
        $(this).hide();
        $('.bid-area-section-content-coupon-list').show();
    });*/
    $('.bid-area-section-content-coupon-list-item-copy, .item-copy').click(function() {
        var code = $(this).attr('data-code');
        $('#coupon-manual').val(code);
        $('.bid-area-section-content-coupon-see').show();
        $('.bid-area-section-content-coupon-list').hide();

        //le code se copie dans le presse papier
        var temp = $("<input>");
        $("body").append(temp);
        temp.val(code).select();
        // Exécuter la commande de copie
        document.execCommand("copy");
        temp.remove();

    });

    //coupon checkout V1
    $('.bid-area-section-content-coupon-form button').click(function(e) {
        e.preventDefault();            

        console.log('update bid coupon');
        
        var currentUrl = window.location.href;
        var urlObject = new URL(currentUrl);
        var baseUrl = urlObject.origin;
        const params = new URLSearchParams(urlObject.search);
        const keyValue = params.get('key');

        $('.bid-area-section-content-coupon-message').text("");

        var coupon = $('#coupon-manual').val();
        coupon = coupon.toUpperCase();

        if(coupon == ""){
            return;
        }

        $.ajax({
            url: $('.bid-area-section-content-coupon-form button').attr('action'),
            type: 'POST',
            data: {bid: keyValue, coupon: coupon},
            success: function(data, status, xhr) {
                if (xhr.status === 201) {
                    console.log('ok')
                    setTimeout(function() {
                        // set cookie for 1 minute with coupon_applied = true
                        var date = new Date();
                        date.setTime(date.getTime() + (1 * 60 * 1000));
                        var expires = "; expires=" + date.toUTCString();
                        document.cookie = "coupon_applied=true" + expires + "; path=/";
                        sendEventLogger('coupon_apply', {code: coupon, status: 'ok'});
                        window.location.reload();
                    }, 500);
                } else {
                    if (data.success) {
                        console.log('NOK');
                    } else {
                        if (data.errorCode === -2) {
                            console.log("Error -2");
                        } else {
                            console.log('Error during coupon update');
                            $('.bid-area-section-content-coupon-message').text(data.errorMsg);
                            $('.bid-area-section-content-coupon-message').removeClass('black');
                            $('.bid-area-section-content-coupon-message').fadeIn();
                            sendEventLogger('coupon_apply', {code: coupon, status: 'ko'});
                        }
                    }                  
                }
            },
            error: function(xhr, status, error) {
                console.log('AJAX error: ' + error);
            }
        });
    });

    // $('.checkout-container-left-address select[name="address_selector"]').change(function() {
    $('.address_selector').change(function() {

        //get closest parent div
        var addressSelectorContainer = $(this).closest('div');
        
        if($(this).val() == "new"){
            addressSelectorContainer.find('input[name="first_name"]').val("");
            addressSelectorContainer.find('input[name="last_name"]').val("");
            addressSelectorContainer.find('input[name="address_1"]').val("");
            addressSelectorContainer.find('input[name="address_2"]').val("");
            addressSelectorContainer.find('input[name="city"]').val("");
            addressSelectorContainer.find('input[name="zipcode"]').val("");
            addressSelectorContainer.find('input[name="phone"]').val("");
            addressSelectorContainer.find('select[name="state"]').val("");
            addressSelectorContainer.find('input[name="address_id"]').val("");
            return;
        }

        var addressSelectedData = $(this).find('option:selected').attr('data-details');
        var addressId = $(this).find('option:selected').attr('data-id');
        //json decode
        var addressSelectedData = JSON.parse(addressSelectedData);
        //fill the form
        addressSelectorContainer.find('input[name="first_name"]').val(addressSelectedData.first_name);
        addressSelectorContainer.find('input[name="last_name"]').val(addressSelectedData.last_name);
        addressSelectorContainer.find('input[name="address_1"]').val(addressSelectedData.address_1);
        addressSelectorContainer.find('input[name="address_2"]').val(addressSelectedData.address_2);
        addressSelectorContainer.find('input[name="city"]').val(addressSelectedData.city);
        addressSelectorContainer.find('input[name="zipcode"]').val(addressSelectedData.zipcode);
        addressSelectorContainer.find('input[name="phone"]').val(addressSelectedData.phone);
        setTimeout(function() {
        if(addressSelectedData.state){
            addressSelectorContainer.find('select[name="state"]').val(addressSelectedData.state);
            console.log("state change to " + addressSelectedData.state);
        }else{
            addressSelectorContainer.find('select[name="state"]').val("");
            console.log("state change to empty");
        }
        }, 200);
        if(addressSelectedData.country.toLowerCase() == "gb" && addressSelectorContainer.find('select[name="country"]').data('section') == "address_checkout"){
            addressSelectorContainer.find('select[name="country"]').val("UK").trigger('change');
            console.log("country change to UK");
            window.AddressAutocomplete.setCountry('.address-block', "gb");
        }else if(addressSelectedData.country.toLowerCase() == "uk" && addressSelectorContainer.find('select[name="country"]').data('section') == "checkout_billing"){
            addressSelectorContainer.find('select[name="country"]').val("GB").trigger('change');
            console.log("country change to GB");
            window.AddressAutocomplete.setCountry('.address-block', "gb");
        }else{
            addressSelectorContainer.find('select[name="country"]').val(addressSelectedData.country).trigger('change');
            console.log("country change to " + addressSelectedData.country);
            window.AddressAutocomplete.setCountry('.address-block', addressSelectedData.country.toLowerCase());
        }
        console.log(addressSelectedData.country.toLowerCase());
        addressSelectorContainer.find('input[name="address_id"]').val( addressId );
        
        //fill the country in the select
        // $('.checkout-container-left-address select[name="country"]').val("US");
    });


    //coupon checkout V2
    $('.checkout-container-right-coupon button, .checkout-container-right-coupon button').click(function(e) {
        e.preventDefault();            

        console.log('update bid coupon');
        
        var currentUrl = window.location.href;
        var urlObject = new URL(currentUrl);
        var baseUrl = urlObject.origin;
        const params = new URLSearchParams(urlObject.search);
        const keyValue = $('input[name="buykey"]').val();

        $('.checkout-container-right-coupon-message').text("");

        var coupon = $('#coupon-manual').val();
        coupon = coupon.toUpperCase();

        if(coupon == ""){
            return;
        }

        $.ajax({
            url: $('.checkout-container-right-coupon button').attr('action'),
            type: 'POST',
            data: {bid: keyValue, coupon: coupon},
            success: function(data, status, xhr) {
                if (xhr.status === 201) {
                    console.log('ok')
                    setTimeout(function() {
                        // set cookie for 1 minute with coupon_applied = true
                        var date = new Date();
                        date.setTime(date.getTime() + (1 * 60 * 1000));
                        var expires = "; expires=" + date.toUTCString();
                        document.cookie = "coupon_applied=true" + expires + "; path=/";
                        sendEventLogger('coupon_apply', {code: coupon, status: 'ok'});
                        
                        console.log(data)

                        $('span[data-checkout-summary="amount_total"]').text(data.amounts_formatted.amount_total);
                        $('span[data-checkout-summary="amount_subtotal"]').text(data.amounts_formatted.amount_subtotal);
                        $('span[data-checkout-summary="amount_discount"]').text(data.amounts_formatted.amount_discount);
                        $('.checkout-container-right-total-credit').remove();

                        $('.checkout-container-right-total-discount').fadeIn();

                        const url = new URL(window.location.href);
                        const segments = url.pathname.split('/').filter(Boolean);
                        const baseHref = `/${segments[0]}/${segments[1]}`;

                        $('.checkout-container-right-coupon-applied').append('<span class="checkout-container-right-coupon-applied-item" data-code="' + coupon + '" data-action="' + baseHref + '/coupon/order-remove">' + coupon + '</span>');

                        $('input[name="coupon-manual"]').val('');

                        //send custom event to window
                        window.dispatchEvent(new CustomEvent('coupon-applied', { detail: { amount: data.amounts.amount_total } }));
                        
                    }, 500);
                } else {
                    if (data.success) {
                        console.log('NOK');
                    } else {
                        if (data.errorCode === -2) {
                            console.log("Error -2");
                        } else {
                            console.log('Error during coupon update');
                            $('.checkout-container-right-coupon-message').text(data.errorMsg);
                            //remove 5s later
                            setTimeout(function() {
                                $('.checkout-container-right-coupon-message').fadeOut();
                                $('.checkout-container-right-coupon-message').text('');
                            }, 5000);
                            $('.checkout-container-right-coupon-message').removeClass('black');
                            $('.checkout-container-right-coupon-message').fadeIn();
                            $('input[name="coupon-manual"]').val('');
                            sendEventLogger('coupon_apply', {code: coupon, status: 'ko'});
                        }
                    }                  
                }
            },
            error: function(xhr, status, error) {
                console.log('AJAX error: ' + error);
            }
        });
    });

    var cookieApplied = document.cookie.replace(/(?:(?:^|.*;\s*)coupon_applied\s*\=\s*([^;]*).*$)|^.*$/, "$1");
    if(cookieApplied == "true"){
        var oDict = JSON.parse(document.querySelector('[dict-json]').innerHTML);
        $('.bid-area-section-content-coupon-message').text(oDict["coupon_applied"]).show();
        $('.bid-area-section-content-coupon-message').addClass('black');
        // delete cookie
        document.cookie = "coupon_applied=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";

        // 5 seconds after we remove the message
        setTimeout(function() {
            $('.bid-area-section-content-coupon-message').fadeOut();
        }, 5000);
        setTimeout(function() {
            $('.bid-area-section-content-coupon-message').text("").removeClass('black');
        }, 7000);
    }

    $(document).on('click', '.bid-area-section-content-coupon-applied-item, .checkout-container-right-coupon-applied-item', function(e) {
        e.preventDefault();

        console.log('remove bid coupon');
        
        var currentUrl = window.location.href;
        var urlObject = new URL(currentUrl);
        var baseUrl = urlObject.origin;
        const params = new URLSearchParams(urlObject.search);
        var keyValue = '';
        if(params.get('key') && params.get('key') != ''){
            keyValue = params.get('key');
        }else if($('input[name="buykey"]').val()){
            keyValue = $('input[name="buykey"]').val();
        }

        $('.bid-area-section-content-coupon-message').text("").hide();

        var coupon = $(this).attr('data-code');

        $.ajax({
            url: $(this).attr('data-action'),
            type: 'POST',
            data: {bid: keyValue, coupon: coupon},
            success: function(data, status, xhr) {
                if (xhr.status === 201) {
                    console.log('ok')
                    setTimeout(function() {
                        if($('input[name="buykey"]').val()){
                            $('span[data-checkout-summary="amount_total"]').text(data.amounts_formatted.amount_total);
                            $('span[data-checkout-summary="amount_subtotal"]').text(data.amounts_formatted.amount_subtotal);

                            //send custom event to window
                            window.dispatchEvent(new CustomEvent('coupon-applied', { detail: { amount: data.amounts.amount_total } }));
                            
                            if(data.amounts.amount_discount == 0){
                                $('.checkout-container-right-total-discount').fadeOut();
                                setTimeout(function() {
                                    $('span[data-checkout-summary="amount_discount"]').text(data.amounts_formatted.amount_discount);
                                }, 1500);
                            }else{
                                $('span[data-checkout-summary="amount_discount"]').text(data.amounts_formatted.amount_discount);
                            }
                            //delete the coupon from the list
                            $('.checkout-container-right-coupon-applied-item[data-code="'+coupon+'"]').remove();
                        }else{
                            window.location.reload();
                        }
                       
                    }, 500);
                } else {
                    if (data.success) {
                        console.log('NOK');
                    } else {
                        if (data.errorCode === -2) {
                            console.log("Error -2");
                        } else {
                            console.log('Error during coupon update');
                            $('.bid-area-section-content-coupon-message').text(data.errorMsg).show();
                        }
                    }                  
                }
            },
            error: function(xhr, status, error) {
                console.log('AJAX error: ' + error);
            }
        });
    });

    $('.bid-area-section-content-coupon-title').click(function(e) {
        e.preventDefault();
        $('.bid-area-section-content-coupon-box').toggleClass('hidden');
        $('.bid-area-section-content-coupon-title').toggleClass('active');
    });

    
/*
    $('#submitBidBtn').click(function(e) {
        e.preventDefault();

        console.log('verify bid coupon');
        
        var currentUrl = window.location.href;
        var urlObject = new URL(currentUrl);
        var baseUrl = urlObject.origin;
        const params = new URLSearchParams(urlObject.search);
        const keyValue = params.get('key');

        $.ajax({
            url: $(this).attr('data-action'),
            type: 'POST',
            data: {bid: keyValue},
            success: function(data, status, xhr) {
                if (xhr.status === 201) {
                    console.log('ok')
                    setTimeout(function() {
                        //redirect to $('#submitBidBtn') href
                        window.location.href = $('#submitBidBtn').attr('href');
                    }, 500);
                } else {
                    if (data.success) {
                        console.log('NOK');
                    } else {
                        $('.bid-area-section-content-coupon-title').addClass('active');
                        $('.bid-area-section-content-coupon-box').removeClass('hidden');
                        if (data.errorCode === -2) {
                            console.log("Error -2");
                        } else {
                            console.log('Error during coupon verify');
                            $('.bid-area-section-content-coupon-message').text(data.errorMsg).show();
                        }
                    }                  
                }
            },
            error: function(xhr, status, error) {
                console.log('AJAX error: ' + error);
            }
        });
    });
    */

    /**** Loyalty popins */
    
    $('.open-loyalty_popin__welcome-modal').click(function(e) {

        $.magnificPopup.open({
            items: {
                src: $('.loyalty_popin__welcome-modal'),
                type: 'inline',
                closeBtnInside: true,
                modal: true,
            },
            closeOnBgClick: true,
            callbacks: {
                open: function() {
                    jQuery('body').addClass('noscroll');
                    $('.close-popin').on('click', function(e) {
                        e.preventDefault();
                        $.magnificPopup.close(); // Fermer la popup lors du clic sur le bouton de fermeture
                    });
                },
                close: function() {
                    jQuery('body').removeClass('noscroll');
                }
            }
        });
    });

    $('.open-loyalty_popin__birthday-modal').click(function(e) {

        $.magnificPopup.open({
            items: {
                src: $('.loyalty_popin__birthday-modal'),
                type: 'inline',
                closeBtnInside: true,
                modal: true,
            },
            closeOnBgClick: true,
            callbacks: {
                open: function() {
                    jQuery('body').addClass('noscroll');
                    $('.close-popin').on('click', function(e) {
                        e.preventDefault();
                        $.magnificPopup.close(); // Fermer la popup lors du clic sur le bouton de fermeture
                    });
                },
                close: function() {
                    jQuery('body').removeClass('noscroll');
                }
            }
        });
    });

    $('.open-notifyme_popin-modal').on('click', function (e) {
        e.preventDefault();
        var container = $('.mobile-off-canvas-active');
        var wrapper = $('.main-wrapper-3');
        container.removeClass('inside');
        wrapper.removeClass('overlay-active-3');

        $.magnificPopup.open({
            items: {
                src: $('#notifyme_popin-modal'),
                type: 'inline',
                closeBtnInside: true,
                midClick: true,
            },
            closeOnBgClick: false,
            callbacks: {
                open: function() {
                    jQuery('body').addClass('noscroll');
                },
                close: function() {
                    jQuery('body').removeClass('noscroll');
                }
            }
        });
    });

    $('#notifyme_popin-modal input, #notifyme_popin-modal select').on('click', function(e) {
        e.stopPropagation();
    });

    $('#notifyme_popin-modal a.btn-primary').on('click', function(e) {
        e.stopPropagation();

        $('#notifyme_popin-modal .error-message').remove(); // Remove previous error messages

        //call ajax to save the notify me
        var email = $('#notifyme_popin-modal input[name="notifyme_email"]').val();
        var size = $('#notifyme_popin-modal select[name="notifyme_size"]').val();
        var newsletter = $('#notifyme_popin-modal input[name="notifyme_legal"]').is(':checked') ? 1 : 0;
        var registration_url = $('#notifyme_popin-modal input[name="registration_url"]').val();

        if(size == ""){
            //show error message
            //add a span below the select
            $('#notifyme_popin-modal select[name="notifyme_size"]').after('<span class="error-message">' + oDict["select_size"] + '</span>');
        }
        if(email == ""){
            //show error message
            //add a span below the input
            $('#notifyme_popin-modal input[name="notifyme_email"]').after('<span class="error-message">' + oDict["enter_your_email"] + '</span>');
        }else{
            //test if email is correct
            var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if(!emailPattern.test(email)){
                $('#notifyme_popin-modal input[name="notifyme_email"]').after('<span class="error-message">' + oDict["enter_valid_email"] + '</span>');
                return;
            }
        }
        if(email == "" || size == ""){
            return;
        }


        var currentUrl = window.location.href;
        var urlObject = new URL(currentUrl);
        var baseUrl = urlObject.origin;
        var productId = $('.wishlist-trigger').data("product");
        // Call AJAX to save the notify me
        $.ajax({
            url: baseUrl + "/notifyme-update",
            method: 'POST',
            data: {
                email: email,
                product: productId,
                size: size,
                newsletter: newsletter,
                registration_url: registration_url,
            },
            success: function(response) {
                // Handle success
                $.magnificPopup.close();
            },
            error: function(xhr, status, error) {
                // Handle error
            }
        });
    });


    $('.open-loyalty_popin__exclusive-modal').click(function(e) {

        $.magnificPopup.open({
            items: {
                src: $('.loyalty_popin__exclusive-modal'),
                type: 'inline',
                closeBtnInside: true,
                modal: true,
            },
            closeOnBgClick: true,
            callbacks: {
                open: function() {
                    jQuery('body').addClass('noscroll');
                    $('.close-popin').on('click', function(e) {
                        e.preventDefault();
                        $.magnificPopup.close(); // Fermer la popup lors du clic sur le bouton de fermeture
                    });
                },
                close: function() {
                    jQuery('body').removeClass('noscroll');
                }
            }
        });
    });

    $('.open-loyalty_popin__free_shipping-modal').click(function(e) {

        $.magnificPopup.open({
            items: {
                src: $('.loyalty_popin__free_shipping-modal'),
                type: 'inline',
                closeBtnInside: true,
                modal: true,
            },
            closeOnBgClick: true,
            callbacks: {
                open: function() {
                    jQuery('body').addClass('noscroll');
                    $('.close-popin').on('click', function(e) {
                        e.preventDefault();
                        $.magnificPopup.close(); // Fermer la popup lors du clic sur le bouton de fermeture
                    });
                },
                close: function() {
                    jQuery('body').removeClass('noscroll');
                }
            }
        });
    });

    $('.open-loyalty_popin__free_returns-modal').click(function(e) {

        $.magnificPopup.open({
            items: {
                src: $('.loyalty_popin__free_returns-modal'),
                type: 'inline',
                closeBtnInside: true,
                modal: true,
            },
            closeOnBgClick: true,
            callbacks: {
                open: function() {
                    jQuery('body').addClass('noscroll');
                    $('.close-popin').on('click', function(e) {
                        e.preventDefault();
                        $.magnificPopup.close(); // Fermer la popup lors du clic sur le bouton de fermeture
                    });
                },
                close: function() {
                    jQuery('body').removeClass('noscroll');
                }
            }
        });
    });

    $('.loyalty_popin__birthday-informations-title, .loyalty_popin__welcome-informations-title, .loyalty_popin__exclusive-informations-title, .loyalty_popin__free_shipping-informations-title').click(function(e) {
        e.preventDefault();
        $(this).toggleClass('opened');
        $(this).siblings('div').toggleClass('hidden');
    });

    /**** End Loyalty popins */

    /**** Shop filter swipe */
    /*$(document).on('click', '.sidebar-widget-list a', function(event) {

        setTimeout(function() {
            console.log('check swipe')

            var element = $('.shop-top-bar-left-filters');

            // Vérifiez si l'élément a un contenu défilant horizontalement
            console.log([element.prop('scrollWidth'), element.width()])
            if (element.prop('scrollWidth') > element.width()) {
                // Si le contenu dépasse la largeur visible, affichez les boutons
                $('.shop-top-bar-left-filters-buttons-right').show();
            } else {
                // Sinon, cachez les boutons
                $('.shop-top-bar-left-filters-buttons-left').hide();
                $('.shop-top-bar-left-filters-buttons-right').hide();
            }
        }, 500);
    });*/
    // $(document).on('click', '.sidebar-widget-list a', function(event) {

    //     setTimeout(function() {
    //         console.log('check swipe')

    //         var elementFull = $('.shop-top-bar-left').outerWidth();
    //         var elements = 0;
    //         //elements is the addition of all the width of shop-top-bar-left-item
    //         $('.shop-top-bar-left-item').each(function() {
    //             elements += $(this).outerWidth() + 10;
    //         });
    //         console.log(elements);

    //         // Vérifiez si l'élément a un contenu défilant horizontalement
    //         console.log([elements, elementFull])
    //         if (elements > elementFull) {
    //             // Si le contenu dépasse la largeur visible, affichez les boutons
    //             $('.shop-top-bar-left-filters-buttons-right').show();
    //         } else {
    //             // Sinon, cachez les boutons
    //             $('.shop-top-bar-left-filters-buttons-left').hide();
    //             $('.shop-top-bar-left-filters-buttons-right').hide();
    //         }
    //     }, 500);
    // });
    // var currentIndex = 0; // Variable pour suivre l'index de l'élément actuel

    // function scrollToNextFilter(direction) {
    //     var element = $('.shop-top-bar-left-filters');
    //     var currentScroll = element.scrollLeft();
    //     var newScroll = 0;
        
    //     if (direction === 'right') {
    //         newScroll = currentScroll + 200; // Défiler de 200px à droite
    //         var maxScroll = element.prop('scrollWidth') - element.outerWidth();
    //         if (newScroll > maxScroll) {
    //             newScroll = maxScroll; // Caler au maximum à droite si on dépasse
    //         }
    //     } else {
    //         newScroll = currentScroll - 200; // Défiler de 200px à gauche
    //         if (newScroll < 0) {
    //             newScroll = 0; // Caler au maximum à gauche si on dépasse
    //         }
    //     }
    
    //     element.animate({
    //         scrollLeft: newScroll
    //     }, 300, function() {
    //         // Mettre à jour la visibilité des flèches après l'animation
    //         updateButtonsVisibility();
    //     });
    // }
    
    
    
    // $(document).on('click', '.shop-top-bar-left-item', function(event) {
    //     setTimeout(function() {
    //         updateButtonsVisibility();
    //     }, 500);
    // });
    /*function updateButtonsVisibility() {
        if($('.shop-top-bar-left-item').length <= 1){
            return;
        }
        var element = $('.shop-top-bar-left-filters');
        var currentScroll = element.scrollLeft();
        var maxScrollLeft = element.prop('scrollWidth') - element.outerWidth();
    
        // Afficher ou cacher le bouton gauche
        if (currentScroll > 0) {
            $('.shop-top-bar-left-filters-buttons-left').show();
        } else {
            $('.shop-top-bar-left-filters-buttons-left').hide();
        }
    
        // Afficher ou cacher le bouton droit
        if (currentScroll < maxScrollLeft) {
            $('.shop-top-bar-left-filters-buttons-right').show();
        } else {
            $('.shop-top-bar-left-filters-buttons-right').hide();
        }
    }*/
    // function isScrolledToRight(selector) {
    //     var element = $(selector);
    //     var scrollLeft = element.scrollLeft(); // Position actuelle du défilement horizontal
    //     var visibleWidth = element.innerWidth(); // Largeur visible de l'élément
    //     var totalWidth = element.prop('scrollWidth'); // Largeur totale de défilement de l'élément
    //     console.log([(scrollLeft + visibleWidth), totalWidth])
    //     // Vérifier si on a défilé au maximum à droite avec 1px de marge d'erreur
    //     return (scrollLeft + visibleWidth + 1) >= totalWidth;
    // }
    
    
    // // Utiliser la fonction
    // var scrolledToRight = isScrolledToRight('.shop-top-bar-left-filters');
    // console.log(scrolledToRight); // Affiche true si vous avez défilé au maximum à droite, false sinon
    
    
    // // Utilisation de la fonction
    
    // function updateButtonsVisibility() {
    //     if($('.shop-top-bar-left-item').length <= 1){
    //         return;
    //     }
    //     var element = $('.shop-top-bar-left-filters');
    //     var currentScroll = element.scrollLeft();
    //     var maxScrollLeft = element.prop('scrollWidth') - element.outerWidth();
    
    //     // Afficher ou cacher le bouton gauche
    //     if (currentScroll > 0) {
    //         $('.shop-top-bar-left-filters-buttons-left').show();
    //     } else {
    //         $('.shop-top-bar-left-filters-buttons-left').hide();
    //     }
    
    //     // Afficher ou cacher le bouton droit
    //     var scrolledToRight = isScrolledToRight('.shop-top-bar-left-filters');
    //     console.log(scrolledToRight);
    //     if (scrolledToRight) {
    //         $('.shop-top-bar-left-filters-buttons-right').hide();
    //     } else {
    //         $('.shop-top-bar-left-filters-buttons-right').show();
    //     }
    // }
    
    // $(document).on('click', '.shop-top-bar-left-filters-buttons-right', function(event) {
    //     scrollToNextFilter('right');
    // });
    
    // $(document).on('click', '.shop-top-bar-left-filters-buttons-left', function(event) {
    //     scrollToNextFilter('left');
    // });
    
    // La fonction updateButtonsVisibility reste inchangée
    
    
    /**** End Shop filter swipe */

    //*** MAGIC LOGIN */
    $('#login_magic-form').on('submit', function(e) {
        e.preventDefault();
        console.log('submit login magic form');
        $('#login_magic-error').text('').hide();

        var email = $(this).find('input[name="email"]').val().trim();
        console.log(email)
        if(email == "") {
            $('#login_magic-error').text(oDict["enter_your_email"]).show();
            return;
        }else if(email.includes("@example")){
            $('#login_magic-error').text(oDict["enter_valid_email"]).show();
            return;
        }
        

        var currentUrl = window.location.href;
        var urlObject = new URL(currentUrl);
        var baseUrl = urlObject.origin;

        $.ajax({
            url: $(this).attr('action'),
            type: 'POST',
            data: {email: email, resend_code: true},
            success: function(data, status, xhr) {
                if (xhr.status === 201) {
                    console.log('ok')
                    // form creation to display
                    $('.login_magic-signup').fadeIn();
                    $('.login_magic-modal--reset').fadeIn();
                    $('.login_magic-form_submit').hide();
                } else if (xhr.status === 202 && data.has_password == false && data.user_login_type == 'native') {
                    console.log('no password')
                    // open popin to verify account
                    $.magnificPopup.close();
                    $('#verify_account-modal').attr('data-email', email);
                    $('.verify_account--A').hide();
                    $('.verify_account--B').show();
                    $.magnificPopup.open({
                        items: {
                            src: $('#verify_account-modal'),
                            closeMarkup: '',
                            type: 'inline',
                            closeBtnInside: false,
                            closeOnBgClick: false,
                        },
                        closeOnBgClick: false,
                        callbacks: {
                            open: function() {
                                $('.mfp-close').on('click', function(e) {
                                    e.preventDefault();
                                    $.magnificPopup.close(); // Fermer la popup lors du clic sur le bouton de fermeture
                                });
                            }
                        }
                    });


                } else if (xhr.status === 202 && data.has_password == true && data.user_login_type == 'native' && data.is_verified == false) {
                    console.log('has password but not verified')
                    $.magnificPopup.open({
                        items: {
                            src: $('#verify_account-modal'),
                            closeMarkup: '',
                            type: 'inline',
                            closeBtnInside: false,
                            closeOnBgClick: false,
                        },
                        closeOnBgClick: false,
                        callbacks: {
                            open: function() {
                                $('.mfp-close').on('click', function(e) {
                                    e.preventDefault();
                                    $.magnificPopup.close(); // Fermer la popup lors du clic sur le bouton de fermeture
                                });
                            }
                        }
                    });
                    $('#verify_account-modal').attr('data-email', $('#login_magic_email').val().trim());
                } else if (xhr.status === 202){
                    console.log('ok but has password')
                    // login
                    if(data.has_password == true && data.user_login_type == 'native'){
                        $('.login_magic-form_password').fadeIn();
                        $('.login_magic-modal--reset').fadeIn();
                        $('.login_magic-form_submit').hide();
                    }else if(data.user_login_type == 'google'){
                        // redirect to google login
                        window.location.href = $('#login_magic-modal .btn-google').attr('href')
                    }else if(data.user_login_type == 'apple'){
                        window.location.href = $('#login_magic-modal .btn-apple').attr('href')
                    }
                }else{
                    console.log('NOK');
                }
            },
            error: function(xhr, status, error) {
                console.log('AJAX error: ' + error);
            }
        });
    });

    $('.login_magic-modal--reset').on('click', function(e) {
        e.preventDefault();
        $('.login_magic-form_password').hide();
        $('.login_magic-signup').hide();
        $('.login_magic-form_submit').fadeIn();
        $('#login_magic-error').hide();
        $(this).hide();
    });

    /*** MAGIC LOGIN FORM SUBMISSION ***/

    $('.login_magic-form_password input[type="submit"]').on('click', function(e) {
        e.preventDefault(); // Empêche le rechargement de la page

        $('.error-message').remove();

        // Récupère les données du formulaire
        var email = $('#login_magic-form input[name="email"]').val().trim();
        var password = $('.login_magic-form_password input[name="password"]').val().trim();
        var redirect = $('.login_magic-form_password input[name="redirect"]').val().trim();
        var visitor_id = $('.login_magic-form_password input[name="visitor_id"]').val().trim();

        // Vérifie si les champs sont vides
        if (email === '') {
            addErrorMessage($('#login_magic-form input[name="email"]'), oDict["enter_your_email"]);
        } else if (!/^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/.test(email)) {
            addErrorMessage($('#login_magic-form input[name="email"]'), oDict["enter_valid_email"]);
        }

        if (password === '') {
            addErrorMessage($('.login_magic-form_password input[name="password"]'), oDict["enter_your_password"]);
        }

        if($('#login_magic-form .error-message').length > 0) {
            return;
        }

        var currentUrl = window.location.href;
        var urlObject = new URL(currentUrl);
        var baseUrl = urlObject.origin;

        //take checkout_id from url if exists, it should take what's after /checkout/
        var checkout_id = '';
        if (currentUrl.includes('/checkout/')) {
            // Get the part after '/checkout/' and before any '?' (no params)
            checkout_id = currentUrl.split('/checkout/')[1].split('?')[0].split('/')[0];
        }

        var formData = {
            email: email,
            password: password,
            redirect: redirect,
            visitor_id: visitor_id,
            checkout_id: checkout_id,
        };

        $.ajax({
            url: baseUrl + $('.login_magic-form_password input[type="submit"]').attr('data-login'),
            type: 'POST',
            data: formData,
            success: function(data, status, xhr) {
                var redirectUrl = xhr.getResponseHeader('Location');
                if (xhr.status === 201) {
                    var params = new URLSearchParams(window.location.search);
                    // Supprime le paramètre "key"
                    params.delete("key");

                    console.log(getCookieValue('wishlist_product_after_login'));

                    // Récupère la nouvelle URL sans "key"
                    var loginUrl = params.get("login_url");
                    if(loginUrl) {
                        window.location.href = loginUrl;
                    } else if (window.location.href.includes('/checkout/') || getCookieValue('wishlist_product_after_login')) {
                        sendEventLogger('checkout_account_login');
                        var url = new URL(window.location.href);
                        url.searchParams.delete('key');
                        window.location.href = url;
                    //sinon si il existe le cookie wishlist_product_after_login
                    } else {
                        //reload same url but removing "key" parameter if exists
                        // var url = new URL(window.location.href);
                        // url.searchParams.delete('key');
                        // window.location.href = url;
                        //redirect to account home
                        window.location.href = `/${urlObject.pathname.split('/').slice(1, 3).join('/')}/account/home`;
                    }
                } else {
                    if (data.success) {
                        console.log('Utilisateur créé avec succès');
                    } else {
                        if (data.errorCode === -2) {
                            console.log('Email does not exists');
                            addErrorMessage($('#login-form input[name="email"]'), oDict["email_doesnt_exist"]);
                        } else if (data.errorCode === 0) {
                            console.log('Password does not match');
                            addErrorMessage($('#login-form input[name="password"]'), oDict["password_doesnt_match"]);
                        } else if (data.errorCode === -4) {
                            console.log('Your account is not verified yet, please check your email');
                            addErrorMessage($('#login-form input[name="password"]'), oDict["account_not_verified"]);

                            $('#verify_account-modal').attr('data-email', $('#login-form input[name="email"]').val().trim());
                            $.magnificPopup.close();
                            $.magnificPopup.open({
                                items: {
                                    src: $('#verify_account-modal'),
                                    closeMarkup: '',
                                    type: 'inline',
                                    closeBtnInside: false,
                                    closeOnBgClick: false,
                                },
                                closeOnBgClick: false,
                            });
                        } else {
                            console.log('Erreur lors de la création de l\'utilisateur');
                        }
                    }    
                }
            },
            error: function(xhr, status, error) {
                console.log(baseUrl + $('#login-form').attr('action'));
                console.log('AJAX error: ' + error);
            }
        });
    });

    //*** Verify account modal submission ***/
    $('#verify_account_creation_signup-form').on('submit', function(e) {
        e.preventDefault(); // Empêche le rechargement de la page

        $('.error-message').remove();

        // Récupère les données du formulaire
        var code = $('#verify_account_creation_signup-form input[name="code"]').val().trim();
        // var firstname = $('#verify_account_creation_signup-form input[name="firstname"]').val().trim();
        // var lastname = $('#verify_account_creation_signup-form input[name="lastname"]').val().trim();
        var email = $('#verify_account_creation_signup-form input[name="email"]').val().trim();
        var password = $('#verify_account_creation_signup-form input[name="password"]').val().trim();

        // Vérifie si les champs sont vides
        // if (firstname === '') {
        //     addErrorMessage($('#verify_account_creation_signup-form input[name="firstname"]'), oDict["enter_valid_first_name"]);
        // }

        // if (lastname === '') {
        //     addErrorMessage($('#verify_account_creation_signup-form input[name="lastname"]'), oDict["enter_valid_last_name"]);
        // }

        if (email === '') {
            addErrorMessage($('#verify_account_creation_signup-form input[name="email"]'), oDict["enter_your_email"]);
        } else if (!/^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/.test(email)) {
            addErrorMessage($('#verify_account_creation_signup-form input[name="email"]'), oDict["enter_valid_email"]);
        }

        if (password === '') {
            addErrorMessage($('#verify_account_creation_signup-form input[name="password"]'), oDict["enter_your_password"]);
            $('.password-message').hide();
        }

        if (password !== '' && password.length > 20) {
            addErrorMessage($('#verify_account_creation_signup-form input[name="password"]'), oDict["password_exceed_char"]);
            $('.password-message').hide();
        }

        // Vérifie la complexité du mot de passe (1 majuscule, 1 chiffre, 1 symbole)
        var passwordRegex = /^(?=.*[A-Z])(?=.*\d).*$/;
        if (!passwordRegex.test(password)) {
            addErrorMessage($('#verify_account_creation_signup-form input[name="password"]'), oDict["password_policy"]);
            $('.password-message').hide();
        }

        if($('#verify_account_creation_signup-form .error-message').length > 0) {
            return;
        }

        // make ajax call to verify again and submit data
        console.log('ok');

        var currentUrl = window.location.href;
        var urlObject = new URL(currentUrl);
        var baseUrl = urlObject.origin;
        // get /us/en from url
        var locale = urlObject.pathname.split('/').slice(1, 3).join('/');

        $.ajax({
            url: baseUrl + $('#verify_account_creation_signup-form').attr('action'),
            type: 'POST',
            data: {code: code, email: email, password: password},
            success: function(data, status, xhr) {
                if (xhr.status === 203) {
                    console.log('ok')
                    // $('.verify_account_creation--hide').fadeIn();
                    // $('.verify_account_creation--show').hide();
                    window.location.href = `/${locale}/account/home`;
                } else {
                    console.log('NOK'); 
                }
            },
            error: function(xhr, status, error) {
                console.log(baseUrl + $('#signup-form').attr('action'));
                console.log('AJAX error: ' + error);
                $('.account_verif_form_error').html(oDict['g_error_occured']).show();
            }
        });
    });


    $('.checkout_quit_order .close-button, .checkout_quit_order .mfp-close').on('click', function(e) {
        e.preventDefault();
        $.magnificPopup.close();
    });
    $('.checkout_quit_bid .close-button, .checkout_quit_bid .mfp-close').on('click', function(e) {
        e.preventDefault();
        $.magnificPopup.close();
    });

    $('.header-checkout-section-item-link').on('click', function(e) {
        //do not redirect the href
        
        if($('.checkout_quit_order-modal').length > 0 && $('.checkout-container-left-confirmation:visible').length == 0){
            e.preventDefault();
            $.magnificPopup.open({
                items: {
                    src: $('.checkout_quit_order-modal'),
                    type: 'inline',
                    closeBtnInside: true,
                    modal: true,
                },
                closeOnBgClick: false,
                callbacks: {
                    open: function() {
                        jQuery('body').addClass('noscroll');
                    },
                    close: function() {
                        jQuery('body').removeClass('noscroll');
                    }
                }
            });
        }else if($('.checkout_quit_bid-modal').length > 0){
            e.preventDefault();
            $.magnificPopup.open({
                items: {
                    src: $('.checkout_quit_bid-modal'),
                    type: 'inline',
                    closeBtnInside: true,
                    modal: true,
                },
                closeOnBgClick: false,
                callbacks: {
                    open: function() {
                        jQuery('body').addClass('noscroll');
                    },
                    close: function() {
                        jQuery('body').removeClass('noscroll');
                    }
                }
            });
        }
    });

    $('.account-area-section-orders-item-details-delivery_return-infos .display-form').on('click', function(e) {
        e.preventDefault();
        $('.account-area-section-orders-item-details-delivery_return-infos').hide();
        $('.account-area-section-orders-item-details-delivery_return-form').css('display', 'flex');
    });

    $('.account-area-section-orders-item-details-delivery_return-form button').on('click', function(e) {
        e.preventDefault();

        var order_id = $('.account-area-section-orders-item-details-delivery_return-form input[name="order_id"]').val();
        var reason = $('.account-area-section-orders-item-details-delivery_return-form select[name="reason"]').val();
        var comment = $('.account-area-section-orders-item-details-delivery_return-form textarea[name="comment"]').val();
        var commentHtml = comment ? comment.replace(/\n/g, '<br>') : '';
        if(reason == ""){
            $('.account-area-section-orders-item-details-delivery_return-form select[name="reason"]').after('<span class="error-message">' + oDict["select_a_reason"] + '</span>');
            return;
        }

        if($(this).hasClass('next')){
            $(this).hide();
            //hide select and textarea
            $('.account-area-section-orders-item-details-delivery_return-form .error-message').remove();
            $('.account-area-section-orders-item-details-delivery_return-form select').hide();
            $('.account-area-section-orders-item-details-delivery_return-form textarea').hide();
            $('.account-area-section-orders-item-details-delivery_return-form button.submit').show();
            $('.account-area-section-orders-item-details-delivery_return-form-method').show();

            return;
        }

        var refund_method = $('.account-area-section-orders-item-details-delivery_return-form input[name="refund_method"]').val();

        //call ajax to save the return request
        var currentUrl = window.location.href;
        var urlObject = new URL(currentUrl);
        var baseUrl = urlObject.origin;
        $.ajax({
            url: baseUrl + $('.account-area-section-orders-item-details-delivery_return-form').attr('data-form'),
            type: 'POST',
            data: {buykey: order_id, reason: reason, comment: commentHtml, refund_method: refund_method},
            success: function(data, status, xhr) {
                if (xhr.status === 201) {
                    //reload the page
                    // window.location.reload();
                    $('.account-area-section-orders-item-details-delivery_return-form').hide();
                    $('.account-area-section-orders-item-details-delivery_return-instructions').css('display', 'flex');
                    $('.account-area-section-orders-item-details-delivery_return-instructions__reason').text($('.account-area-section-orders-item-details-delivery_return-form select[name="reason"]').find('option:selected').text());
                    $('.account-area-section-orders-item-details-delivery_return-instructions__message').html(commentHtml);
                    if(refund_method == "store_credits"){
                        $('.account-area-section-orders-item-details-delivery_return-instructions__refund').html(oDict["account_delivery_return_form_refund_store_credit_title"]);
                    } else if(refund_method == "original_payment") {
                        $('.account-area-section-orders-item-details-delivery_return-instructions__refund').html(oDict["account_delivery_return_form_refund_original_payment_title"]);
                    }

                    // $('.account-area-section-orders-item-instructions').show();
                } else {
                    console.log('error');
                    $('.account-area-section-orders-item-details-delivery_return-form').prepend('<span class="error-message">' + oDict["g_error_occured"] + '</span>');
                } 
            },
            error: function(xhr, status, error) {
                console.log('AJAX error: ' + error);
                $('.account-area-section-orders-item-details-delivery_return-form').prepend('<span class="error-message">' + oDict["g_error_occured"] + '</span>');
            }
        });
    });

    $('.account-area-section-orders-item-details-delivery_return-form-method-item').on('click', function() {
        $('.account-area-section-orders-item-details-delivery_return-form-method-item').toggleClass('active');
        var selectedMethod = $('.account-area-section-orders-item-details-delivery_return-form-method-item.active').data('value');
        $('.account-area-section-orders-item-details-delivery_return-form input[name="refund_method"]').val(selectedMethod);
    });

    if($('.account-area-section-orders-item-details-delivery_status-bottom_infos').length > 0 && $('.account-area-section-orders-item-details-delivery_status-bottom').length > 0){
        $('.account-area-section-orders-item-details-delivery_status-bottom_infos').height($('.account-area-section-orders-item-details-delivery_status-bottom').height());
    }

    $(document).on('click', '.quick_wishlist-trigger', function(e) {
        e.preventDefault();
        var productId = $(this).data('product');
        // Find the product-quick_wishlist and add active class
        $('.product-quick_wishlist').removeClass('active'); // Remove active class from all

        if($(this).hasClass('active') && $(this).hasClass('checked')){
            $('.product-quick_wishlist[data-product="' + productId + '"]').find('.product-quick_wishlist-size').first().trigger('click');
        }else if($('.product-quick_wishlist[data-product="' + productId + '"]').find('.product-quick_wishlist-size').length == 1){
            $('.product-quick_wishlist[data-product="' + productId + '"]').find('.product-quick_wishlist-size').first().trigger('click');
        }else{
            $('.product-quick_wishlist[data-product="' + productId + '"]').addClass('active');
        }
    });

    $(document).on('click', '.product-quick_wishlist-size', function(e) {
        e.preventDefault();
        // Handle size selection
        var size = $(this).text();
        var productId = $(this).closest('.product-quick_wishlist').data('product');
        $('.product-quick_wishlist').removeClass('active');
        
        //wishlist-update
        var currentUrl = window.location.href;
        var urlObject = new URL(currentUrl);
        var baseUrl = urlObject.origin;

        $.ajax({
            url: baseUrl + "/wishlist-update",
            type: 'POST',
            data: {product: productId.toLowerCase(), size: size},
            success: function(data, status, xhr) {
                if (xhr.status === 201) {
                    if($('.quick_wishlist-trigger[data-product="'+productId+'"].checked').hasClass('active')){
                        sendEventLogger('wishlist_remove');
                    }else{
                        sendEventLogger('wishlist_add');
                    }
                    $('.quick_wishlist-trigger[data-product="'+productId+'"]').toggleClass('active');
                    $('.wishlist-error').remove();
                } else {
                    if (data.success) {
                        console.log('NOK');
                    } else {
                        if (data.errorCode === -2) {
                            console.log("Error -2");
                        } else {
                            console.log('Error during wishlist adding');
                        }
                    }                  
                }
            },
            error: function(xhr, status, error) {
                console.log('AJAX error: ' + error);
            }
        });
    });

    $(document).on('click', '.product-quick_wishlist-close', function(e) {
        e.preventDefault();
        // Handle close button click
        $('.product-quick_wishlist').removeClass('active');
    });

    $('.open-order_return_instructions_popin-modal').click(function(e) {
        e.preventDefault();
        $.magnificPopup.open({
            items: {
                src: $('.order_return_instructions_popin-modal'),
                type: 'inline',
                closeBtnInside: true,
                modal: true,
            },
            callbacks: {
                open: function() {
                    jQuery('body').addClass('noscroll');
                },
                close: function() {
                    jQuery('body').removeClass('noscroll');
                }
            }
        });
    });
    

    if($('.expiring_counter_offer').length > 0){
        var updateCountdown = function() {
            var $counter = $('.expiring_counter_offer');
            var endTime = new Date($counter.data('time'));
            endTime.setDate(endTime.getDate() + 1); // Ajoute un jour à la date
        
            var currentTime = new Date();
            var timeDiff = endTime - currentTime; // Différence en millisecondes
        
            if (timeDiff <= 0) {
                // Si le compte à rebours est terminé
                $counter.text(oDict['expired']);
                $('.account-area-section-orders-item-details-accept_counter').hide()
                clearInterval(interval); // Arrête le compte à rebours
                return;
            }
        
            var hours = Math.floor((timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            var minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
            var seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);
        
            var timeParts = []; // Pour stocker les parties de la chaîne de temps
        
            // Ajoute les heures si supérieures à 0 et gère le singulier/pluriel
            if(hours > 0) {
                if(hours > 1){
                    timeParts.push(hours + ' ' + oDict['g_hours']);
                }else{
                    timeParts.push(hours + ' ' + oDict['g_hour']);
                }
                
            }
        
            // Ajoute les minutes si supérieures à 0 et gère le singulier/pluriel
            if(minutes > 0) {
                if(minutes > 1){
                    timeParts.push(minutes + ' ' + oDict['g_minutes']);
                }else{
                    timeParts.push(minutes + ' ' + oDict['g_minute']);
                }
            }
        
            // Toujours ajouter les secondes (suppose qu'on veut toujours les afficher) et gère le singulier/pluriel
            if(seconds > 1){
                timeParts.push(seconds + ' ' + oDict['g_seconds']);
            }else{
                timeParts.push(seconds + ' ' + oDict['g_second']);
            }

            // Mise à jour du texte du compteur
            $counter.text(oDict['bid_expiring_in'] + ' ' + timeParts.join(', '));
        };
        

        var interval = setInterval(updateCountdown, 1000); // Met à jour le compte à rebours toutes les secondes
    }

    var anchor = window.location.hash.substring(1);
    if (anchor && anchor !== '') {
        if(anchor === 'history'){
            $('#history').click();
        }else if(anchor == "lotw"){
            setTimeout(function() {
                $('html, body').animate({
                    scrollTop: $('#'+anchor).offset().top - 100
                }, 500);
            }, 500);
        }else if(anchor.startsWith('collection_')){
            //scroll to id collection_timeless adding 30px
            $('html, body').animate({
                scrollTop: $('#'+anchor).offset().top - 100
                
            }, 500);
        }
    }

    $('.page-area-anchor').on('click', function(e) {
        e.preventDefault();
        var target = $(this).attr('data-anchor');
        var $target = $('#' + target);

        if ($target.length === 0) return;

        // Find the first h2 inside the target element
        var $h2 = $target.find('h2').first();
        var scrollToElem = $h2.length ? $h2 : $target;

        // Calcul de l'offset selon la taille d'écran
        var offset = ($(window).width() < 768) ? 50 : 200;

        const $modal = $('.checkout_privacy_popin-modal');
        const headerH = $('.site-header:visible').outerHeight() || 0; // si tu as un header sticky dans la modale, sinon 0
        const offsetModal = headerH + 16; // marge de confort

        if ($modal.length) {
        // position de la cible relative au conteneur + scroll actuel du conteneur - offset
            let top = scrollToElem.offset().top - $modal.offset().top + $modal.scrollTop() - offsetModal;

            // clamp pour éviter de viser au-delà du max scrollable (sinon "colle" en bas)
            const max = $modal[0].scrollHeight - $modal.innerHeight();
            top = Math.min(Math.max(0, top), max);

            $modal.stop(true).animate({ scrollTop: top }, 500);
        } else {
            $('html, body').animate({
                scrollTop: scrollToElem.offset().top - offset
            }, 500);
        }
    });

    if($('.scroll-to-bid').length > 0){
        $('html, body').animate({
            scrollTop: $('.scroll-to-bid').offset().top - 150
        }, 500);
    }

    $('.account-area-section-orders-item-details-accept_counter').on('click', function(e) {
        e.preventDefault();
        var bidId = $(this).attr('data-id');
        var bidTotal = $(this).attr('data-total');
        $.magnificPopup.open({
            items: {
                src: $('.bid_counter_accept-modal'),
                type: 'inline',
                closeBtnInside: true,
                modal: true,
            },
            closeOnBgClick: false,
            callbacks: {
                open: function() {
                    jQuery('body').addClass('noscroll');
                    $('.bid_counter_accept-confirm').attr('data-id', bidId);
                    $('.bid_counter_accept-total').text(bidTotal);
                },
                close: function() {
                    jQuery('body').removeClass('noscroll');
                }
            }
        });
    });
    $('.bid_counter_accept-modal .close-button').on('click', function(e) {
        e.preventDefault();
        $.magnificPopup.close();
    });


    $('.bid_counter_accept-confirm').on('click', function(e) {
        e.preventDefault();
        var bidId = $(this).attr('data-id');    
        
        var currentUrl = window.location.href;
        var urlObject = new URL(currentUrl);
        var baseUrl = urlObject.origin;

        $.ajax({
            url: baseUrl + $('.bid_counter_accept-confirm').attr('action'),
            type: 'POST',
            data: {bidId: bidId},
            success: function(data, status, xhr) {
                if (xhr.status === 201) {
                    window.location.href = window.location.href.split('#')[0] + '#history';
                    window.location.reload();
                } else {
                    console.log('error');
                }
            },
            error: function(xhr, status, error) {
                console.log('AJAX error: ' + error);
            }
        });
    });

    if ($(window.location).attr('href').includes('login_url')) {
        var loginUrl = new URLSearchParams(window.location.search).get("login_url");
        if(loginUrl != ""){
            $('.open-login_magic-modal').click();
            $('input[name="redirect"]').val(loginUrl);
        }
    }

    //Bid predict in product pages
    if($('#product-bid_predict-bar-slider').length > 0){
        function cursorPosition(item){
            var value = item.val(); 
            var max = item.attr('max'); 
            var min = item.attr('min');
            var position = (value - min) / (max - min) * 100;
            var newPosition = position * (item.outerWidth() - $('.range-text').width()) / 100;

            if(value == max){
                $('#range-text').css('right', '0px').css('left', 'auto');
            }else if(value == min){
                $('#range-text').css('left', '0px').css('right', 'auto');
            }else{
                $('#range-text').css('left', newPosition + 'px').css('right', 'auto');
            }
        }
        $('#product-bid_predict-bar-slider').on('input', function() {
            var index = $(this).val(); 
            sendEventLogger('bid_predictor_used');
            if(index >= 0 && index < bidPredictDataForRegion.length) {
                var bidPredict = bidPredictDataForRegion[index];
                $('.product-bid_predict-probability').text(bidPredict.p + '%');
                $('.product-bid_predict-amount').text(currencySymbol + bidPredict.bid.toLocaleString());
                cursorPosition($(this));
                $(this).attr('data-amount', bidPredict.bid);

                // var bidLink = $('.product-actions__bid a');
                // var href = bidLink.attr('href');
                // var newHref = href.replace(/(&amt=)[^&]*/, '$1' + bidPredict.bid);
                // bidLink.attr('href', newHref);

                if($('input#bid-number').length > 0){
                    $('input#bid-number').val(bidPredict.bid);
                }

                const BidPredictorEvent = new CustomEvent('bidPredictor', {
                bubbles: true,
                    detail: {
                        position: parseInt(index)
                    }
                });
                
                document.dispatchEvent(BidPredictorEvent);
            }
        });
        cursorPosition($('#product-bid_predict-bar-slider'));
        $('#range-text').fadeIn();
    }

    $('.product-reinsurance-item-title').click(function(e) {
        e.preventDefault();
        if($(this).siblings('div').hasClass('active')){
            $(this).siblings('div').removeClass('active');
        }else{
            $('.product-reinsurance-item-description').removeClass('active');
            $(this).siblings('div').toggleClass('active');
        }
    });

    if($('.account-area-section-orders-item.status-ongoing.counter_offer').length > 0){
        $('.account-bid-counter-offer-mention').show();

        $('.account-bid-counter-offer-link').click(function(e) {
            e.preventDefault();
            // Calcule la position de l'élément ciblé
            var position = $('.account-area-section-orders-item.status-ongoing.counter_offer').first().offset().top - 100;
    
            $('.account-area-section-orders-item.status-ongoing.counter_offer').first().find('.account-area-section-orders-item-details').removeClass('inactive');
        
            // Fait défiler la page jusqu'à cet élément
            $('html, body').animate({
                scrollTop: position
            }, 'slow');
        });
    }
    
    

    //si il y a le paramètre infinite dans l'url 
    if (window.location.href.indexOf("infinite") > -1) {
        $('.products-list-display-pagination').css('visibility', 'hidden');
        var isClickAllowed = true; 
        
        $(window).scroll(function() {
            var $productWraps = $('.product-wrap');
            
            if ($productWraps.length > 1 && isClickAllowed) {
                var $penultimateProductWrap = $productWraps.eq(-2);
                var penultimateProductWrapOffset = $penultimateProductWrap.offset().top;
                var scrollPosition = $(window).scrollTop() + $(window).height();
                
                if (scrollPosition > penultimateProductWrapOffset) {
                    $('.products-list-display-pagination').attr('data-page', parseInt($('.products-list-display-pagination').attr('data-page')) + 1);

                    // Adding page param to url
                    var urlParams = new URLSearchParams(window.location.search);
                    urlParams.set('page', $('.products-list-display-pagination').attr('data-page'));
                    console.log('added page');
                    window.history.pushState({}, '', window.location.pathname + '?' + urlParams.toString());

                    displayCategoryProductsMobile(checkFilters(), false);

                    isClickAllowed = false;
                    
                    setTimeout(function() { isClickAllowed = true; }, 3000); // Réactiver après 3 secondes
                }
            }
        });
    }

    $(document).on('click', '.saveSearchBtn', function(e) {
        e.preventDefault();
        
        if($('.search-page').length > 0){
            var category = $('.shop-top-bar-left-item.query-item').first().text().toUpperCase();
            if(gender_page_data){
                var gender = gender_page_data
            }else{
                var gender = "Search";
            }
        }else{
            var category = $('h1').text();
            var gender = $('.shop-area-breadcrumb .shop-area-breadcrumb-text').first().text();
        }
        
        let searchId = $(this).attr('data-saved');

        var oDict = JSON.parse(document.querySelector('[dict-json]').innerHTML);

        var fullUrl = window.location.href;
        var urlObject = new URL(fullUrl);
        var link = urlObject.pathname + urlObject.search;

        let filters = [];
        $('.shop-top-bar-left-item').each(function() {
            let filter_value = $(this).attr('data-filter-value');
            let filter_key = $(this).attr('data-filter-key');
            let filter_name = $(this).find("span").text();
            if(filter_value != undefined && filter_value != undefined)
                filters.push([filter_key, filter_value, filter_name]);
        });
        let json_filters = JSON.stringify(filters);
        
        var currentUrl = window.location.href;
        var urlObject = new URL(currentUrl);
        var baseUrl = urlObject.origin;

        if(searchId != null && searchId != ""){
            window.location.href = baseUrl + $(this).data('redirect');
        }else{
            var dataSearch = {filters: json_filters, gender: gender, category: category, link: link};
            var urlSearch = baseUrl + "/save-search";
            var textSuccess = oDict["saved_search"];
        }

        $.ajax({
            url: urlSearch,
            type: 'POST',
            data: dataSearch,
            success: function(data, status, xhr) {
                if (xhr.status === 201) {
                    $('.saveSearchBtn').text(textSuccess).toggleClass('saved').attr('data-saved', data.searchId);
                    if(!$('.saveSearchBtn').hasClass('saved')){
                        var urlSearch = new URL(window.location.href);
                        urlSearch.searchParams.delete('search');
                        window.history.pushState({}, '', urlSearch);

                        $('.saveSearchBtn').data('saved', '');
                    }
                } else {
                    if (data.success) {
                        console.log('NOK');
                    } else {
                        if (data.errorCode === -2) {
                            console.log("Error -2");
                        } else {
                            console.log('Error during save search');
                            console.log(data.errorCode);
                            console.log(data.errorMsg);
                        }
                    }                  
                }
            },
            error: function(xhr, status, error) {
                console.log('AJAX error: ' + error);
            }
        });

    });

    $('.saveSearchBtn').on('click', function(e) {
        e.preventDefault();
        if($(this).hasClass('open-login-modal')){
            //add parameter to url
            var url = new URL(window.location.href);
            url.searchParams.set('save', "true");
            window.history.pushState({}, '', url);

            var currentUrl = encodeURIComponent(window.location.pathname + window.location.search);
            $('a.btn-google, a.btn-apple').attr('href', function (index, href) {
                return href.replace(/tfs_redirect=[^&]*/, 'tfs_redirect=' + currentUrl);
            });
        }
    });

    //if url contains save=true
    if(window.location.href.indexOf("save=true") > -1){
        //remove parameter from url
        var url = new URL(window.location.href);
        url.searchParams.delete('save');
        window.history.pushState({}, '', url);

        setTimeout(function() {
            $('.saveSearchBtn').click();
        }, 500);
    }

    $('.remove_saved_search_popin_yes').on('click', function(e) {
        e.preventDefault();
        var searchId = $(this).attr('data-id');
        
        var currentUrl = window.location.href;
        var urlObject = new URL(currentUrl);
        var baseUrl = urlObject.origin;

        $.ajax({
            url: baseUrl + "/remove-search",
            type: 'POST',
            data: {searchId: searchId},
            success: function(data, status, xhr) {
                if (xhr.status === 201) {
                    $('.account-area-section-searchs-link[data-id="'+searchId+'"]').fadeOut(function() {
                        $(this).remove();
                        if($('.account-area-section-searchs-link').length == 0){
                            window.location.reload();
                        }
                    });
                    $.magnificPopup.close();
                } else {
                    if (data.success) {
                        console.log('NOK');
                    } else {
                        if (data.errorCode === -2) {
                            console.log("Error -2");
                        } else {
                            console.log('Error during save search');
                            console.log(data.errorCode);
                            console.log(data.errorMsg);
                        }
                    }                  
                }
            },
            error: function(xhr, status, error) {
                console.log('AJAX error: ' + error);
            }
        });

    });


    $('.remove-saved-search-btn').on('click', function(e) {
        e.preventDefault();

        var searchId = $(this).attr('data-id');
        $('.remove_saved_search_popin_yes').attr('data-id', searchId);

        $.magnificPopup.open({
            items: {
                src: $('.remove_saved_search_popin-modal'),
                type: 'inline',
                closeBtnInside: true,
                modal: true,
            },
            closeOnBgClick: false,
            callbacks: {
                open: function() {
                    jQuery('body').addClass('noscroll');
                },
                close: function() {
                    jQuery('body').removeClass('noscroll');
                }
            }
        });
    });

    $('.remove_saved_search_popin_no').click(function(e) {
        e.preventDefault();
        $.magnificPopup.close();
    });

    // $('.open-popin_moodboard_create-modal').magnificPopup({
    //     type: 'inline',
    //     closeOnBgClick: false,
    //     callbacks: {
    //         open: function() {
    
    //         }
    //     }
    // });

    $('.open-popin_moodboard_create-modal').magnificPopup({
        type: 'inline',
        closeOnBgClick: true,
        closeOnContentClick: false,
    });

    $('.popin_moodboard_create-modal input').on('click', function(e) {
        e.stopPropagation();
    });

    $('.popin_moodboard_create-modal .moodboard_products_item, .popin_moodboard_add_product-modal .moodboard_products_item').click(function(e) {
        e.preventDefault();
        $(this).toggleClass('selected');
    });

    $('.popin_moodboard_create-modal, .popin_moodboard_add_product-modal').click(function(e) {
        e.preventDefault();
        e.stopPropagation();
    });

    $('.popin_moodboard_create-modal .btn-primary').click(function(e) {

        //get selected products
        var products = [];
        $('.popin_moodboard_create-modal .moodboard_products_item.selected').each(function() {
            products.push($(this).attr('data-id'));
        });

        let moodboard_name = $('.popin_moodboard_create-modal input[name="moodboard_title"]').val();

        var currentUrl = window.location.href;
        var urlObject = new URL(currentUrl);
        var baseUrl = urlObject.origin;

        console.log(products);

        $.ajax({
            url: baseUrl + "/moodboard-create",
            type: 'POST',
            data: {name: moodboard_name, products: products},
            success: function(data, status, xhr) {
                if (xhr.status === 201) {
                    window.location.reload();
                } else {
                    if (data.success) {
                        console.log('NOK');
                    } else {
                        if (data.errorCode === -2) {
                            console.log("Error -2");
                        } else {
                            console.log('Error during password reset');
                        }
                    }                  
                }
            },
            error: function(xhr, status, error) {
                console.log('AJAX error: ' + error);
            }
        });
    });

    $('.open-popin_moodboard_add_product-modal').magnificPopup({
        type: 'inline',
        closeOnBgClick: true,
        closeOnContentClick: false,
    });

    $('.popin_moodboard_add_product-modal .btn-primary').click(function(e) {

        //get selected products
        var products = [];
        $('.popin_moodboard_add_product-modal .moodboard_products_item.selected').each(function() {
            products.push($(this).attr('data-id'));
        });

        let collection = $(this).data('collection');

        var currentUrl = window.location.href;
        var urlObject = new URL(currentUrl);
        var baseUrl = urlObject.origin;

        console.log(products);

        $.ajax({
            url: baseUrl + "/moodboard-add-products",
            type: 'POST',
            data: {collection: collection, products: products},
            success: function(data, status, xhr) {
                if (xhr.status === 201) {
                    window.location.reload();
                } else {
                    if (data.success) {
                        console.log('NOK');
                    } else {
                        if (data.errorCode === -2) {
                            console.log("Error -2");
                        } else {
                            console.log('Error during password reset');
                        }
                    }                  
                }
            },
            error: function(xhr, status, error) {
                console.log('AJAX error: ' + error);
            }
        });
    });


    const inputElements = [...document.querySelectorAll('input.code-input')]

    inputElements.forEach((ele,index)=>{
        ele.addEventListener('keydown',(e)=>{
            if(e.keyCode === 8 && e.target.value==='') inputElements[Math.max(0,index-1)].focus()
        })
        ele.addEventListener('input',(e)=>{
            const [first,...rest] = e.target.value
            e.target.value = first ?? '' 
            const lastInputBox = index===inputElements.length-1
            const didInsertContent = first!==undefined
            if(didInsertContent && !lastInputBox) {
            inputElements[index+1].focus()
            inputElements[index+1].value = rest.join('')
            inputElements[index+1].dispatchEvent(new Event('input'))
            }
        })
    })

    $(document).on('click', '.account_verif_form_submit-btn', function(e) {
        e.preventDefault();
        e.stopPropagation();

        $('.account_verif_form_message').html("").hide();
        $('.account_verif_form_error').html("").hide();

        var code = '';
        var email = '';

        $('#account_verif_form input').each(function() {
            code += $(this).val();
        });

        email = $('#verify_account-modal').data('email');
        
        var currentUrl = window.location.href;
        var urlObject = new URL(currentUrl);
        var baseUrl = urlObject.origin;

        $.ajax({
            url: baseUrl + $('#account_verif_form').data('action'),
            type: 'POST',
            data: {code: code, email: email},
            success: function(data, status, xhr) {
                if (xhr.status === 201) {
                    console.log('ok')
                    // window.location.reload();
                    $.magnificPopup.close();
                    $('.account_verified_popin .close-button, .account_verified_popin .mfp-close').on('click', function(e) {
                        e.preventDefault();
                        $.magnificPopup.close();
                    });
                    $.magnificPopup.open({
                        items: {
                            src: $('.account_verified_popin-modal'),
                            type: 'inline',
                            closeBtnInside: true,
                            modal: true,
                        },
                        closeOnBgClick: false,
                        callbacks: {
                            open: function() {
                                jQuery('body').addClass('noscroll');
                            },
                            close: function() {
                                jQuery('body').removeClass('noscroll');
                            }
                        }
                    });
                } else if (xhr.status === 202){
                    //user has successfully verified his account but account has no password set
                    $.magnificPopup.close();
                    //set code + email in the modal
                    $('#verify_account_creation_signup-form input[name="email"]').val(email);
                    $('#verify_account_creation_signup-form input[name="code"]').val(code);
                    $.magnificPopup.open({
                        items: {
                            src: $('.verify_account_creation-modal'),
                            type: 'inline',
                            closeBtnInside: true,
                            modal: true,
                        },
                        closeOnBgClick: false,
                        callbacks: {
                            open: function() {
                                jQuery('body').addClass('noscroll');
                            },
                            close: function() {
                                jQuery('body').removeClass('noscroll');
                            }
                        }
                    });
                } else if( xhr.status === 204 ){
                    $('.account_verif_form_error').html(oDict['verify_account_invalid']).show();
                    setTimeout(function() {
                        $('.account_verif_form_error').html("").fadeOut();
                    }, 5000);
                } else {
                    console.log('NOK'); 

                    //delete the code
                    $('#account_verif_form input').val('');

                    //get the error message in json from errorCode
                    if(data.errorCode == -3){
                        $('.account_verif_form_error').html(oDict['verify_account_invalid_2']).show();
                    }else if(data.errorCode == -5){
                        $('.account_verif_form_error').html(oDict['verify_account_expired']).show();
                    }else{
                        $('.account_verif_form_error').html(oDict['g_error_occured']).show();
                    }
                    setTimeout(function() {
                        $('.account_verif_form_error').html("").hide();
                    }, 10000);
                }
            },
            error: function(xhr, status, error) {
                console.log(baseUrl + $('#signup-form').attr('action'));
                console.log('AJAX error: ' + error);
                $('.account_verif_form_error').html(oDict['g_error_occured']).show();
            }
        });

    });

    
    $(document).on('click', '.account_verif_form_resend-btn', function(e) {
        e.preventDefault();

        if($(this).attr('data-sent') == 'true'){
            console.log('skipped')
            return;
        }

        $('.account_verif_form_message').html("").hide();
        $('.account_verif_form_error').html("").hide();

        var email = '';
        email = $('#verify_account-modal').data('email');
        
        var currentUrl = window.location.href;
        var urlObject = new URL(currentUrl);
        var baseUrl = urlObject.origin;

        $.ajax({
            url: baseUrl + $('.account_verif_form_resend-btn').attr('href'),
            type: 'POST',
            data: {email: email},
            success: function(data, status, xhr) {
                if (xhr.status === 201) {
                    $('.account_verif_form_message').html(oDict['verify_account_sent']).show();
                    
                    $('.account_verif_form_resend-btn').attr('data-sent', 'true').html(oDict["verif_sent"]);
                    $('.verif_counter').text(60);
                    var interval = setInterval(function() {
                        var counter = $('.verif_counter').text();
                        counter--;
                        $('.verif_counter').text(counter);
                        if(counter == 0) {
                            clearInterval(interval);
                            $('.account_verif_form_resend-btn').attr('data-sent', 'false');
                            $('.account_verif_form_resend-btn').html(oDict["verif_send_code"]);
                        }
                    }, 1000);
                } else {
                    $('.account_verif_form_error').html(oDict['g_error_occured']).show();
                }
            },
            error: function(xhr, status, error) {
                console.log('AJAX error: ' + error);
                $('.account_verif_form_error').html(oDict['g_error_occured']).show();
            }
        });
    });

    $('.account_verified_popin_reload').on('click', function(e) {
        // si il y a dans l'url le paramètre login_url et qu'il contient "signup" alors on le supprime
        var currentUrl = window.location.href;
        var urlObject = new URL(currentUrl);
        if(urlObject.searchParams.has('login_url') && urlObject.searchParams.get('login_url').includes('signup')){
            urlObject.searchParams.delete('login_url');
        }
        window.history.pushState({}, '', urlObject.toString());

        e.preventDefault();
        window.location.reload();
    });

    $('.loyalty_popin__exclusive-content_btn').on('click', function(e) {
        e.preventDefault();

        var currentUrl = window.location.href;
        var urlObject = new URL(currentUrl);
        var baseUrl = urlObject.origin;

        $.ajax({
            url: baseUrl + $(this).attr('href'),
            type: 'POST',
            data: {},
            success: function(data, status, xhr) {
                if (xhr.status === 201) {
                    $('.loyalty_popin__exclusive-content_btn').hide();
                    $('.loyalty_popin__exclusive-content_activated').show();
                }
            },
            error: function(xhr, status, error) {
                console.log('AJAX error: ' + error);
            }
        });

    });

    $('.product-sales-wishlist').css('display', '');

    $('.loyalty_page2__table_rewards_item_left, .loyalty_page2__table_rewards_mobile__rewards_item').click(function(e) {
        e.preventDefault();
        $(this).toggleClass('opened');
        $(this).siblings('.loyalty_page2__table_rewards_item_right').toggleClass('opened');
    });

    $('.loyalty_page2__table_rewards_mobile__categories_item').click(function(e) {
        e.preventDefault();
        $(this).addClass('active');
        $(this).siblings().removeClass('active');
        var cat = $(this).data('cat');
        console.log(cat);
        $('.loyalty_page2__table_rewards_mobile__rewards_item').each(function() {
            if($(this).data('cat') > cat){
                $(this).addClass('hidden');
            }else{
                $(this).removeClass('hidden');
            }
        });
    });

    $('#giftwrap').on('change', function() {
        if($(this).is(':checked')){
            $('.bid-area-section-content-giftwrap-message').removeClass('hidden');
        }else{
            $('.bid-area-section-content-giftwrap-message').addClass('hidden');
            $('.bid-area-section-content-giftwrap-message-count').text(oDict['giftwrap_150_left']);
            $('#giftwrap-message').val('');
        }
    });

    $('#giftwrap-message').on('keyup', function() {
        //we count the number of characters
        var count = $(this).val().length;
        if((150 - count) < 2){
            $('.bid-area-section-content-giftwrap-message-count').text(150 - count + " " + oDict['giftwrap_character_left']);
        }else{
            $('.bid-area-section-content-giftwrap-message-count').text(150 - count + " " + oDict['giftwrap_characters_left']);
        }
    });

    /// ANIMATION APPARITION PRE-HOME
    // $('.pre_home-big_entry a').on('click', function(e) {
    //     e.preventDefault();
        
    //     var href = $(this).attr('href'); // Capture l'attribut href
    
    //     console.log(href);

    //     if ($(window).width() > 768) {
    
    //         if($(this).parent().hasClass('women')){
    //             $('.pre_home_left').css('transition', 'width 2s ease').css('width', '100vw');
    //             $('.pre_home_right').css('transition', 'width 2s ease').css('width', '0');
    //         }else{
    //             $('.pre_home_left').css('transition', 'width 2s ease').css('width', '0');
    //             $('.pre_home_right').css('transition', 'width 2s ease').css('width', '100vw');
    //         }
    //         $('.pre_home-big_entry a').css('transition', 'opacity 0.5s ease').css('opacity', '0');
    //         $('.pre_home-logo svg').css({
    //             'width': '300px',
    //             'height': '50px',
    //             'transition': 'width 2s ease, height 2s ease'
    //         });
    //         $('.pre_home-logo').css('transition', 'top 2s ease').css('top', '70px');
    //     }else{
    //         if($(this).parent().hasClass('women')){
    //             $('.pre_home_left').css('transition', 'height 2s ease').css('height', '90vh');
    //             $('.pre_home_right').css('transition', 'height 2s ease').css('height', '0');
    //             //scroll to the parent
    //             $('html, body').animate({
    //                 scrollTop: $('.pre_home_left').offset().top
    //             }, 500);
    //         }else{
    //             $('.pre_home_left').css('transition', 'height 2s ease').css('height', '0');
    //             $('.pre_home_right').css('transition', 'height 2s ease').css('height', '90vh');
    //             $('html, body').animate({
    //                 scrollTop: $('.pre_home_right').offset().top
    //             }, 500);
    //         }
    //         $('.pre_home-big_entry a').css('transition', 'opacity 0.5s ease').css('opacity', '0');
    //         $('.pre_home-logo svg').css({
    //             'width': '300px',
    //             'height': '50px',
    //             'transition': 'width 2s ease, height 2s ease'
    //         });
    //         $('.pre_home-logo').css('transition', 'top 2s ease').css('top', '70px');
    //     }
    
    //     setTimeout(function() {
    //         window.location.href = href; // Utilise la valeur capturée
    //     }, 2000);
    // });
    
    $(document).on("closeAddPaymentMethodModal", function (event) {
        $.magnificPopup.close();
    });

    $('.country_switcher_link').on('click', function(e) {
        e.preventDefault();
        $('.country_switcher_section').toggleClass('active');
    });

    $('.country_switcher_close').on('click', function(e) {
        e.preventDefault();
        $('.country_switcher_section').removeClass('active');
    });

    $('.country_switcher_section_entries span').on('click', function(e) {
        e.preventDefault();
        var target = $(this).data('target');
        $('.country_switcher_section_entries span').removeClass('active');
        $(this).addClass('active');
        $('span[data-target]').removeClass('active');
        $('.country_switcher_section_panel[data-target]').removeClass('active');
        $('span[data-target="'+target+'"]').addClass('active');
        $('.country_switcher_section_panel[data-target="'+target+'"]').addClass('active');
    });

    $('.open_country_switcher_mobile').on('click', function(e) {
        e.preventDefault();
        var target = $(this).data('target');
        $('.country_switcher_section_entries span').removeClass('active');
        $('span[data-target="'+target+'"]').addClass('active');
        $('.country_switcher_section').toggleClass('active');
        $('.country_switcher_section_entries span[data-target="'+target+'"]').click();
    });

    //pour l'input qui a le name="ssn", on ajoute un mask
    $('input[name="ssn"]').mask('000-00-0000');
    //pour l'input qui a le name="ein", on ajoute un mask 
    $('input[name="ein"]').mask('00-0000000');

    $('.menu-title-universe').on('click', function(e) {
        e.preventDefault();

        if($(this).hasClass('active')){
            //go to the href
            window.location.href = $(this).attr('href');
            return;
        }

        $('.mobile-menu .menu-title-universe').removeClass('active');
        $(this).addClass('active');
        var universe = $(this).data('universe');

        // $('.mobile-menu .menu-title-universe-section').removeClass('selected');
        // $('.mobile-menu .menu-title-universe-section[data-universe="'+universe+'"]').addClass('selected');

        if(universe == "MEN"){
            $('.mobile-menu .menu-title-universe-section').animate({
                opacity: 0,         // Réduction de l'opacité
                // left: "-50px"  // Déplacement vers la droite
            }, 250, function() {
                $('.mobile-menu .menu-title-universe-section').removeClass('selected');
                $('.mobile-menu .menu-title-universe-section[data-universe="'+universe+'"]').addClass('selected');
                $('.mobile-menu .menu-title-universe-section').animate({
                    opacity: 1,         // Réduction de l'opacité
                    // left: "0"  // Déplacement vers la droite
                }, 250);
            });
        }else{
            $('.mobile-menu .menu-title-universe-section').animate({
                opacity: 0,         // Réduction de l'opacité
                // left: "50px"  // Déplacement vers la droite
            }, 250, function() {
                $('.mobile-menu .menu-title-universe-section').removeClass('selected');
                $('.mobile-menu .menu-title-universe-section[data-universe="'+universe+'"]').addClass('selected');
                $('.mobile-menu .menu-title-universe-section').animate({
                    opacity: 1,         // Réduction de l'opacité
                    // left: "0"  // Déplacement vers la droite
                }, 250);
            });
        }

        // $('.mobile-menu .menu-title-universe-section')
        // .css({ // Remet ces éléments visibles avant animation
        //     'opacity': '0', // Assure que l'animation commence bien
        //     'left': '-5%' // Position initiale pour l'animation
        // })
        // .each(function(index) {
        //     $(this).delay(index * 25).animate({
        //         'left': '0%',
        //         'opacity': '1'
        //     }, 250); // Animation fluide
        // });
    });

    // Animation page about us new, pour faire grandir l'image
    if($('.about_us2_page_hero_mask').length > 0){
        const masks = document.querySelectorAll('.about_us2_page_hero_mask');
        const trigger = document.querySelector('.about_us2_page_hero_mask_trigger');

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    // Ajoute la classe à tous les éléments de la liste
                    masks.forEach(mask => mask.classList.add('animate'));
                } else {
                    // Supprime la classe de tous les éléments si besoin
                    // masks.forEach(mask => mask.classList.remove('animate'));
                }
            });
        });

        // Observe uniquement l'élément "trigger"
        observer.observe(trigger);
    }

    const scrollableSections = document.querySelectorAll('.moodboard_products');

    scrollableSections.forEach(scrollableSection => {
        scrollableSection.addEventListener('scroll', () => {
            const { scrollTop, scrollHeight, clientHeight } = scrollableSection;

            // Si l'utilisateur atteint le bas de la section, retire le fade
            if (scrollTop + clientHeight >= scrollHeight) {
                scrollableSection.classList.add('no-fade');
            } else {
                scrollableSection.classList.remove('no-fade');
            }
        });
    });

    $('#accordion_details').click(function() {
        sendEventLogger('product_details_open');
    });
    $('#accordion_size_fit').click(function() {
        sendEventLogger('size_fit_open');
    });
    $('#accordion_delivery_returns').click(function() {
        sendEventLogger('delivery_returns_open');
    });

    $('.openBrevoChat').click(function() {
        sendEventLogger('live_chat_open');
    });

    //make window listener for all data-call="carousel-product" 
    $(document).on('click', '[data-call="carousel-product"] swiper-slide', function(e) {

        var placement = $(this).closest('swiper-container').attr('data-placement');
        var destProductId = $(this).attr('data-id');
        var slidePosition = $(this).index();

        if(!placement || placement == ""){
            return;
        }
        if(!destProductId || destProductId == ""){
            return;
        }else{
            destProductId = parseInt(destProductId);
        }
        if(!slidePosition || slidePosition == ""){
            return;
        } 
       
        sendEventLogger('product_carousel_click', {dest_product_id: destProductId, position: slidePosition, placement: placement});

    });


    //Call carousel produit
    $('[data-call="carousel-product"]').each(function() {
        var _this = $(this);
        var listProducts = $(this).attr('data-list');
        var variation = $(this).attr('data-variation');
        var acl = $(this).attr('data-acl');
        var key = $(this).attr('data-key');
        var market = $(this).attr('data-market');
        var location = $(this).attr('data-location');

        if(!acl){
            acl = 0;
        }
        if(!variation){
            variation = "product_slide";
        }   
        
        const requestBodyData = {
            list: listProducts, 
            variation: variation, 
            acl: acl,
            key: key,
            location: location
        };
    
        //make ajax call to get the products
        var currentUrl = window.location.href;
        var urlObject = new URL(currentUrl);
        var baseUrl = urlObject.origin;

        $.ajax({
            url: baseUrl + market + '/carousel-products',
            type: 'POST',
            data: requestBodyData,
            success: function(data, status, xhr) {
                if (xhr.status === 201) {
                    _this.find('swiper-container').html(data);
                } else {
                    console.log(data);
                }
            },
            error: function(xhr, status, error) {
                console.log('AJAX error: ' + error);
            }
        });
    });

    function nudgeSwiper(swiper) {
        if (swiper.slides.length > 1) {
            const currentTranslate = swiper.getTranslate();
            const slideWidth = swiper.slides[0].offsetWidth;
            const nudgeDistance = slideWidth / 2;
    
            // Avance légèrement
            swiper.setTransition(300);
            swiper.setTranslate(currentTranslate - nudgeDistance);
    
            // Attendre un peu, puis revenir à la position d’origine
            setTimeout(() => {
                swiper.setTransition(300);
                swiper.setTranslate(currentTranslate);
            }, 600);
        }
    }

    document.querySelectorAll('.plp-product-swiper:not([data-swiper-initialized])').forEach(initSwiperContainer);

    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
                if (node.nodeType === 1 && node.matches('.plp-product-swiper:not([data-swiper-initialized])')) {
                    initSwiperContainer(node);
                }
    
                // Si le node contient d'autres .plp-product-swiper plus profonds
                if (node.nodeType === 1) {
                    const innerSwipers = node.querySelectorAll('.plp-product-swiper:not([data-swiper-initialized])');
                    innerSwipers.forEach(initSwiperContainer);
                }
            });
        });
    });

    function initSwiperContainer(swiperElProductTile) {
        console.log('Initializing swiper for:', swiperElProductTile);
        swiperElProductTile.setAttribute('data-swiper-initialized', 'true');
        swiperElProductTile.classList.add('swiper-placeholder-height');
    
        const images = swiperElProductTile.querySelectorAll('img');
        let loadedCount = 0;
    
        function tryInitSwiper() {
            const paramsProductTile = {
                injectStyles: [`
                    .swiper-scrollbar.swiper-scrollbar-horizontal {
                        position: absolute;
                        left: 0;
                        bottom: 1px;
                        width: 100%;
                        height: 2px;
                    }
                `],
                pagination: false,
                scrollbar: true,
                slidesPerView: 1,
                spaceBetween: 0,
                slidesPerGroup: 1,
                direction: 'horizontal',
                draggable: true,
                autoHeight: true,
                nested: true, // Ajoute cette ligne
                touchStartPreventDefault: false,
                touchMoveStopPropagation: true,
                observer: true,
                observeParents: true,
                breakpoints: {
                    768: {
                        slidesPerView: 1,
                        slidesPerGroup: 1,
                    },
                },
            };
    
            Object.assign(swiperElProductTile, paramsProductTile);
            swiperElProductTile.initialize();
    
            // Effet de nudge uniquement sur le premier swiper visible, à adapter si besoin
            if (!document.querySelector('[data-nudge-done]')) {
                swiperElProductTile.setAttribute('data-nudge-done', 'true');
                setTimeout(() => {
                    if (swiperElProductTile.swiper) {
                        nudgeSwiper(swiperElProductTile.swiper);
                    }
                }, 500);
            }
    
            swiperElProductTile.classList.remove('swiper-placeholder-height');
        }
    
        if (images.length === 0) {
            tryInitSwiper();
            return;
        }
    
        images.forEach((img) => {
            if (img.complete) {
                loadedCount++;
            } else {
                img.addEventListener('load', () => {
                    loadedCount++;
                    if (loadedCount === images.length) {
                        tryInitSwiper();
                    }
                });
            }
        });
    
        if (loadedCount === images.length) {
            tryInitSwiper();
        }
    }
    
    // Observe le body entier (ajuste si nécessaire)
    observer.observe(document.body, { childList: true, subtree: true });


    $(document).on('click', '.checkout-container-left-confirmation-survey-option', function(e) {
        e.preventDefault();
        $('.checkout-container-left-confirmation-survey-option').removeClass('active');
        $(this).addClass('active');
        $('.checkout-container-left-confirmation-survey-btns input').removeAttr('disabled');
    });
    $(document).on('click', '.checkout-container-left-confirmation-survey-btns #survey-submit', function(e) {
        e.preventDefault();
        var answer = $('.checkout-container-left-confirmation-survey-option.active').data('survey');
        var open = $('.checkout-container-left-confirmation-survey-details input[name="survey_extra_details"]').val();

        var currentUrl = window.location.href;
        var urlObject = new URL(currentUrl);
        var baseUrl = urlObject.origin;

        $.ajax({
            url: baseUrl + $(this).attr('data-action'),
            type: 'POST',
            data: {buykey: $('input[name="buykey"]').val(), answer: answer, open: open},
            success: function(data, status, xhr) {
                $('.checkout-container-left-confirmation-survey .hide-after-submit').fadeOut(function() {
                    $('.checkout-container-left-confirmation-survey-thanks').fadeIn();
                });
            },
            error: function(xhr, status, error) {
                console.log('AJAX error: ' + error);
            }
        });
    });

    function updateCountdown() {
        try {
            // Modern approach using Intl.DateTimeFormat API
            updateCountdownUsingIntl();
        } catch (e) {
            // Fallback to a more compatible approach
            updateCountdownFallback();
        }
    }

    function updateCountdownUsingIntl() {
        const now = new Date();
        
        const pacificOptions = {
            timeZone: 'America/Los_Angeles',
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric',
            hour12: false
        };
        
        const pacificTimeStr = new Intl.DateTimeFormat('en-US', pacificOptions).format(now);
        
        const pacificNow = new Date(pacificTimeStr.replace(',', ''));
        
        const midnightPacific = new Date(pacificNow);
        midnightPacific.setHours(24, 0, 0, 0);
        
        const diff = midnightPacific - pacificNow;
        
        displayCountdown(diff);
    }

    function updateCountdownFallback() {
        const now = new Date();
        
        const utcNow = new Date(
            now.getUTCFullYear(),
            now.getUTCMonth(),
            now.getUTCDate(),
            now.getUTCHours(),
            now.getUTCMinutes(),
            now.getUTCSeconds()
        );
        
        // Determine if Pacific Time is currently in Daylight Saving Time (PDT)
        // This is a simplified approach - DST in US Pacific Time typically:
        // Starts: Second Sunday in March
        // Ends: First Sunday in November
        const year = utcNow.getUTCFullYear();
        
        // Find second Sunday in March
        const marchStart = new Date(Date.UTC(year, 2, 8)); // March 8th
        const daysUntilSecondSunday = (7 - marchStart.getUTCDay()) % 7;
        const dstStart = new Date(Date.UTC(year, 2, 8 + daysUntilSecondSunday, 2)); // 2 AM
        
        // Find first Sunday in November
        const novStart = new Date(Date.UTC(year, 10, 1)); // November 1st
        const daysUntilFirstSunday = (7 - novStart.getUTCDay()) % 7;
        const dstEnd = new Date(Date.UTC(year, 10, 1 + daysUntilFirstSunday, 2)); // 2 AM
        
        // Determine if current UTC time is within DST period
        const isDST = utcNow >= dstStart && utcNow < dstEnd;
        
        // Apply Pacific Time offset (PDT is UTC-7, PST is UTC-8)
        const pacificOffset = isDST ? -7 : -8;
        const pacificNow = new Date(utcNow);
        pacificNow.setUTCHours(utcNow.getUTCHours() + pacificOffset);
        
        const midnightPacific = new Date(pacificNow);
        midnightPacific.setHours(24, 0, 0, 0);
        
        const diff = midnightPacific - pacificNow;
        
        displayCountdown(diff);
    }

    function displayCountdown(diff) {
        // If midnight has passed, clear the countdown
        if (diff <= 0) {
            $('#countdown_delivery_midnight').text("");
            return;
        }

        // Calculate hours, minutes, seconds
        const totalSeconds = Math.floor(diff / 1000);
        let hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        // const seconds = totalSeconds % 60;

        let oDict = JSON.parse(document.querySelector('[dict-json]').innerHTML);
        let hourLabel = hours === 1 ? oDict['g_hour_short'] || "hr" : oDict['g_hours_short'] || "hrs";
        const minuteLabel = minutes === 1 ? oDict['g_minute_short'] || "min" : oDict['g_minutes_short'] || "mins";

        if ( hours === 0 ) {
            hourLabel=""
            hours=""
        }

        // Update the countdown display
        $('#countdown_delivery_midnight').html(
            `(${oDict['order_within']} <span style="color: #B5351D; font-weight: 700;">${hours} ${hourLabel} ${minutes} ${minuteLabel}</span>)`
        );
    }

    updateCountdown();
    setInterval(updateCountdown, 1000);


    if($('#checkout_product_data_update_popin-modal').length > 0){
        $.magnificPopup.open({
            items: {
                src: '#checkout_product_data_update_popin-modal'
            },
            type: 'inline',
            closeOnBgClick: false,
        });

        // Prevent closing when clicking on <a> inside the modal
        $('#checkout_product_data_update_popin-modal a').on('click', function(e) {
            //close popin
            $.magnificPopup.close();
        });
    }

    function getPaymentExpressSupportInfo() {
        //if we are on mac/safari or ios, we display Apple Pay in the text of the button
        var isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
        var isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
        var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

        if ( (isMac && isSafari) || isIOS ) {
            return 'apple_pay';
        } else {
            return 'google_pay';
        }
    }

    if($('.checkout-container-left-express[data-provider="adyen"]').length > 0){
        var payment_express_support = getPaymentExpressSupportInfo();
        console.log('flag1')
        if($('.adyen-express-payments').find('div').length >= 1){
            // console.log('flag2')
            // if(payment_express_support == 'google_pay' && $('#googlepay-container').length == 0){
            //     console.log('flag3')
            //     if( $('#applepay-container').length > 0 ||  $('#googlepay-container').length > 0){
            //         console.log('flag4')
            //         //$('.checkout-container-left-express').replaceWith('<div class="checkout-container-left-contact-margin"></div>');
            //     }
            // }else if(payment_express_support == 'apple_pay' && $('#applepay-container').length == 0){
            //     console.log('flag5')
            //     if( $('#applepay-container').length > 0 ||  $('#googlepay-container').length > 0){
            //         console.log('flag6')
            //         //$('.checkout-container-left-express').replaceWith('<div class="checkout-container-left-contact-margin"></div>');
            //     }
            // }

            // function isEmptyOrMissing(selector) {
            //     return $(selector).length === 0 || $(selector).is(':empty');
            // }

            if((($('#applepay-container').length == 0 && payment_express_support == 'apple_pay') || ($('#googlepay-container').length == 0 && payment_express_support == 'google_pay')) && $('#paypal-container').length == 0){
                console.log('flag8')
                $('.checkout-container-left-express').replaceWith('<div class="checkout-container-left-contact-margin"></div>');
            }
        }else if($('.adyen-express-payments').find('div').length == 0){
            console.log('flag7')
            $('.checkout-container-left-express').replaceWith('<div class="checkout-container-left-contact-margin"></div>');
        }
    }


    if($('.product-express-btn').length > 0){
        var payment_express_support = getPaymentExpressSupportInfo();
        var expressBtn = document.querySelector('.product-express-btn');
        console.log('Flag0');

        if( !expressBtn.querySelector('img[data-payment="'+payment_express_support+'"]')){
            $('.product-express-btn').hide();
            console.log('Flag1');
            return;
        }
        expressBtn.querySelector('img[data-payment="'+payment_express_support+'"]').style.display = 'block';
        expressBtn.setAttribute('data-payment-method', payment_express_support);

        console.log('Flag2');

        if( payment_express_support == 'apple_pay' ) {
            console.log('Flag3');
            reloadAdyenExpressSession('apple_pay', $('.product-express-btn').attr('data-sku'));
            setTimeout(() => {
                $('.product-express-btn').click();
                console.log('AUTO CLICK APPLE PAY')
            }, 500);
        }else if( payment_express_support == 'google_pay' ) {
            console.log('Flag4');
            if($('.product-express-btn').attr('data-display') == 1){
                $('.product-express-btn').hide();
                $('#container-googlepay-btn').show();
                console.log('Flag5');

            }
        }
    }

    $('.product-size__choices__item').on('click', function(e) {
        e.preventDefault();
        console.log('size clicked so we reload the session')
        var payment_express_support = getPaymentExpressSupportInfo();
        if( payment_express_support == 'apple_pay' ) {
            window.removeApplePayClickListener();
            reloadAdyenExpressSession($('.product-express-btn').attr('data-payment-method'), $('.product-express-btn').attr('data-sku'));
            numberApplePayLoad = 0;
        }
    });

    function reloadAdyenExpressSession(paymentMethod, sku){
        console.log('Express checkout with ' + paymentMethod);

        var url = new URL(window.location.href);
        var sgz = url.pathname.split('/')[1];
        var lang = url.pathname.split('/')[2];

        //if we have /checkout/ in the current url express_location = 'checkout', else 'product'
        var express_location = 'product';
        if(url.pathname.indexOf('/checkout/') !== -1){
            express_location = 'checkout';
        }

        // 1. create order ref
        fetch('/' + sgz + '/' + lang + '/order/express-create', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                'sku': sku,
                'size': $('.product-size__choices__item.active').attr('data-size'),
                'express_location': express_location,
            })
        })
        .then(response => response.json())
        .then(data => {
            // 2. create Adyen session
            fetch('/' + sgz + '/' + lang + '/adyen/get_new_session', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ sgz: sgz, buykey: data.key, is_json: true, is_only_express: true }),
            })
            .then(response2 => {
                if (response2.ok) {
                    return response2.json();
                } else {
                    throw new Error('Failed to create Adyen session');
                }
            })
            .then(data => {
                $('.initiate_adyen_checkout').html(data.results);
                initCheckout(false);
                console.log('INIT CHECKOUT JS')
                addHotjarLog(`Nouvelle session récupérée`);
                setTimeout(() => {
                    // $('#gpay-button-online-api-id').click()
                    // adyen-checkout__applepay__button
                    var paymentExpressSupport = getPaymentExpressSupportInfo();
                    if( paymentExpressSupport == 'apple_pay' ) {
                        // $('#applepay-container button').click();
                    } else if( paymentExpressSupport == 'google_pay' ) {
                        $('#googlepay-container button').click();
                    }
                }, 500);
            })
            .catch(error => {
                console.error(error);
            });
        });
    }

    var numberApplePayLoad = 0;
    $('.product-express-btn, #container-googlepay-btn').on('click', function(e) {
        e.preventDefault();
        if( $(this).attr('data-payment-method') == 'apple_pay' && numberApplePayLoad > 1 ) {
            console.log('SKIPPED APPLE PAY CLICK');
            return;
        }else if( $(this).attr('data-payment-method') == 'google_pay' ) {
            reloadAdyenExpressSession("google_pay", $(this).attr('data-sku'));
        }
        numberApplePayLoad++;
    });

    // si on récup l'event event_apple_pay_error
    $(window).on("event_apple_pay_error", function (event, message) {
        console.log('event_apple_pay_error', message);
        // numberApplePayLoad = 0;
        window.removeApplePayClickListener();
        reloadAdyenExpressSession("apple_pay", $('.product-express-btn').attr('data-sku'));
    });

    $('#use_fashion_square_credit').on('change', function() {
        if($(this).is(':checked')){
            //remove param skip_credit from url
            var currentUrl = window.location.href;
            var urlObject = new URL(currentUrl);
            urlObject.searchParams.delete('skip_credit');
            window.history.pushState({}, '', urlObject.toString());
            //refresh the page
            window.location.reload();
        }else{
            //add param skip_credit=1 to url
            var currentUrl = window.location.href;
            var urlObject = new URL(currentUrl);
            urlObject.searchParams.set('skip_credit', '1');
            window.history.pushState({}, '', urlObject.toString());
            //refresh the page
            window.location.reload();
        }
    });

    $('#add_giftwrap').on('change', function() {
        if($(this).is(':checked')){
            // add param add_giftwrap=1 to url
            var currentUrl = window.location.href;
            var urlObject = new URL(currentUrl);
            urlObject.searchParams.set('add_giftwrap', '1');
            window.history.pushState({}, '', urlObject.toString());
            // refresh the page
            window.location.reload();
        }else{
            // set param add_giftwrap=0 to url
            var currentUrl = window.location.href;
            var urlObject = new URL(currentUrl);
            urlObject.searchParams.set('add_giftwrap', '0');
            window.history.pushState({}, '', urlObject.toString());
            // refresh the page
            window.location.reload();
        }
    });

    $('#giftwrap_message').on('blur', function() {
        var message = $(this).val();
        var buykey = $('input[name="buykey"]').val();
        console.log('Giftwrap message:', message);
        //call ajax to save the message
        var currentUrl = window.location.href;
        var urlObject = new URL(currentUrl);
        var baseUrl = urlObject.origin;
        // get sgz and lang
        var pathSegments = urlObject.pathname.split('/');
        var sgz = pathSegments[1];
        var lang = pathSegments[2];
        $.ajax({
            url: baseUrl + '/' + sgz + '/' + lang + '/order/save-giftwrap-message',
            type: 'POST',
            contentType: 'application/json; charset=utf-8', // important
            dataType: 'json',                               // si tu attends du JSON en retour
            data: JSON.stringify({
                message: message,
                buykey: buykey
            }),
            success: function(data, status, xhr) {
                console.log('Giftwrap message saved', data);
            }
        });
    });

    // if there is .mobile-bf-banner element and user scrolls down, hide the banner
    if($('.mobile-bf-banner').length > 0){
        $(window).on('scroll', function() {
            if($(window).scrollTop() > 300) {
                $('.mobile-bf-banner').fadeOut();
            } else {
                $('.mobile-bf-banner').fadeIn();
            }
        });
    }

})(jQuery);

$('.collections-results-item-content img').each(function() {
    var height = $('.collections-results-item-product img').height();
    $(this).css('height', height);
});

function clickMailtoEmail(){
    var user = 'he' + 'll' + 'o';
    var domain = 'the-fash' + 'ion-square' + '.co' + 'm';
    var email = user + '@' + domain;

    window.location.href = 'mailto:' + email;
}

function clickMailtoEmailReturns(){
    var user = 're' + 'tur' + 'ns';
    var domain = 'the-fash' + 'ion-square' + '.co' + 'm';
    var email = user + '@' + domain;

    window.location.href = 'mailto:' + email;
}
